var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 107,
    viewBox: "0 0 102 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7057 102.192L57.3301 82.3488C57.887 82.0012 58.1654 81.5351 58.1729 81.0444C58.1729 81.0281 58.1729 79.3557 58.1729 79.3434C58.1617 78.7505 57.7591 79.7809 56.9802 79.2903L39.0327 68.0293C37.5917 67.1256 35.4094 67.0275 34.1602 67.8085L2.5358 87.6562C2.11816 87.9179 1.81715 86.8057 1.70804 87.1615C1.67041 87.2801 1.69675 88.838 1.69298 88.9606C1.6817 89.5699 2.08429 90.2159 2.88572 90.7148L20.8332 101.976C22.2743 102.879 24.4565 102.978 25.7057 102.197V102.192Z",
    fill: "url(#paint0_linear_2_901)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7081 100.52L57.3325 80.6767C58.5817 79.8916 58.4236 78.5259 56.9826 77.6181L39.0351 66.3572C37.5941 65.4535 35.4118 65.3554 34.1626 66.1364L2.53817 85.9841C1.289 86.7692 1.44702 88.1349 2.88809 89.0427L20.8356 100.304C22.2766 101.207 24.4589 101.305 25.7081 100.524V100.52Z",
    fill: "url(#paint1_linear_2_901)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5942 100.365C24.3053 100.365 24.9449 100.209 25.3927 99.927L57.0171 80.0833C57.2128 79.9607 57.5439 79.699 57.5439 79.3514C57.5439 79.0039 57.2165 78.5623 56.6672 78.2147L38.7197 66.9537C38.0537 66.5367 37.1658 66.2954 36.2778 66.2954C35.5667 66.2954 34.927 66.4508 34.4793 66.7329L2.85489 86.5766C2.65923 86.6993 2.32812 86.961 2.32812 87.3085C2.32812 87.6561 2.65547 88.0977 3.2048 88.4452L21.1523 99.7062C21.8182 100.123 22.7062 100.365 23.5942 100.365Z",
    fill: "url(#paint2_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M2.89116 88.7562L20.8386 100.017C22.2797 100.921 24.462 101.019 25.7112 100.238L57.3356 80.3943C57.8548 80.0713 58.1257 79.6419 58.1709 79.1921C58.2348 79.7482 57.9639 80.288 57.3356 80.6805L25.7112 100.524C24.462 101.309 22.2797 101.211 20.8386 100.303L2.89116 89.0424C2.04834 88.5149 1.64575 87.8239 1.70971 87.1901C1.77367 87.7421 2.17251 88.3105 2.89116 88.7603V88.7562Z",
    fill: "url(#paint3_radial_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M32.2716 70.7078C31.4326 73.3533 34.0965 76.7471 38.2203 78.2887C42.344 79.8302 46.3625 78.9347 47.2015 76.2892C48.0406 73.6436 45.3767 70.2498 41.2529 68.7083C37.1291 67.1667 33.1107 68.0622 32.2716 70.7078Z",
    fill: "url(#paint4_radial_2_901)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0778 93.2132L45.7573 77.1027C46.2728 76.7797 46.2088 76.2154 45.6143 75.8433L35.9746 69.7957C35.3801 69.4237 34.4809 69.3828 33.9692 69.7058L8.28586 85.8122C7.77039 86.1352 7.83435 86.6995 8.42884 87.0716L18.0685 93.1191C18.663 93.4912 19.5623 93.5321 20.074 93.2091L20.0778 93.2132Z",
    fill: "url(#paint5_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M35.4279 70.4949C35.221 70.364 34.8823 70.364 34.6716 70.4949L33.0274 71.5294C32.8167 71.6602 32.8167 71.8728 33.0274 72.0037C33.2343 72.1345 33.573 72.1345 33.7837 72.0037L35.4279 70.9692C35.6386 70.8383 35.6386 70.6257 35.4279 70.4949ZM32.6097 72.2613C32.4028 72.1304 32.0642 72.1304 31.8535 72.2613L31.0746 72.752C30.8639 72.8828 30.8639 73.0954 31.0746 73.2263C31.2815 73.3571 31.6202 73.3571 31.8309 73.2263L32.6097 72.7356C32.8204 72.6048 32.8204 72.3921 32.6097 72.2613ZM30.657 73.4839C30.45 73.353 30.1114 73.353 29.9007 73.4839L29.1218 73.9746C28.9111 74.1054 28.9111 74.318 29.1218 74.4489C29.3288 74.5797 29.6674 74.5797 29.8781 74.4489L30.657 73.9582C30.8677 73.8274 30.8677 73.6147 30.657 73.4839ZM28.7042 74.7065C28.4972 74.5756 28.1586 74.5756 27.9479 74.7065L27.1691 75.1972C26.9584 75.328 26.9584 75.5406 27.1691 75.6715C27.376 75.8023 27.7146 75.8023 27.9253 75.6715L28.7042 75.1808C28.9149 75.0499 28.9149 74.8373 28.7042 74.7065ZM26.7514 75.9291C26.5445 75.7982 26.2058 75.7982 25.9951 75.9291L25.2163 76.4197C25.0056 76.5506 25.0056 76.7632 25.2163 76.8941C25.4232 77.0249 25.7619 77.0249 25.9726 76.8941L26.7514 76.4034C26.9621 76.2725 26.9621 76.0599 26.7514 75.9291ZM24.7986 77.1517C24.5917 77.0208 24.2531 77.0208 24.0424 77.1517L23.2635 77.6423C23.0528 77.7732 23.0528 77.9858 23.2635 78.1167C23.4705 78.2475 23.8091 78.2475 24.0198 78.1167L24.7986 77.626C25.0093 77.4951 25.0093 77.2825 24.7986 77.1517ZM22.8459 78.3743C22.6389 78.2434 22.3003 78.2434 22.0896 78.3743L21.3107 78.8649C21.1 78.9958 21.1 79.2084 21.3107 79.3393C21.5177 79.4701 21.8563 79.4701 22.067 79.3393L22.8459 78.8486C23.0566 78.7177 23.0566 78.5051 22.8459 78.3743ZM20.8931 79.5969C20.6862 79.466 20.3475 79.466 20.1368 79.5969L19.358 80.0875C19.1473 80.2184 19.1473 80.431 19.358 80.5619C19.5649 80.6927 19.9035 80.6927 20.1142 80.5619L20.8931 80.0712C21.1038 79.9403 21.1038 79.7277 20.8931 79.5969ZM18.9403 80.8195C18.7334 80.6886 18.3947 80.6886 18.184 80.8195L17.4052 81.3101C17.1945 81.441 17.1945 81.6536 17.4052 81.7844C17.6121 81.9153 17.9508 81.9153 18.1615 81.7844L18.9403 81.2938C19.151 81.1629 19.151 80.9503 18.9403 80.8195ZM16.9875 82.042C16.7806 81.9112 16.442 81.9112 16.2313 82.042L15.4524 82.5327C15.2417 82.6636 15.2417 82.8762 15.4524 83.007C15.6594 83.1379 15.998 83.1379 16.2087 83.007L16.9875 82.5164C17.1982 82.3855 17.1982 82.1729 16.9875 82.042ZM15.0348 83.2646C14.8278 83.1338 14.4892 83.1338 14.2785 83.2646L13.4996 83.7553C13.2889 83.8862 13.2889 84.0988 13.4996 84.2296C13.7066 84.3605 14.0452 84.3605 14.2559 84.2296L15.0348 83.739C15.2455 83.6081 15.2455 83.3955 15.0348 83.2646ZM13.082 84.4872C12.8751 84.3564 12.5364 84.3564 12.3257 84.4872L11.5469 84.9779C11.3362 85.1088 11.3362 85.3214 11.5469 85.4522C11.7538 85.5831 12.0924 85.5831 12.3031 85.4522L13.082 84.9616C13.2927 84.8307 13.2927 84.6181 13.082 84.4872ZM11.0916 85.7385C10.8847 85.6076 10.546 85.6076 10.3353 85.7385L9.55647 86.2291C9.34576 86.36 9.34576 86.5726 9.55647 86.7035C9.76341 86.8343 10.102 86.8343 10.3127 86.7035L11.0916 86.2128C11.3023 86.0819 11.3023 85.8693 11.0916 85.7385ZM37.17 71.5784L36.5002 71.1573C36.2632 71.0101 35.8794 71.0101 35.6386 71.1573L34.9651 71.5825C34.7281 71.7338 34.7243 71.9751 34.9651 72.1223L35.6348 72.5434C35.8719 72.6906 36.2557 72.6906 36.4965 72.5434L37.17 72.1182C37.407 71.9669 37.4108 71.7256 37.17 71.5784ZM34.5399 73.766L35.2134 73.3408C35.4505 73.1895 35.4542 72.9482 35.2134 72.801L34.5437 72.3799C34.3067 72.2327 33.9229 72.2327 33.6821 72.3799L33.0086 72.8051C32.7715 72.9564 32.7678 73.1977 33.0086 73.3449L33.6783 73.766C33.9153 73.9132 34.2991 73.9132 34.5399 73.766ZM33.2644 74.0277L32.5947 73.6066C32.3576 73.4594 31.9739 73.4594 31.7331 73.6066L31.0596 74.0318C30.8225 74.1831 30.8188 74.4243 31.0596 74.5715L31.7293 74.9927C31.9663 75.1399 32.3501 75.1399 32.5909 74.9927L33.2644 74.5675C33.5015 74.4162 33.5052 74.1749 33.2644 74.0277ZM31.3117 75.2503L30.6419 74.8291C30.4049 74.6819 30.0211 74.6819 29.7803 74.8291L29.1068 75.2544C28.8697 75.4057 28.866 75.6469 29.1068 75.7941L29.7765 76.2153C30.0136 76.3625 30.3973 76.3625 30.6382 76.2153L31.3117 75.79C31.5487 75.6388 31.5525 75.3975 31.3117 75.2503ZM27.154 77.0167L27.8237 77.4379C28.0608 77.5851 28.4446 77.5851 28.6854 77.4379L29.3589 77.0126C29.5959 76.8614 29.5997 76.6201 29.3589 76.4729L28.6891 76.0517C28.4521 75.9045 28.0683 75.9045 27.8275 76.0517L27.154 76.477C26.917 76.6283 26.9132 76.8695 27.154 77.0167ZM25.2012 78.2393L25.871 78.6605C26.108 78.8077 26.4918 78.8077 26.7326 78.6605L27.4061 78.2352C27.6431 78.0839 27.6469 77.8427 27.4061 77.6955L26.7364 77.2743C26.4993 77.1271 26.1155 77.1271 25.8747 77.2743L25.2012 77.6996C24.9642 77.8509 24.9604 78.0921 25.2012 78.2393ZM23.2485 79.4619L23.9182 79.8831C24.1552 80.0303 24.539 80.0303 24.7798 79.8831L25.4533 79.4578C25.6904 79.3065 25.6941 79.0653 25.4533 78.9181L24.7836 78.4969C24.5465 78.3497 24.1628 78.3497 23.922 78.4969L23.2485 78.9222C23.0114 79.0735 23.0077 79.3147 23.2485 79.4619ZM21.2957 80.6845L21.9654 81.1057C22.2025 81.2529 22.5862 81.2529 22.8271 81.1057L23.5006 80.6804C23.7376 80.5291 23.7414 80.2879 23.5006 80.1407L22.8308 79.7195C22.5938 79.5723 22.21 79.5723 21.9692 79.7195L21.2957 80.1448C21.0586 80.2961 21.0549 80.5373 21.2957 80.6845ZM19.3429 81.9071L20.0127 82.3283C20.2497 82.4755 20.6335 82.4755 20.8743 82.3283L21.5478 81.903C21.7848 81.7517 21.7886 81.5105 21.5478 81.3633L20.878 80.9421C20.641 80.7949 20.2572 80.7949 20.0164 80.9421L19.3429 81.3674C19.1059 81.5187 19.1021 81.7599 19.3429 81.9071ZM17.3901 83.1297L18.0599 83.5509C18.2969 83.6981 18.6807 83.6981 18.9215 83.5509L19.595 83.1256C19.832 82.9743 19.8358 82.7331 19.595 82.5859L18.9253 82.1647C18.6882 82.0175 18.3044 82.0175 18.0636 82.1647L17.3901 82.59C17.1531 82.7413 17.1493 82.9825 17.3901 83.1297ZM17.646 83.8085L16.9763 83.3873C16.7392 83.2401 16.3554 83.2401 16.1146 83.3873L15.4411 83.8126C15.2041 83.9639 15.2003 84.2051 15.4411 84.3523L16.1109 84.7735C16.3479 84.9207 16.7317 84.9207 16.9725 84.7735L17.646 84.3482C17.883 84.1969 17.8868 83.9557 17.646 83.8085ZM13.4884 85.5749L14.1581 85.9961C14.3951 86.1433 14.7789 86.1433 15.0197 85.9961L15.6932 85.5708C15.9303 85.4195 15.934 85.1783 15.6932 85.0311L15.0235 84.6099C14.7864 84.4627 14.4027 84.4627 14.1619 84.6099L13.4884 85.0352C13.2513 85.1865 13.2475 85.4277 13.4884 85.5749ZM10.6288 87.3699L11.2985 87.7911C11.5356 87.9383 11.9194 87.9383 12.1602 87.7911L13.7028 86.8261C13.9399 86.6748 13.9436 86.4336 13.7028 86.2864L13.0331 85.8652C12.796 85.718 12.4123 85.718 12.1715 85.8652L10.6288 86.8302C10.3918 86.9815 10.388 87.2227 10.6288 87.3699ZM38.9685 72.6988L38.2987 72.2776C38.0617 72.1304 37.6779 72.1304 37.4371 72.2776L35.8945 73.2426C35.6574 73.3939 35.6537 73.6352 35.8945 73.7824L36.5642 74.2035C36.8012 74.3507 37.185 74.3507 37.4258 74.2035L38.9685 73.2385C39.2055 73.0873 39.2093 72.846 38.9685 72.6988ZM36.1503 74.4652L35.4806 74.0441C35.2435 73.8969 34.8598 73.8969 34.6189 74.0441L33.9455 74.4693C33.7084 74.6206 33.7046 74.8619 33.9455 75.0091L34.6152 75.4302C34.8522 75.5774 35.236 75.5774 35.4768 75.4302L36.1503 75.005C36.3874 74.8537 36.3911 74.6124 36.1503 74.4652ZM34.1975 76.2276C34.4346 76.0763 34.4383 75.835 34.1975 75.6878L33.5278 75.2667C33.2908 75.1195 32.907 75.1195 32.6662 75.2667L31.9927 75.6919C31.7556 75.8432 31.7519 76.0845 31.9927 76.2317L32.6624 76.6528C32.8995 76.8 33.2832 76.8 33.524 76.6528L34.1975 76.2276ZM32.2448 77.4502C32.4818 77.2989 32.4856 77.0576 32.2448 76.9104L31.575 76.4893C31.338 76.3421 30.9542 76.3421 30.7134 76.4893L30.0399 76.9145C29.8029 77.0658 29.7991 77.307 30.0399 77.4542L30.7096 77.8754C30.9467 78.0226 31.3305 78.0226 31.5713 77.8754L32.2448 77.4502ZM28.7644 77.7159L28.0909 78.1412C27.8538 78.2925 27.8501 78.5337 28.0909 78.6809L28.7606 79.1021C28.9977 79.2493 29.3815 79.2493 29.6223 79.1021L30.2958 78.6768C30.5328 78.5256 30.5366 78.2843 30.2958 78.1371L29.626 77.7159C29.389 77.5687 29.0052 77.5687 28.7644 77.7159ZM26.853 78.914L26.0967 79.3883C25.8823 79.5233 25.8823 79.74 26.0967 79.8749L26.8492 80.3492C27.0637 80.4842 27.4099 80.4842 27.6281 80.3492L28.3844 79.8749C28.5988 79.74 28.5988 79.5233 28.3844 79.3883L27.6319 78.914C27.4174 78.7791 27.0712 78.7791 26.853 78.914ZM24.9002 80.1366L24.144 80.6109C23.9295 80.7459 23.9295 80.9626 24.144 81.0975L24.8965 81.5718C25.1109 81.7068 25.4571 81.7068 25.6753 81.5718L26.4316 81.0975C26.6461 80.9626 26.6498 80.7459 26.4316 80.6109L25.6791 80.1366C25.4646 80.0017 25.1185 80.0017 24.9002 80.1366ZM22.9475 81.3592L22.1912 81.8335C21.9767 81.9684 21.9767 82.1852 22.1912 82.3201L22.9437 82.7944C23.1582 82.9294 23.5043 82.9294 23.7225 82.7944L24.4788 82.3201C24.6933 82.1852 24.6933 81.9684 24.4788 81.8335L23.7263 81.3592C23.5118 81.2243 23.1657 81.2243 22.9475 81.3592ZM20.9947 82.5818L20.2384 83.0561C20.0239 83.191 20.0202 83.4078 20.2384 83.5427L20.9909 84.017C21.2054 84.1519 21.5515 84.1519 21.7698 84.017L22.526 83.5427C22.7405 83.4078 22.7443 83.191 22.526 83.0561L21.7735 82.5818C21.5591 82.4469 21.2129 82.4469 20.9947 82.5818ZM19.0419 83.8044L18.2856 84.2787C18.0712 84.4136 18.0712 84.6304 18.2856 84.7653L19.0381 85.2396C19.2526 85.3745 19.5988 85.3745 19.817 85.2396L20.5733 84.7653C20.7877 84.6304 20.7877 84.4136 20.5733 84.2787L19.8208 83.8044C19.6063 83.6695 19.2601 83.6695 19.0419 83.8044ZM17.8605 86.4622L18.6167 85.9879C18.8312 85.853 18.835 85.6362 18.6167 85.5013L17.8642 85.027C17.6498 84.892 17.3036 84.892 17.0854 85.027L16.3291 85.5013C16.1146 85.6362 16.1109 85.853 16.3291 85.9879L17.0816 86.4622C17.2961 86.5971 17.6422 86.5971 17.8605 86.4622ZM15.9077 87.6848L16.664 87.2105C16.8784 87.0755 16.8784 86.8588 16.664 86.7239L15.9114 86.2496C15.697 86.1146 15.3508 86.1146 15.1326 86.2496L14.3763 86.7239C14.1619 86.8588 14.1619 87.0755 14.3763 87.2105L15.1288 87.6848C15.3433 87.8197 15.6895 87.8197 15.9077 87.6848ZM12.3859 88.4617L13.1384 88.936C13.3529 89.071 13.6991 89.071 13.9173 88.936L14.6736 88.4617C14.888 88.3268 14.888 88.1101 14.6736 87.9751L13.921 87.5008C13.7066 87.3659 13.3604 87.3659 13.1422 87.5008L12.3859 87.9751C12.1715 88.1101 12.1715 88.3268 12.3859 88.4617ZM40.8084 73.8437L40.0559 73.3694C39.8414 73.2345 39.4952 73.2345 39.277 73.3694L36.8313 74.9027C36.6169 75.0377 36.6169 75.2544 36.8313 75.3893L37.5839 75.8636C37.7983 75.9986 38.1445 75.9986 38.3627 75.8636L40.8084 74.3303C41.0228 74.1954 41.0228 73.9786 40.8084 73.8437ZM37.1662 76.1294L36.4137 75.6551C36.1992 75.5202 35.8531 75.5202 35.6348 75.6551L34.8786 76.1294C34.6641 76.2644 34.6641 76.4811 34.8786 76.616L35.6311 77.0903C35.8455 77.2253 36.1917 77.2253 36.4099 77.0903L37.1662 76.616C37.3807 76.4811 37.3844 76.2644 37.1662 76.1294ZM35.2134 77.352L34.4609 76.8777C34.2465 76.7428 33.9003 76.7428 33.6821 76.8777L32.9258 77.352C32.7113 77.487 32.7113 77.7037 32.9258 77.8386L33.6783 78.3129C33.8928 78.4479 34.2389 78.4479 34.4572 78.3129L35.2134 77.8386C35.4279 77.7037 35.4279 77.487 35.2134 77.352ZM33.2607 78.5746L32.5081 78.1003C32.2937 77.9654 31.9475 77.9654 31.7293 78.1003L30.973 78.5746C30.7586 78.7096 30.7586 78.9263 30.973 79.0612L31.7255 79.5355C31.94 79.6705 32.2862 79.6705 32.5044 79.5355L33.2607 79.0612C33.4751 78.9263 33.4789 78.7096 33.2607 78.5746ZM30.5478 80.7622L31.3041 80.2879C31.5186 80.153 31.5186 79.9362 31.3041 79.8013L30.5516 79.327C30.3371 79.1921 29.991 79.1921 29.7728 79.327L29.0165 79.8013C28.802 79.9362 28.802 80.153 29.0165 80.2879L29.769 80.7622C29.9835 80.8971 30.3296 80.8971 30.5478 80.7622ZM28.5951 81.9848L29.3513 81.5105C29.5658 81.3756 29.5696 81.1588 29.3513 81.0239L28.5988 80.5496C28.3844 80.4146 28.0382 80.4146 27.82 80.5496L27.0637 81.0239C26.8492 81.1588 26.8492 81.3756 27.0637 81.5105L27.8162 81.9848C28.0307 82.1197 28.3768 82.1197 28.5951 81.9848ZM26.6423 83.2074L27.3986 82.7331C27.613 82.5981 27.613 82.3814 27.3986 82.2465L26.6461 81.7722C26.4316 81.6372 26.0854 81.6372 25.8672 81.7722L25.1109 82.2465C24.8965 82.3814 24.8965 82.5981 25.1109 82.7331L25.8634 83.2074C26.0779 83.3423 26.4241 83.3423 26.6423 83.2074ZM24.6895 84.43L25.4458 83.9557C25.6603 83.8207 25.664 83.604 25.4458 83.4691L24.6933 82.9948C24.4788 82.8598 24.1327 82.8598 23.9144 82.9948L23.1582 83.4691C22.9437 83.604 22.9399 83.8207 23.1582 83.9557L23.9107 84.43C24.1251 84.5649 24.4713 84.5649 24.6895 84.43ZM22.7368 85.6526L23.493 85.1783C23.7075 85.0433 23.7075 84.8266 23.493 84.6917L22.7405 84.2174C22.526 84.0824 22.1799 84.0824 21.9617 84.2174L21.2054 84.6917C20.9909 84.8266 20.9909 85.0433 21.2054 85.1783L21.9579 85.6526C22.1724 85.7875 22.5185 85.7875 22.7368 85.6526ZM20.784 86.8752L21.5403 86.4009C21.7547 86.2659 21.7585 86.0492 21.5403 85.9143L20.7877 85.44C20.5733 85.305 20.2271 85.305 20.0089 85.44L19.2526 85.9143C19.0381 86.0492 19.0344 86.2659 19.2526 86.4009L20.0051 86.8752C20.2196 87.0101 20.5657 87.0101 20.784 86.8752ZM19.5912 87.1369L18.8387 86.6626C18.6243 86.5276 18.2781 86.5276 18.0599 86.6626L17.3036 87.1369C17.0891 87.2718 17.0891 87.4885 17.3036 87.6235L18.0561 88.0978C18.2706 88.2327 18.6167 88.2327 18.835 88.0978L19.5912 87.6235C19.8057 87.4885 19.8057 87.2718 19.5912 87.1369ZM14.1807 89.5862L14.9332 90.0605C15.1476 90.1954 15.4938 90.1954 15.712 90.0605L17.6385 88.8502C17.8529 88.7152 17.8567 88.4985 17.6385 88.3636L16.886 87.8892C16.6715 87.7543 16.3253 87.7543 16.1071 87.8892L14.1807 89.0996C13.9662 89.2345 13.9662 89.4512 14.1807 89.5862ZM42.5956 74.9641L41.9447 74.5552C41.7039 74.4039 41.3088 74.4039 41.068 74.5552L37.5951 76.7346C37.3506 76.8859 37.3506 77.1353 37.5951 77.2866L38.2461 77.6955C38.4869 77.8468 38.8819 77.8468 39.1227 77.6955L42.5956 75.5161C42.8402 75.3648 42.8402 75.1154 42.5956 74.9641ZM37.8284 77.9531L37.1775 77.5442C36.9367 77.3929 36.5416 77.3929 36.3008 77.5442L35.6424 77.9572C35.3978 78.1085 35.3978 78.3579 35.6424 78.5092L36.2933 78.9181C36.5341 79.0694 36.9292 79.0694 37.17 78.9181L37.8284 78.5051C38.073 78.3538 38.073 78.1044 37.8284 77.9531ZM35.8757 79.1757L35.2247 78.7668C34.9839 78.6155 34.5889 78.6155 34.348 78.7668L33.6896 79.1798C33.445 79.3311 33.445 79.5805 33.6896 79.7318L34.3405 80.1407C34.5813 80.292 34.9764 80.292 35.2172 80.1407L35.8757 79.7277C36.1202 79.5764 36.1202 79.327 35.8757 79.1757ZM33.9229 80.3983L33.2719 79.9894C33.0311 79.8381 32.6361 79.8381 32.3953 79.9894L31.7368 80.4024C31.4923 80.5537 31.4923 80.8031 31.7368 80.9544L32.3877 81.3633C32.6285 81.5146 33.0236 81.5146 33.2644 81.3633L33.9229 80.9503C34.1674 80.799 34.1674 80.5496 33.9229 80.3983ZM31.9701 81.6209L31.3192 81.212C31.0784 81.0607 30.6833 81.0607 30.4425 81.212L29.784 81.625C29.5395 81.7763 29.5395 82.0257 29.784 82.177L30.435 82.5859C30.6758 82.7372 31.0708 82.7372 31.3117 82.5859L31.9701 82.1729C32.2147 82.0216 32.2147 81.7722 31.9701 81.6209ZM30.0173 82.8435L29.3664 82.4346C29.1256 82.2833 28.7305 82.2833 28.4897 82.4346L27.8313 82.8476C27.5867 82.9989 27.5867 83.2483 27.8313 83.3996L28.4822 83.8085C28.723 83.9598 29.1181 83.9598 29.3589 83.8085L30.0173 83.3955C30.2619 83.2442 30.2619 82.9948 30.0173 82.8435ZM28.0646 84.0661L27.4136 83.6572C27.1728 83.5059 26.7778 83.5059 26.5369 83.6572L25.8785 84.0702C25.6339 84.2215 25.6339 84.4709 25.8785 84.6222L26.5294 85.0311C26.7702 85.1824 27.1653 85.1824 27.4061 85.0311L28.0646 84.6181C28.3091 84.4668 28.3091 84.2174 28.0646 84.0661ZM26.1118 85.2887L25.4609 84.8798C25.22 84.7285 24.825 84.7285 24.5842 84.8798L23.9257 85.2928C23.6812 85.4441 23.6812 85.6935 23.9257 85.8448L24.5766 86.2537C24.8175 86.405 25.2125 86.405 25.4533 86.2537L26.1118 85.8407C26.3563 85.6894 26.3563 85.44 26.1118 85.2887ZM24.159 86.5113L23.5081 86.1024C23.2673 85.9511 22.8722 85.9511 22.6314 86.1024L21.9729 86.5154C21.7284 86.6667 21.7284 86.9161 21.9729 87.0674L22.6239 87.4763C22.8647 87.6276 23.2597 87.6276 23.5006 87.4763L24.159 87.0633C24.4036 86.912 24.4036 86.6626 24.159 86.5113ZM22.2062 87.7339L21.5553 87.325C21.3145 87.1737 20.9194 87.1737 20.6786 87.325L20.0202 87.738C19.7756 87.8892 19.7756 88.1387 20.0202 88.29L20.6711 88.6989C20.9119 88.8501 21.307 88.8501 21.5478 88.6989L22.2062 88.2859C22.4508 88.1346 22.4508 87.8852 22.2062 87.7339ZM20.2535 88.9565L19.6025 88.5476C19.3617 88.3963 18.9667 88.3963 18.7259 88.5476L18.0674 88.9606C17.8228 89.1118 17.8228 89.3613 18.0674 89.5126L18.7183 89.9215C18.9591 90.0727 19.3542 90.0727 19.595 89.9215L20.2535 89.5085C20.498 89.3572 20.498 89.1078 20.2535 88.9565ZM16.0695 90.7638L16.7204 91.1727C16.9612 91.324 17.3563 91.324 17.5971 91.1727L18.2555 90.7597C18.5001 90.6084 18.5001 90.359 18.2555 90.2077L17.6046 89.7988C17.3638 89.6475 16.9687 89.6475 16.7279 89.7988L16.0695 90.2118C15.8249 90.3631 15.8249 90.6125 16.0695 90.7638ZM41.3351 77.1803L41.9861 77.5892C42.2269 77.7405 42.6219 77.7405 42.8627 77.5892L44.3866 76.6324C44.6312 76.4811 44.6312 76.2317 44.3866 76.0804L43.7357 75.6715C43.4949 75.5202 43.0998 75.5202 42.859 75.6715L41.3351 76.6283C41.0906 76.7796 41.0906 77.029 41.3351 77.1803ZM39.3824 78.4029L40.0333 78.8118C40.2741 78.9631 40.6692 78.9631 40.91 78.8118L41.5684 78.3988C41.813 78.2475 41.813 77.9981 41.5684 77.8468L40.9175 77.4379C40.6767 77.2866 40.2816 77.2866 40.0408 77.4379L39.3824 77.8509C39.1378 78.0022 39.1378 78.2516 39.3824 78.4029ZM37.4296 79.6255L38.0805 80.0344C38.3213 80.1857 38.7164 80.1857 38.9572 80.0344L39.6156 79.6214C39.8602 79.4701 39.8602 79.2207 39.6156 79.0694L38.9647 78.6605C38.7239 78.5092 38.3288 78.5092 38.088 78.6605L37.4296 79.0735C37.185 79.2248 37.185 79.4742 37.4296 79.6255ZM23.7677 88.1959L24.4186 88.6048C24.6594 88.7561 25.0545 88.7561 25.2953 88.6048L37.6591 80.8481C37.9037 80.6968 37.9037 80.4474 37.6591 80.2961L37.0082 79.8872C36.7674 79.7359 36.3723 79.7359 36.1315 79.8872L23.7677 87.6439C23.5231 87.7952 23.5231 88.0446 23.7677 88.1959ZM21.8149 89.4185L22.4658 89.8274C22.7067 89.9787 23.1017 89.9787 23.3425 89.8274L24.001 89.4144C24.2455 89.2631 24.2455 89.0137 24.001 88.8624L23.35 88.4535C23.1092 88.3022 22.7142 88.3022 22.4734 88.4535L21.8149 88.8665C21.5704 89.0178 21.5704 89.2672 21.8149 89.4185ZM19.8621 90.6411L20.5131 91.05C20.7539 91.2013 21.1489 91.2013 21.3898 91.05L22.0482 90.637C22.2928 90.4857 22.2928 90.2363 22.0482 90.085L21.3973 89.6761C21.1565 89.5248 20.7614 89.5248 20.5206 89.6761L19.8621 90.0891C19.6176 90.2404 19.6176 90.4898 19.8621 90.6411ZM17.8717 91.8923L18.5227 92.3012C18.7635 92.4525 19.1585 92.4525 19.3994 92.3012L20.0578 91.8882C20.3024 91.7369 20.3024 91.4875 20.0578 91.3362L19.4069 90.9273C19.1661 90.776 18.771 90.776 18.5302 90.9273L17.8717 91.3403C17.6272 91.4916 17.6272 91.741 17.8717 91.8923Z",
    fill: "url(#paint6_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M33.9663 81.0076L33.3079 81.4206C33.0633 81.5719 32.672 81.576 32.4312 81.4206L31.7803 81.0117C31.6298 80.9176 31.5733 80.7827 31.6147 80.66C31.6373 80.7336 31.6937 80.7991 31.7803 80.8563L32.4312 81.2652C32.672 81.4165 33.0671 81.4165 33.3079 81.2652L33.9663 80.8522C34.0566 80.795 34.1131 80.7255 34.1357 80.6519C34.177 80.7745 34.1206 80.9095 33.9663 81.0076Z",
    fill: "url(#paint7_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M33.2969 79.1101L32.5407 79.5845C32.3262 79.7194 31.9763 79.7194 31.7618 79.5845L31.0093 79.1101C30.8701 79.0243 30.8249 78.9016 30.8663 78.7912C30.8889 78.8525 30.934 78.9098 31.0093 78.9548L31.7618 79.4291C31.9763 79.564 32.3224 79.564 32.5407 79.4291L33.2969 78.9548C33.3722 78.9057 33.4211 78.8484 33.4437 78.7871C33.4851 78.8975 33.4361 79.0202 33.2969 79.1101Z",
    fill: "url(#paint8_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M32.0132 82.2342L31.3548 82.6471C31.1102 82.7984 30.7189 82.8025 30.4781 82.6471L29.8272 82.2382C29.6767 82.1442 29.6202 82.0093 29.6616 81.8866C29.6842 81.9602 29.7406 82.0256 29.8272 82.0829L30.4781 82.4918C30.7189 82.6431 31.114 82.6431 31.3548 82.4918L32.0132 82.0788C32.1035 82.0215 32.16 81.952 32.1825 81.8784C32.2239 82.0011 32.1675 82.136 32.0132 82.2342Z",
    fill: "url(#paint9_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M28.107 84.6836L27.4485 85.0966C27.2039 85.2479 26.8126 85.2479 26.5718 85.0966L25.9209 84.6877C25.7704 84.5937 25.714 84.4587 25.7554 84.3361C25.7779 84.4097 25.8344 84.4751 25.9209 84.5323L26.5718 84.9412C26.8126 85.0925 27.2077 85.0925 27.4485 84.9412L28.107 84.5282C28.1973 84.471 28.2537 84.4015 28.2763 84.3279C28.3177 84.4505 28.2612 84.5855 28.107 84.6836Z",
    fill: "url(#paint10_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M30.0601 83.4568L29.4016 83.8698C29.1571 84.0211 28.7658 84.0211 28.525 83.8698L27.874 83.4609C27.7235 83.3669 27.6671 83.2319 27.7085 83.1092C27.7311 83.1828 27.7875 83.2483 27.874 83.3055L28.525 83.7144C28.7658 83.8657 29.1608 83.8657 29.4016 83.7144L30.0601 83.3014C30.1504 83.2442 30.2068 83.1747 30.2294 83.1011C30.2708 83.2237 30.2144 83.3587 30.0601 83.4568Z",
    fill: "url(#paint11_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M23.0538 83.6901C23.0764 83.7515 23.1215 83.8087 23.1968 83.8537L23.9493 84.328C24.1638 84.4629 24.5099 84.4629 24.7282 84.328L25.4844 83.8537C25.5597 83.8046 25.6086 83.7474 25.6312 83.686C25.6726 83.7964 25.6236 83.9191 25.4844 84.0091L24.7282 84.4834C24.5137 84.6183 24.1638 84.6183 23.9493 84.4834L23.1968 84.0091C23.0576 83.9232 23.0124 83.8005 23.0538 83.6901Z",
    fill: "url(#paint12_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M26.9444 81.2448C26.967 81.3061 27.0122 81.3634 27.0874 81.4084L27.8399 81.8827C28.0544 82.0176 28.4005 82.0176 28.6188 81.8827L29.3751 81.4084C29.4503 81.3593 29.4992 81.3021 29.5218 81.2407C29.5632 81.3511 29.5143 81.4738 29.3751 81.5637L28.6188 82.0381C28.4043 82.173 28.0544 82.173 27.8399 82.0381L27.0874 81.5637C26.9482 81.4779 26.903 81.3552 26.9444 81.2448Z",
    fill: "url(#paint13_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M31.336 80.333L30.5797 80.8074C30.3652 80.9423 30.0153 80.9423 29.8009 80.8074L29.0483 80.333C28.9091 80.2472 28.864 80.1245 28.9054 80.0141C28.9279 80.0754 28.9731 80.1327 29.0483 80.1777L29.8009 80.652C30.0153 80.7869 30.3615 80.7869 30.5797 80.652L31.336 80.1777C31.4112 80.1286 31.4602 80.0713 31.4827 80.01C31.5241 80.1204 31.4752 80.2431 31.336 80.333Z",
    fill: "url(#paint14_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M21.0929 84.9167C21.1154 84.978 21.1606 85.0353 21.2358 85.0802L21.9884 85.5546C22.2028 85.6895 22.549 85.6895 22.7672 85.5546L23.5235 85.0802C23.5987 85.0312 23.6477 84.9739 23.6702 84.9126C23.7116 85.023 23.6627 85.1457 23.5235 85.2356L22.7672 85.7099C22.5527 85.8449 22.2028 85.8449 21.9884 85.7099L21.2358 85.2356C21.0966 85.1498 21.0515 85.0271 21.0929 84.9167Z",
    fill: "url(#paint15_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M22.6656 87.5461L22.0147 87.1372C21.8642 87.0431 21.8077 86.9082 21.8491 86.7855C21.8717 86.8591 21.9281 86.9245 22.0147 86.9818L22.6656 87.3907C22.9064 87.542 23.3015 87.542 23.5423 87.3907L24.2007 86.9777C24.291 86.9205 24.3475 86.8509 24.37 86.7773C24.4114 86.9 24.355 87.035 24.2007 87.1331L23.5423 87.5461C23.2977 87.6974 22.9064 87.7014 22.6656 87.5461Z",
    fill: "url(#paint16_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M35.9117 79.7849L35.2532 80.1979C35.0086 80.3492 34.6173 80.3533 34.3765 80.1979L33.7256 79.789C33.5751 79.695 33.5187 79.56 33.56 79.4374C33.5826 79.511 33.6391 79.5764 33.7256 79.6336L34.3765 80.0425C34.6173 80.1938 35.0124 80.1938 35.2532 80.0425L35.9117 79.6296C36.002 79.5723 36.0584 79.5028 36.081 79.4292C36.1224 79.5519 36.0659 79.6868 35.9117 79.7849Z",
    fill: "url(#paint17_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M19.1476 86.1391C19.1701 86.2004 19.2153 86.2577 19.2905 86.3027L20.043 86.777C20.2575 86.9119 20.6037 86.9119 20.8219 86.777L21.5782 86.3027C21.6534 86.2536 21.7023 86.1963 21.7249 86.135C21.7663 86.2454 21.7174 86.3681 21.5782 86.458L20.8219 86.9324C20.6074 87.0673 20.2575 87.0673 20.043 86.9324L19.2905 86.458C19.1513 86.3722 19.1062 86.2495 19.1476 86.1391Z",
    fill: "url(#paint18_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M34.2084 76.2602L33.5349 76.6854C33.2979 76.8367 32.9103 76.8367 32.6733 76.6854L32.0035 76.2642C31.853 76.1702 31.8004 76.0394 31.8417 75.9167C31.8643 75.9862 31.917 76.0516 32.0035 76.1089L32.6733 76.53C32.9103 76.6772 33.2941 76.6772 33.5349 76.53L34.2084 76.1048C34.2949 76.0516 34.3514 75.9821 34.374 75.9126C34.4153 76.0353 34.3589 76.1661 34.2084 76.2602Z",
    fill: "url(#paint19_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M25.0147 82.4675C25.0373 82.5288 25.0825 82.586 25.1577 82.631L25.9102 83.1053C26.1247 83.2403 26.4709 83.2403 26.6891 83.1053L27.4454 82.631C27.5206 82.582 27.5695 82.5247 27.5921 82.4634C27.6335 82.5738 27.5846 82.6965 27.4454 82.7864L26.6891 83.2607C26.4746 83.3957 26.1247 83.3957 25.9102 83.2607L25.1577 82.7864C25.0185 82.7005 24.9734 82.5779 25.0147 82.4675Z",
    fill: "url(#paint20_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M26.1617 85.906L25.5032 86.319C25.2586 86.4703 24.8673 86.4744 24.6265 86.319L23.9756 85.9101C23.8251 85.8161 23.7687 85.6811 23.81 85.5585C23.8326 85.6321 23.8891 85.6975 23.9756 85.7547L24.6265 86.1636C24.8673 86.3149 25.2624 86.3149 25.5032 86.1636L26.1617 85.7507C26.252 85.6934 26.3084 85.6239 26.331 85.5503C26.3724 85.673 26.3159 85.8079 26.1617 85.906Z",
    fill: "url(#paint21_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M18.1632 84.4914C18.1858 84.5527 18.2309 84.61 18.3062 84.6549L19.0587 85.1293C19.2731 85.2642 19.6193 85.2642 19.8375 85.1293L20.5938 84.6549C20.6691 84.6059 20.718 84.5486 20.7405 84.4873C20.7819 84.5977 20.733 84.7204 20.5938 84.8103L19.8375 85.2846C19.6231 85.4196 19.2731 85.4196 19.0587 85.2846L18.3062 84.8103C18.1669 84.7245 18.1218 84.6018 18.1632 84.4914Z",
    fill: "url(#paint22_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M22.2124 82.2055L22.9649 82.6798C23.1794 82.8147 23.5255 82.8147 23.7438 82.6798L24.5001 82.2055C24.5753 82.1564 24.6242 82.0992 24.6468 82.0378C24.6882 82.1482 24.6393 82.2709 24.5001 82.3609L23.7438 82.8352C23.5293 82.9701 23.1794 82.9701 22.9649 82.8352L22.2124 82.3609C22.0732 82.275 22.028 82.1523 22.0694 82.0419C22.092 82.1033 22.1372 82.1605 22.2124 82.2055Z",
    fill: "url(#paint23_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M23.2535 79.331L23.9233 79.7522C24.1603 79.8994 24.5441 79.8994 24.7849 79.7522L25.4584 79.3269C25.5449 79.2738 25.6014 79.2043 25.624 79.1348C25.6653 79.2574 25.6089 79.3883 25.4584 79.4823L24.7849 79.9076C24.5479 80.0589 24.1603 80.0589 23.9233 79.9076L23.2535 79.4864C23.103 79.3924 23.0504 79.2615 23.0917 79.1389C23.1143 79.2084 23.167 79.2738 23.2535 79.331Z",
    fill: "url(#paint24_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M25.2067 78.1042L25.8764 78.5254C26.1134 78.6726 26.4972 78.6726 26.738 78.5254L27.4115 78.1001C27.4981 78.047 27.5545 77.9775 27.5771 77.908C27.6185 78.0306 27.562 78.1615 27.4115 78.2555L26.738 78.6808C26.501 78.8321 26.1134 78.8321 25.8764 78.6808L25.2067 78.2596C25.0562 78.1656 25.0035 78.0347 25.0449 77.9121C25.0674 77.9816 25.1201 78.047 25.2067 78.1042Z",
    fill: "url(#paint25_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M19.3551 81.7803L20.0248 82.2014C20.2619 82.3486 20.6457 82.3486 20.8865 82.2014L21.56 81.7762C21.6465 81.723 21.7029 81.6535 21.7255 81.584C21.7669 81.7067 21.7105 81.8375 21.56 81.9315L20.8865 82.3568C20.6494 82.5081 20.2619 82.5081 20.0248 82.3568L19.3551 81.9356C19.2046 81.8416 19.1519 81.7107 19.1933 81.5881C19.2159 81.6576 19.2686 81.723 19.3551 81.7803Z",
    fill: "url(#paint26_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M21.3082 80.5537L21.978 80.9749C22.215 81.1221 22.5988 81.1221 22.8396 80.9749L23.5131 80.5496C23.5996 80.4964 23.6561 80.4269 23.6786 80.3574C23.72 80.4801 23.6636 80.6109 23.5131 80.705L22.8396 81.1302C22.6025 81.2815 22.215 81.2815 21.978 81.1302L21.3082 80.7091C21.1577 80.615 21.105 80.4842 21.1464 80.3615C21.169 80.431 21.2217 80.4964 21.3082 80.5537Z",
    fill: "url(#paint27_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M27.1676 76.8818L27.8373 77.303C28.0744 77.4502 28.4582 77.4502 28.699 77.303L29.3725 76.8777C29.459 76.8246 29.5154 76.7551 29.538 76.6855C29.5794 76.8082 29.523 76.9391 29.3725 77.0331L28.699 77.4584C28.4619 77.6096 28.0744 77.6096 27.8373 77.4584L27.1676 77.0372C27.0171 76.9432 26.9644 76.8123 27.0058 76.6896C27.0284 76.7591 27.0811 76.8246 27.1676 76.8818Z",
    fill: "url(#paint28_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M29.1207 75.655L29.7905 76.0762C30.0275 76.2234 30.4113 76.2234 30.6521 76.0762L31.3256 75.6509C31.4121 75.5978 31.4686 75.5283 31.4911 75.4587C31.5325 75.5814 31.4761 75.7123 31.3256 75.8063L30.6521 76.2316C30.415 76.3828 30.0275 76.3828 29.7905 76.2316L29.1207 75.8104C28.9702 75.7163 28.9175 75.5855 28.9589 75.4628C28.9815 75.5323 29.0342 75.5978 29.1207 75.655Z",
    fill: "url(#paint29_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M35.224 73.3612L34.5505 73.7865C34.3135 73.9378 33.9259 73.9378 33.6889 73.7865L33.0192 73.3653C32.8687 73.2713 32.816 73.1404 32.8574 73.0178C32.8799 73.0873 32.9326 73.1527 33.0192 73.2099L33.6889 73.6311C33.9259 73.7783 34.3097 73.7783 34.5505 73.6311L35.224 73.2058C35.3106 73.1527 35.367 73.0832 35.3896 73.0137C35.431 73.1363 35.3745 73.2672 35.224 73.3612Z",
    fill: "url(#paint30_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M31.066 74.4324L31.7358 74.8535C31.9728 75.0007 32.3566 75.0007 32.5974 74.8535L33.2709 74.4283C33.3574 74.3751 33.4139 74.3056 33.4365 74.2361C33.4778 74.3588 33.4214 74.4896 33.2709 74.5836L32.5974 75.0089C32.3604 75.1602 31.9728 75.1602 31.7358 75.0089L31.066 74.5877C30.9155 74.4937 30.8629 74.3628 30.9042 74.2402C30.9268 74.3097 30.9795 74.3751 31.066 74.4324Z",
    fill: "url(#paint31_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M28.1129 78.5583L28.7826 78.9795C29.0197 79.1267 29.4035 79.1267 29.6443 78.9795L30.3178 78.5542C30.4043 78.5011 30.4608 78.4316 30.4833 78.3621C30.5247 78.4847 30.4683 78.6156 30.3178 78.7096L29.6443 79.1349C29.4072 79.2862 29.0197 79.2862 28.7826 79.1349L28.1129 78.7137C27.9624 78.6197 27.9097 78.4888 27.9511 78.3662C27.9737 78.4357 28.0264 78.5011 28.1129 78.5583Z",
    fill: "url(#paint32_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M26.1108 79.7563L26.8634 80.2306C27.0778 80.3655 27.424 80.3655 27.6422 80.2306L28.3985 79.7563C28.4737 79.7072 28.5227 79.65 28.5452 79.5886C28.5866 79.699 28.5377 79.8217 28.3985 79.9117L27.6422 80.386C27.4277 80.5209 27.0778 80.5209 26.8634 80.386L26.1108 79.9117C25.9716 79.8258 25.9265 79.7031 25.9679 79.5927C25.9904 79.6541 26.0356 79.7113 26.1108 79.7563Z",
    fill: "url(#paint33_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M20.2593 83.4321L21.0118 83.9064C21.2263 84.0413 21.5724 84.0413 21.7907 83.9064L22.5469 83.4321C22.6222 83.383 22.6711 83.3257 22.6937 83.2644C22.7351 83.3748 22.6861 83.4975 22.5469 83.5874L21.7907 84.0617C21.5762 84.1967 21.2263 84.1967 21.0118 84.0617L20.2593 83.5874C20.1201 83.5016 20.0749 83.3789 20.1163 83.2685C20.1389 83.3298 20.184 83.3871 20.2593 83.4321Z",
    fill: "url(#paint34_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M24.1577 80.9831L24.9102 81.4574C25.1247 81.5923 25.4709 81.5923 25.6891 81.4574L26.4454 80.9831C26.5206 80.934 26.5695 80.8768 26.5921 80.8154C26.6335 80.9258 26.5846 81.0485 26.4454 81.1385L25.6891 81.6128C25.4746 81.7477 25.1247 81.7477 24.9102 81.6128L24.1577 81.1385C24.0185 81.0526 23.9734 80.9299 24.0147 80.8195C24.0373 80.8809 24.0825 80.9381 24.1577 80.9831Z",
    fill: "url(#paint35_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M17.402 83.0032L18.0717 83.4243C18.3088 83.5715 18.6925 83.5715 18.9333 83.4243L19.6068 82.9991C19.6934 82.9459 19.7498 82.8764 19.7724 82.8069C19.8138 82.9296 19.7573 83.0604 19.6068 83.1544L18.9333 83.5797C18.6963 83.731 18.3088 83.731 18.0717 83.5797L17.402 83.1585C17.2515 83.0645 17.1988 82.9336 17.2402 82.811C17.2628 82.8805 17.3154 82.9459 17.402 83.0032Z",
    fill: "url(#paint36_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M16.2101 85.7141C16.2326 85.7754 16.2778 85.8326 16.353 85.8776L17.1055 86.3519C17.32 86.4869 17.6662 86.4869 17.8844 86.3519L18.6407 85.8776C18.7159 85.8285 18.7648 85.7713 18.7874 85.71C18.8288 85.8204 18.7799 85.943 18.6407 86.033L17.8844 86.5073C17.6699 86.6422 17.32 86.6422 17.1055 86.5073L16.353 86.033C16.2138 85.9471 16.1687 85.8245 16.2101 85.7141Z",
    fill: "url(#paint37_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M15.4488 84.2256L16.1186 84.6467C16.3556 84.7939 16.7394 84.7939 16.9802 84.6467L17.6537 84.2215C17.7403 84.1683 17.7967 84.0988 17.8193 84.0293C17.8607 84.152 17.8042 84.2828 17.6537 84.3769L16.9802 84.8021C16.7432 84.9534 16.3556 84.9534 16.1186 84.8021L15.4488 84.3809C15.2983 84.2869 15.2457 84.1561 15.2871 84.0334C15.3096 84.1029 15.3623 84.1683 15.4488 84.2256Z",
    fill: "url(#paint38_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M32.2553 77.4872L31.5818 77.9125C31.3447 78.0638 30.9572 78.0638 30.7201 77.9125L30.0504 77.4913C29.8999 77.3973 29.8472 77.2664 29.8886 77.1437C29.9112 77.2132 29.9639 77.2787 30.0504 77.3359L30.7201 77.7571C30.9572 77.9043 31.341 77.9043 31.5818 77.7571L32.2553 77.3318C32.3418 77.2787 32.3983 77.2092 32.4208 77.1396C32.4622 77.2623 32.4058 77.3932 32.2553 77.4872Z",
    fill: "url(#paint39_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M19.896 88.0079C19.9186 88.0815 19.975 88.147 20.0615 88.2042L20.7125 88.6131C20.9533 88.7644 21.3483 88.7644 21.5891 88.6131L22.2476 88.2001C22.3379 88.1429 22.3943 88.0734 22.4169 87.9998C22.4583 88.1224 22.4019 88.2574 22.2476 88.3555L21.5891 88.7685C21.3446 88.9198 20.9533 88.9239 20.7125 88.7685L20.0615 88.3596C19.911 88.2655 19.8546 88.1306 19.896 88.0079Z",
    fill: "url(#paint40_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M35.2422 77.888L34.486 78.3623C34.2715 78.4972 33.9216 78.4972 33.7071 78.3623L32.9546 77.888C32.8154 77.8021 32.7702 77.6794 32.8116 77.569C32.8342 77.6304 32.8793 77.6876 32.9546 77.7326L33.7071 78.2069C33.9216 78.3418 34.2677 78.3418 34.486 78.2069L35.2422 77.7326C35.3175 77.6835 35.3664 77.6263 35.389 77.5649C35.4304 77.6753 35.3815 77.798 35.2422 77.888Z",
    fill: "url(#paint41_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M41.2241 76.8982C41.2467 76.9718 41.3031 77.0372 41.3897 77.0945L42.0406 77.5034C42.2814 77.6547 42.6765 77.6547 42.9173 77.5034L44.4411 76.5466C44.5314 76.4893 44.5878 76.4198 44.6104 76.3462C44.6518 76.4689 44.5954 76.6038 44.4411 76.7019L42.9173 77.6587C42.6727 77.81 42.2814 77.81 42.0406 77.6587L41.3897 77.2498C41.2392 77.1558 41.1827 77.0209 41.2241 76.8982Z",
    fill: "url(#paint42_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M39.2632 78.1251C39.2857 78.1987 39.3422 78.2641 39.4287 78.3214L40.0796 78.7303C40.3205 78.8816 40.7155 78.8816 40.9563 78.7303L41.6148 78.3173C41.7051 78.2601 41.7615 78.1905 41.7841 78.1169C41.8255 78.2396 41.769 78.3745 41.6148 78.4727L40.9563 78.8857C40.7118 79.037 40.3205 79.037 40.0796 78.8857L39.4287 78.4768C39.2782 78.3827 39.2218 78.2478 39.2632 78.1251Z",
    fill: "url(#paint43_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M42.6323 75.5694L39.1595 77.7488C38.9149 77.9001 38.5236 77.9041 38.2828 77.7488L37.6318 77.3399C37.4813 77.2458 37.4249 77.1109 37.4663 76.9882C37.4889 77.0618 37.5453 77.1273 37.6318 77.1845L38.2828 77.5934C38.5236 77.7447 38.9186 77.7447 39.1595 77.5934L42.6323 75.414C42.7226 75.3567 42.779 75.2872 42.8016 75.2136C42.843 75.3363 42.7866 75.4712 42.6323 75.5694Z",
    fill: "url(#paint44_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M23.6616 87.9181C23.6842 87.9917 23.7406 88.0571 23.8272 88.1144L24.4781 88.5233C24.7189 88.6745 25.114 88.6745 25.3548 88.5233L37.7186 80.7665C37.8089 80.7093 37.8653 80.6398 37.8879 80.5662C37.9293 80.6888 37.8728 80.8238 37.7186 80.9219L25.3548 88.6786C25.1102 88.8299 24.7189 88.834 24.4781 88.6786L23.8272 88.2697C23.6767 88.1757 23.6202 88.0408 23.6616 87.9181Z",
    fill: "url(#paint45_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M37.3179 79.3475C37.3404 79.4211 37.3969 79.4866 37.4834 79.5438L38.1343 79.9527C38.3751 80.104 38.7702 80.104 39.011 79.9527L39.6695 79.5397C39.7598 79.4825 39.8162 79.413 39.8388 79.3394C39.8802 79.462 39.8237 79.597 39.6695 79.6951L39.011 80.1081C38.7664 80.2594 38.3751 80.2635 38.1343 80.1081L37.4834 79.6992C37.3329 79.6051 37.2765 79.4702 37.3179 79.3475Z",
    fill: "url(#paint46_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M40.8223 74.3753L38.3766 75.9086C38.1621 76.0436 37.8122 76.0436 37.5977 75.9086L36.8452 75.4343C36.706 75.3484 36.6609 75.2258 36.7022 75.1154C36.7248 75.1767 36.77 75.234 36.8452 75.2789L37.5977 75.7533C37.8122 75.8882 38.1584 75.8882 38.3766 75.7533L40.8223 74.2199C40.8975 74.1708 40.9464 74.1136 40.969 74.0522C41.0104 74.1626 40.9615 74.2853 40.8223 74.3753Z",
    fill: "url(#paint47_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M37.1772 72.1344L36.5037 72.5597C36.2666 72.711 35.8791 72.711 35.642 72.5597L34.9723 72.1385C34.8218 72.0445 34.7691 71.9136 34.8105 71.791C34.8331 71.8605 34.8857 71.9259 34.9723 71.9831L35.642 72.4043C35.8791 72.5515 36.2628 72.5515 36.5037 72.4043L37.1772 71.979C37.2637 71.9259 37.3201 71.8564 37.3427 71.7869C37.3841 71.9095 37.3277 72.0404 37.1772 72.1344Z",
    fill: "url(#paint48_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M38.976 73.2672L37.4333 74.2322C37.1963 74.3835 36.8088 74.3835 36.5717 74.2322L35.902 73.8111C35.7515 73.717 35.6988 73.5862 35.7402 73.4635C35.7628 73.533 35.8154 73.5984 35.902 73.6557L36.5717 74.0769C36.8088 74.2241 37.1925 74.2241 37.4333 74.0769L38.976 73.1119C39.0625 73.0587 39.119 72.9892 39.1415 72.9197C39.1829 73.0423 39.1265 73.1732 38.976 73.2672Z",
    fill: "url(#paint49_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M12.4155 88.3554L13.168 88.8297C13.3825 88.9646 13.7287 88.9646 13.9469 88.8297L14.7032 88.3554C14.7784 88.3063 14.8273 88.2491 14.8499 88.1877C14.8913 88.2981 14.8424 88.4208 14.7032 88.5108L13.9469 88.9851C13.7324 89.12 13.3825 89.12 13.168 88.9851L12.4155 88.5108C12.2763 88.4249 12.2312 88.3022 12.2726 88.1918C12.2951 88.2532 12.3403 88.3104 12.4155 88.3554Z",
    fill: "url(#paint50_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M35.4217 70.9691L33.7775 72.0037C33.5668 72.1345 33.2281 72.1345 33.0212 72.0037C32.8857 71.9178 32.8406 71.7992 32.882 71.6888C32.9046 71.746 32.9497 71.8033 33.0212 71.8483C33.2281 71.9791 33.5668 71.9791 33.7775 71.8483L35.4217 70.8138C35.4932 70.7688 35.5421 70.7115 35.5647 70.6543C35.6061 70.7647 35.5609 70.8833 35.4217 70.9691Z",
    fill: "url(#paint51_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M14.2202 89.4879L14.9727 89.9622C15.1872 90.0971 15.5334 90.0971 15.7516 89.9622L17.678 88.7519C17.7533 88.7028 17.8022 88.6456 17.8248 88.5842C17.8662 88.6946 17.8172 88.8173 17.678 88.9073L15.7516 90.1176C15.5371 90.2525 15.1872 90.2525 14.9727 90.1176L14.2202 89.6433C14.081 89.5574 14.0359 89.4347 14.0772 89.3243C14.0998 89.3857 14.145 89.4429 14.2202 89.4879Z",
    fill: "url(#paint52_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M10.6442 87.2433L11.3139 87.6645C11.5509 87.8117 11.9347 87.8117 12.1755 87.6645L13.7182 86.6995C13.8047 86.6463 13.8612 86.5768 13.8837 86.5073C13.9251 86.63 13.8687 86.7608 13.7182 86.8549L12.1755 87.8199C11.9385 87.9712 11.5509 87.9712 11.3139 87.8199L10.6442 87.3987C10.4937 87.3047 10.441 87.1738 10.4824 87.0511C10.5049 87.1207 10.5576 87.1861 10.6442 87.2433Z",
    fill: "url(#paint53_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M21.6929 89.1444C21.7154 89.218 21.7719 89.2834 21.8584 89.3407L22.5093 89.7496C22.7501 89.9009 23.1452 89.9009 23.386 89.7496L24.0445 89.3366C24.1348 89.2793 24.1912 89.2098 24.2138 89.1362C24.2552 89.2589 24.1987 89.3938 24.0445 89.492L23.386 89.905C23.1414 90.0562 22.7501 90.0603 22.5093 89.905L21.8584 89.4961C21.7079 89.402 21.6515 89.2671 21.6929 89.1444Z",
    fill: "url(#paint54_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M9.56026 86.5645C9.7672 86.6953 10.1058 86.6953 10.3165 86.5645L11.0954 86.0738C11.1669 86.0288 11.2158 85.9716 11.2384 85.9143C11.2798 86.0247 11.2346 86.1433 11.0954 86.2292L10.3165 86.7198C10.1058 86.8507 9.7672 86.8507 9.56026 86.7198C9.42481 86.634 9.37966 86.5154 9.42104 86.405C9.44362 86.4622 9.48877 86.5195 9.56026 86.5645Z",
    fill: "url(#paint55_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M19.7475 90.3673C19.7701 90.4409 19.8266 90.5063 19.9131 90.5636L20.564 90.9725C20.8048 91.1238 21.1999 91.1238 21.4407 90.9725L22.0992 90.5595C22.1895 90.5022 22.2459 90.4327 22.2685 90.3591C22.3099 90.4818 22.2534 90.6167 22.0992 90.7149L21.4407 91.1278C21.1961 91.2791 20.8048 91.2832 20.564 91.1278L19.9131 90.719C19.7626 90.6249 19.7062 90.49 19.7475 90.3673Z",
    fill: "url(#paint56_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M17.9287 91.8146L18.5796 92.2234C18.8205 92.3747 19.2155 92.3747 19.4563 92.2234L20.1148 91.8105C20.2051 91.7532 20.2615 91.6837 20.2841 91.6101C20.3255 91.7328 20.269 91.8677 20.1148 91.9658L19.4563 92.3788C19.2118 92.5301 18.8205 92.5342 18.5796 92.3788L17.9287 91.9699C17.7782 91.8759 17.7218 91.741 17.7632 91.6183C17.7857 91.6919 17.8422 91.7573 17.9287 91.8146Z",
    fill: "url(#paint57_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M16.124 90.682L16.775 91.0909C17.0158 91.2422 17.4108 91.2422 17.6516 91.0909L18.3101 90.6779C18.4004 90.6207 18.4568 90.5511 18.4794 90.4775C18.5208 90.6002 18.4644 90.7351 18.3101 90.8333L17.6516 91.2463C17.4071 91.3976 17.0158 91.3976 16.775 91.2463L16.124 90.8374C15.9735 90.7433 15.9171 90.6084 15.9585 90.4857C15.9811 90.5593 16.0375 90.6247 16.124 90.682Z",
    fill: "url(#paint58_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M18.9391 81.3058L18.1603 81.7965C17.9496 81.9273 17.611 81.9273 17.404 81.7965C17.2686 81.7106 17.2234 81.592 17.2648 81.4816C17.2874 81.5389 17.3325 81.5961 17.404 81.6411C17.611 81.772 17.9496 81.772 18.1603 81.6411L18.9391 81.1504C19.0106 81.1055 19.0595 81.0482 19.0821 80.991C19.1235 81.1014 19.0784 81.2199 18.9391 81.3058Z",
    fill: "url(#paint59_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M14.2569 86.9406C14.2795 87.002 14.3247 87.0592 14.3999 87.1042L15.1524 87.5785C15.3669 87.7134 15.713 87.7134 15.9313 87.5785L16.6876 87.1042C16.7628 87.0551 16.8117 86.9979 16.8343 86.9365C16.8757 87.0469 16.8268 87.1696 16.6876 87.2596L15.9313 87.7339C15.7168 87.8688 15.3669 87.8688 15.1524 87.7339L14.3999 87.2596C14.2607 87.1737 14.2155 87.051 14.2569 86.9406Z",
    fill: "url(#paint60_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M13.3339 85.26C13.3565 85.3295 13.4092 85.3949 13.4957 85.4521L14.1655 85.8733C14.4025 86.0205 14.7863 86.0205 15.0271 85.8733L15.7006 85.448C15.7871 85.3949 15.8436 85.3254 15.8661 85.2559C15.9075 85.3785 15.8511 85.5094 15.7006 85.6034L15.0271 86.0287C14.79 86.18 14.4025 86.18 14.1655 86.0287L13.4957 85.6075C13.3452 85.5135 13.2925 85.3826 13.3339 85.26Z",
    fill: "url(#paint61_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M13.0798 84.9821L12.3009 85.4728C12.0902 85.6036 11.7516 85.6036 11.5446 85.4728C11.4092 85.3869 11.364 85.2683 11.4054 85.1579C11.428 85.2152 11.4731 85.2724 11.5446 85.3174C11.7516 85.4482 12.0902 85.4482 12.3009 85.3174L13.0798 84.8267C13.1513 84.7817 13.2002 84.7245 13.2227 84.6672C13.2641 84.7776 13.219 84.8962 13.0798 84.9821Z",
    fill: "url(#paint62_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M17.1944 87.3659C17.217 87.4272 17.2622 87.4845 17.3374 87.5295L18.0899 88.0038C18.3044 88.1387 18.6505 88.1387 18.8688 88.0038L19.6251 87.5295C19.7003 87.4804 19.7492 87.4232 19.7718 87.3618C19.8132 87.4722 19.7643 87.5949 19.6251 87.6848L18.8688 88.1592C18.6543 88.2941 18.3044 88.2941 18.0899 88.1592L17.3374 87.6848C17.1982 87.599 17.153 87.4763 17.1944 87.3659Z",
    fill: "url(#paint63_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M37.1876 76.6609L36.4313 77.1352C36.2168 77.2702 35.8669 77.2702 35.6524 77.1352L34.8999 76.6609C34.7607 76.5751 34.7155 76.4524 34.7569 76.342C34.7795 76.4033 34.8247 76.4606 34.8999 76.5055L35.6524 76.9799C35.8669 77.1148 36.213 77.1148 36.4313 76.9799L37.1876 76.5055C37.2628 76.4565 37.3117 76.3992 37.3343 76.3379C37.3757 76.4483 37.3268 76.571 37.1876 76.6609Z",
    fill: "url(#paint64_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M17.9585 89.2306C17.9811 89.3042 18.0375 89.3696 18.124 89.4269L18.775 89.8358C19.0158 89.987 19.4108 89.987 19.6516 89.8358L20.3101 89.4228C20.4004 89.3655 20.4568 89.296 20.4794 89.2224C20.5208 89.3451 20.4644 89.48 20.3101 89.5781L19.6516 89.9911C19.4071 90.1424 19.0158 90.1424 18.775 89.9911L18.124 89.5822C17.9735 89.4882 17.9171 89.3533 17.9585 89.2306Z",
    fill: "url(#paint65_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M32.5954 72.7355L31.8165 73.2262C31.6058 73.357 31.2672 73.357 31.0603 73.2262C30.9248 73.1403 30.8797 73.0217 30.921 72.9113C30.9436 72.9686 30.9888 73.0258 31.0603 73.0708C31.2672 73.2016 31.6058 73.2016 31.8165 73.0708L32.5954 72.5801C32.6669 72.5351 32.7158 72.4779 32.7384 72.4207C32.7798 72.5311 32.7346 72.6496 32.5954 72.7355Z",
    fill: "url(#paint66_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M37.8648 78.5623L37.2063 78.9753C36.9618 79.1266 36.5705 79.1306 36.3296 78.9753L35.6787 78.5664C35.5282 78.4723 35.4718 78.3374 35.5132 78.2147C35.5357 78.2883 35.5922 78.3537 35.6787 78.411L36.3296 78.8199C36.5705 78.9712 36.9655 78.9712 37.2063 78.8199L37.8648 78.4069C37.9551 78.3497 38.0115 78.2801 38.0341 78.2065C38.0755 78.3292 38.019 78.4641 37.8648 78.5623Z",
    fill: "url(#paint67_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M15.0329 83.7553L14.254 84.2459C14.0433 84.3768 13.7047 84.3768 13.4978 84.2459C13.3623 84.1601 13.3172 84.0415 13.3585 83.9311C13.3811 83.9883 13.4263 84.0456 13.4978 84.0906C13.7047 84.2214 14.0433 84.2214 14.254 84.0906L15.0329 83.5999C15.1044 83.5549 15.1533 83.4977 15.1759 83.4404C15.2173 83.5508 15.1721 83.6694 15.0329 83.7553Z",
    fill: "url(#paint68_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M24.7907 77.6342L24.0118 78.1249C23.8011 78.2557 23.4625 78.2557 23.2556 78.1249C23.1201 78.039 23.075 77.9204 23.1164 77.81C23.1389 77.8673 23.1841 77.9245 23.2556 77.9695C23.4625 78.1003 23.8011 78.1003 24.0118 77.9695L24.7907 77.4788C24.8622 77.4338 24.9111 77.3766 24.9337 77.3193C24.9751 77.4297 24.9299 77.5483 24.7907 77.6342Z",
    fill: "url(#paint69_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M28.7048 75.185L27.9259 75.6756C27.7152 75.8065 27.3766 75.8065 27.1696 75.6756C27.0342 75.5898 26.989 75.4712 27.0304 75.3608C27.053 75.418 27.0981 75.4753 27.1696 75.5203C27.3766 75.6511 27.7152 75.6511 27.9259 75.5203L28.7048 75.0296C28.7763 74.9846 28.8252 74.9274 28.8477 74.8701C28.8891 74.9805 28.844 75.0991 28.7048 75.185Z",
    fill: "url(#paint70_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M26.7438 76.4074L25.965 76.8981C25.7543 77.0289 25.4156 77.0289 25.2087 76.8981C25.0732 76.8122 25.0281 76.6936 25.0695 76.5832C25.0921 76.6404 25.1372 76.6977 25.2087 76.7427C25.4156 76.8735 25.7543 76.8735 25.965 76.7427L26.7438 76.252C26.8153 76.207 26.8642 76.1498 26.8868 76.0925C26.9282 76.2029 26.883 76.3215 26.7438 76.4074Z",
    fill: "url(#paint71_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M30.6501 73.9621L29.8712 74.4527C29.6605 74.5836 29.3219 74.5836 29.1149 74.4527C28.9795 74.3669 28.9343 74.2483 28.9757 74.1379C28.9983 74.1951 29.0435 74.2524 29.1149 74.2974C29.3219 74.4282 29.6605 74.4282 29.8712 74.2974L30.6501 73.8067C30.7216 73.7617 30.7705 73.7045 30.7931 73.6472C30.8344 73.7576 30.7893 73.8762 30.6501 73.9621Z",
    fill: "url(#paint72_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M22.8454 78.8568L22.0665 79.3475C21.8558 79.4784 21.5172 79.4784 21.3103 79.3475C21.1748 79.2616 21.1297 79.1431 21.171 79.0327C21.1936 79.0899 21.2388 79.1472 21.3103 79.1921C21.5172 79.323 21.8558 79.323 22.0665 79.1921L22.8454 78.7015C22.9169 78.6565 22.9658 78.5992 22.9884 78.542C23.0298 78.6524 22.9846 78.771 22.8454 78.8568Z",
    fill: "url(#paint73_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M36.1693 75.0375L35.4958 75.4628C35.2588 75.614 34.8713 75.614 34.6342 75.4628L33.9645 75.0416C33.814 74.9475 33.7613 74.8167 33.8027 74.694C33.8253 74.7635 33.8779 74.829 33.9645 74.8862L34.6342 75.3074C34.8713 75.4546 35.255 75.4546 35.4958 75.3074L36.1693 74.8821C36.2559 74.829 36.3123 74.7595 36.3349 74.6899C36.3763 74.8126 36.3198 74.9435 36.1693 75.0375Z",
    fill: "url(#paint74_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M20.8923 80.0832L20.1134 80.5738C19.9027 80.7047 19.5641 80.7047 19.3571 80.5738C19.2217 80.488 19.1765 80.3694 19.2179 80.259C19.2405 80.3162 19.2856 80.3735 19.3571 80.4185C19.5641 80.5493 19.9027 80.5493 20.1134 80.4185L20.8923 79.9278C20.9638 79.8828 21.0127 79.8256 21.0352 79.7683C21.0766 79.8787 21.0315 79.9973 20.8923 80.0832Z",
    fill: "url(#paint75_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M16.9938 82.5329L16.215 83.0235C16.0043 83.1544 15.6656 83.1544 15.4587 83.0235C15.3232 82.9377 15.2781 82.8191 15.3195 82.7087C15.3421 82.7659 15.3872 82.8232 15.4587 82.8682C15.6656 82.999 16.0043 82.999 16.215 82.8682L16.9938 82.3775C17.0653 82.3325 17.1142 82.2753 17.1368 82.218C17.1782 82.3284 17.133 82.447 16.9938 82.5329Z",
    fill: "url(#paint76_linear_2_901)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03558 85.718L33.5049 66.5899C34.6863 65.8498 35.642 63.8626 35.642 62.1534V36.1763C35.642 34.4672 34.6863 33.6821 33.5049 34.4222L3.03558 53.5544C1.85413 54.2945 0.898438 56.2817 0.898438 57.9909V83.968C0.898438 85.6771 1.85413 86.4622 3.03558 85.7221V85.718Z",
    fill: "url(#paint77_linear_2_901)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76001 84.385L32.9057 65.4613C33.8539 64.8071 34.4409 63.4945 34.4409 62.1534V36.0495C34.4409 35.7306 34.121 35.5343 33.869 35.6938C33.8389 35.7142 33.8163 35.7265 33.8012 35.7347L3.63669 54.6829C2.50792 55.3903 2.10156 56.6496 2.10156 57.9908V84.0333C2.10156 84.3727 2.44019 84.5894 2.7111 84.4177C2.73367 84.4054 2.74872 84.3932 2.76001 84.385Z",
    fill: "url(#paint78_linear_2_901)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10156 57.9908V84.0333C2.10156 84.3727 2.44019 84.5894 2.7111 84.4177C2.73367 84.4054 2.74872 84.3932 2.76001 84.385L32.9057 65.4613C33.8539 64.8071 34.4409 63.4945 34.4409 62.1534V36.0495C34.4409 35.7306 34.121 35.5343 33.869 35.6938C33.8389 35.7142 33.8163 35.7265 33.8012 35.7347L3.63669 54.6829C2.50792 55.3903 2.10156 56.6496 2.10156 57.9908ZM2.34237 57.9908C2.34237 56.989 2.58693 55.6438 3.75709 54.9118L33.9931 35.9269C34.0157 35.9146 34.0383 35.9064 34.0608 35.9064C34.1286 35.9064 34.2001 35.9637 34.2001 36.0577V62.1615C34.2001 63.4373 33.6394 64.6517 32.7816 65.2405L2.59446 84.1887C2.56812 84.2051 2.54178 84.2132 2.51168 84.2132C2.42891 84.2132 2.34237 84.1437 2.34237 84.0292V57.9867V57.9908Z",
    fill: "#BCBEC0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43402 53.2028L32.9033 34.0747C33.3699 33.7803 33.8026 33.7272 34.1525 33.8744C34.1976 33.8948 34.7921 34.2383 34.8335 34.2628C34.4686 34.0706 34.0095 34.1074 33.5053 34.4223L3.03979 53.5545C1.85834 54.2946 0.902649 56.2818 0.902649 57.991V83.9681C0.902649 85.0353 1.27514 85.7427 1.84329 85.943C1.79814 85.943 1.73794 85.9267 1.65516 85.8735C1.62883 85.8572 0.981663 85.4605 0.955325 85.4401C0.548967 85.1293 0.296875 84.4955 0.296875 83.6164V57.6393C0.296875 55.9301 1.25257 53.9429 2.43402 53.2028Z",
    fill: "url(#paint79_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M2.93402 53.4971L33.4033 34.369C33.8887 34.0664 34.3327 34.0214 34.6901 34.1891C34.3854 34.1359 34.0354 34.2177 33.6592 34.4508L3.18987 53.583C2.00842 54.323 1.05273 56.3103 1.05273 58.0195V83.9965C1.05273 85.0065 1.3876 85.6894 1.90307 85.9306C1.24462 85.8161 0.796875 85.0801 0.796875 83.9148V57.9377C0.796875 56.2285 1.75257 54.2413 2.93402 53.5012V53.4971Z",
    fill: "url(#paint80_radial_2_901)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4512 85.4277L28.1096 85.0147C28.3015 84.8961 28.3391 84.7162 28.23 84.5731C28.1999 84.614 28.1623 84.6508 28.1096 84.6835L27.4512 85.0965C27.2066 85.2478 26.8153 85.2478 26.5745 85.0965L25.9236 84.6876C25.8709 84.6549 25.8333 84.6181 25.8069 84.5813C25.6978 84.7244 25.7354 84.9043 25.9236 85.0229L26.5745 85.4318C26.8153 85.5831 27.2104 85.5831 27.4512 85.4318V85.4277ZM32.5306 79.9199L33.2869 79.4456C33.4638 79.3352 33.4939 79.1634 33.3772 79.0326C33.3509 79.0612 33.3245 79.0857 33.2869 79.1103L32.5306 79.5846C32.3162 79.7195 31.9663 79.7195 31.7518 79.5846L30.9993 79.1103C30.9616 79.0857 30.9353 79.0612 30.909 79.0326C30.7923 79.1634 30.8224 79.3311 30.9993 79.4415L31.7518 79.9158C31.9663 80.0507 32.3124 80.0507 32.5306 79.9158V79.9199ZM29.4039 84.2051L30.0624 83.7921C30.2543 83.6735 30.2919 83.4936 30.1828 83.3505C30.1527 83.3914 30.1151 83.4282 30.0624 83.4609L29.4039 83.8739C29.1594 84.0252 28.7681 84.0252 28.5273 83.8739L27.8763 83.465C27.8237 83.4323 27.786 83.3955 27.7597 83.3587C27.6506 83.5018 27.6882 83.6817 27.8763 83.8003L28.5273 84.2092C28.7681 84.3605 29.1631 84.3605 29.4039 84.2092V84.2051ZM31.3567 82.9825L32.0152 82.5695C32.2071 82.4509 32.2447 82.271 32.1356 82.1279C32.1055 82.1688 32.0678 82.2056 32.0152 82.2383L31.3567 82.6513C31.1121 82.8026 30.7208 82.8067 30.48 82.6513L29.8291 82.2424C29.7764 82.2097 29.7388 82.1729 29.7125 82.1361C29.6034 82.2792 29.641 82.4591 29.8291 82.5777L30.48 82.9866C30.7208 83.1379 31.1159 83.1379 31.3567 82.9866V82.9825ZM28.6289 82.3692L29.3851 81.8948C29.562 81.7844 29.5921 81.6127 29.4754 81.4819C29.4491 81.5105 29.4228 81.535 29.3851 81.5596L28.6289 82.0339C28.4144 82.1688 28.0645 82.1688 27.85 82.0339L27.0975 81.5596C27.0599 81.535 27.0335 81.5105 27.0072 81.4819C26.8905 81.6127 26.9206 81.7804 27.0975 81.8908L27.85 82.3651C28.0645 82.5 28.4106 82.5 28.6289 82.3651V82.3692ZM24.7271 84.8184L25.4833 84.3441C25.6602 84.2337 25.6903 84.062 25.5736 83.9311C25.5473 83.9598 25.521 83.9843 25.4833 84.0088L24.7271 84.4831C24.5126 84.6181 24.1627 84.6181 23.9482 84.4831L23.1957 84.0088C23.1581 83.9843 23.1317 83.9598 23.1054 83.9311C22.9888 84.062 23.0189 84.2296 23.1957 84.34L23.9482 84.8144C24.1627 84.9493 24.5088 84.9493 24.7271 84.8144V84.8184ZM30.5816 81.1466L31.3379 80.6722C31.5147 80.5618 31.5448 80.3901 31.4282 80.2593C31.4019 80.2879 31.3755 80.3124 31.3379 80.337L30.5816 80.8113C30.3672 80.9462 30.0172 80.9462 29.8028 80.8113L29.0503 80.337C29.0126 80.3124 28.9863 80.2879 28.96 80.2593C28.8433 80.3901 28.8734 80.5578 29.0503 80.6682L29.8028 81.1425C30.0172 81.2774 30.3634 81.2774 30.5816 81.1425V81.1466ZM17.8867 86.8425L18.643 86.3682C18.8198 86.2578 18.8499 86.086 18.7333 85.9552C18.7069 85.9838 18.6806 86.0083 18.643 86.0329L17.8867 86.5072C17.6722 86.6421 17.3223 86.6421 17.1079 86.5072L16.3553 86.0329C16.3177 86.0083 16.2914 85.9838 16.265 85.9552C16.1484 86.086 16.1785 86.2537 16.3553 86.3641L17.1079 86.8384C17.3223 86.9733 17.6685 86.9733 17.8867 86.8384V86.8425ZM35.2585 80.5332L35.917 80.1202C36.1088 80.0017 36.1465 79.8217 36.0374 79.6786C36.0073 79.7195 35.9696 79.7563 35.917 79.789L35.2585 80.202C35.0139 80.3533 34.6226 80.3574 34.3818 80.202L33.7309 79.7931C33.6782 79.7604 33.6406 79.7236 33.6143 79.6868C33.5051 79.8299 33.5428 80.0098 33.7309 80.1284L34.3818 80.5373C34.6226 80.6886 35.0177 80.6886 35.2585 80.5373V80.5332ZM34.4834 78.6973L35.2397 78.223C35.4165 78.1126 35.4466 77.9408 35.33 77.81C35.3037 77.8386 35.2773 77.8631 35.2397 77.8877L34.4834 78.362C34.2689 78.4969 33.919 78.4969 33.7046 78.362L32.952 77.8877C32.9144 77.8631 32.8881 77.8386 32.8617 77.81C32.7451 77.9408 32.7752 78.1085 32.952 78.2189L33.7046 78.6932C33.919 78.8281 34.2652 78.8281 34.4834 78.6932V78.6973ZM23.5494 87.8811L24.2078 87.4681C24.3997 87.3495 24.4373 87.1696 24.3282 87.0265C24.2981 87.0674 24.2605 87.1042 24.2078 87.1369L23.5494 87.5499C23.3048 87.7011 22.9135 87.7052 22.6727 87.5499L22.0218 87.141C21.9691 87.1083 21.9315 87.0715 21.9051 87.0347C21.796 87.1778 21.8336 87.3577 22.0218 87.4763L22.6727 87.8852C22.9135 88.0364 23.3086 88.0364 23.5494 87.8852V87.8811ZM25.5022 86.6585L26.1606 86.2455C26.3525 86.1269 26.3901 85.947 26.281 85.8039C26.2509 85.8448 26.2133 85.8816 26.1606 85.9143L25.5022 86.3273C25.2576 86.4786 24.8663 86.4826 24.6255 86.3273L23.9746 85.9184C23.9219 85.8857 23.8842 85.8489 23.8579 85.8121C23.7488 85.9552 23.7864 86.1351 23.9746 86.2537L24.6255 86.6626C24.8663 86.8138 25.2613 86.8138 25.5022 86.6626V86.6585ZM20.8253 86.9406C20.6108 87.0755 20.2609 87.0755 20.0464 86.9406L19.2939 86.4663C19.2563 86.4418 19.2299 86.4172 19.2036 86.3886C19.087 86.5194 19.1171 86.6871 19.2939 86.7975L20.0464 87.2718C20.2609 87.4067 20.607 87.4067 20.8253 87.2718L21.5816 86.7975C21.7584 86.6871 21.7885 86.5154 21.6719 86.3845C21.6455 86.4131 21.6192 86.4377 21.5816 86.4622L20.8253 86.9365V86.9406ZM26.6798 83.5999L27.4361 83.1256C27.613 83.0152 27.6431 82.8435 27.5264 82.7126C27.5001 82.7413 27.4737 82.7658 27.4361 82.7903L26.6798 83.2646C26.4654 83.3996 26.1155 83.3996 25.901 83.2646L25.1485 82.7903C25.1108 82.7658 25.0845 82.7413 25.0582 82.7126C24.9415 82.8435 24.9716 83.0111 25.1485 83.1215L25.901 83.5958C26.1155 83.7308 26.4616 83.7308 26.6798 83.5958V83.5999ZM22.7781 86.0492L23.5343 85.5749C23.7112 85.4645 23.7413 85.2928 23.6246 85.1619C23.5983 85.1905 23.572 85.2151 23.5343 85.2396L22.7781 85.7139C22.5636 85.8489 22.2137 85.8489 21.9992 85.7139L21.2467 85.2396C21.2091 85.2151 21.1827 85.1905 21.1564 85.1619C21.0397 85.2928 21.0698 85.4604 21.2467 85.5708L21.9992 86.0451C22.2137 86.1801 22.5598 86.1801 22.7781 86.0451V86.0492ZM19.0644 85.2928L18.3119 84.8184C18.2743 84.7939 18.2479 84.7694 18.2216 84.7408C18.1049 84.8716 18.135 85.0392 18.3119 85.1496L19.0644 85.624C19.2789 85.7589 19.625 85.7589 19.8432 85.624L20.5995 85.1496C20.7764 85.0392 20.8065 84.8675 20.6898 84.7367C20.6635 84.7653 20.6371 84.7898 20.5995 84.8144L19.8432 85.2887C19.6288 85.4236 19.2789 85.4236 19.0644 85.2887V85.2928ZM32.6849 76.6978L32.0152 76.2766C31.9663 76.248 31.9324 76.2112 31.9023 76.1744C31.7932 76.3175 31.827 76.4933 32.0152 76.6078L32.6849 77.029C32.9219 77.1762 33.3057 77.1762 33.5465 77.029L34.22 76.6037C34.4082 76.4852 34.4458 76.3093 34.3367 76.1662C34.3066 76.203 34.2689 76.2398 34.22 76.2725L33.5465 76.6978C33.3095 76.8491 32.9219 76.8491 32.6849 76.6978ZM21.0172 84.0702L20.2647 83.5958C20.227 83.5713 20.2007 83.5468 20.1744 83.5182C20.0577 83.649 20.0878 83.8166 20.2647 83.927L21.0172 84.4014C21.2316 84.5363 21.5778 84.5363 21.796 84.4014L22.5523 83.927C22.7291 83.8166 22.7592 83.6449 22.6426 83.5141C22.6163 83.5427 22.5899 83.5672 22.5523 83.5918L21.796 84.0661C21.5816 84.201 21.2316 84.201 21.0172 84.0661V84.0702ZM25.22 78.6073L25.8897 79.0285C26.1267 79.1757 26.5105 79.1757 26.7513 79.0285L27.4248 78.6032C27.613 78.4847 27.6506 78.3088 27.5415 78.1657C27.5114 78.2025 27.4737 78.2393 27.4248 78.272L26.7513 78.6973C26.5143 78.8486 26.1267 78.8486 25.8897 78.6973L25.22 78.2761C25.171 78.2475 25.1372 78.2107 25.1071 78.1739C24.998 78.317 25.0318 78.4928 25.22 78.6073ZM23.2672 79.8299L23.9369 80.2511C24.174 80.3983 24.5577 80.3983 24.7986 80.2511L25.4721 79.8258C25.6602 79.7073 25.6978 79.5314 25.5887 79.3883C25.5586 79.4251 25.521 79.4619 25.4721 79.4946L24.7986 79.9199C24.5615 80.0712 24.174 80.0712 23.9369 79.9199L23.2672 79.4987C23.2183 79.4701 23.1844 79.4333 23.1543 79.3965C23.0452 79.5396 23.0791 79.7154 23.2672 79.8299ZM21.3144 81.0525L21.9841 81.4737C22.2212 81.6209 22.605 81.6209 22.8458 81.4737L23.5193 81.0484C23.7074 80.9299 23.745 80.754 23.6359 80.6109C23.6058 80.6477 23.5682 80.6845 23.5193 80.7172L22.8458 81.1425C22.6087 81.2938 22.2212 81.2938 21.9841 81.1425L21.3144 80.7213C21.2655 80.6927 21.2316 80.6559 21.2015 80.6191C21.0924 80.7622 21.1263 80.938 21.3144 81.0525ZM29.1217 76.154L29.7915 76.5751C30.0285 76.7223 30.4123 76.7223 30.6531 76.5751L31.3266 76.1499C31.5147 76.0313 31.5524 75.8555 31.4433 75.7124C31.4132 75.7492 31.3755 75.786 31.3266 75.8187L30.6531 76.2439C30.4161 76.3952 30.0285 76.3952 29.7915 76.2439L29.1217 75.8228C29.0728 75.7941 29.039 75.7573 29.0089 75.7205C28.8998 75.8636 28.9336 76.0395 29.1217 76.154ZM33.0235 73.7047L33.6933 74.1258C33.9303 74.273 34.3141 74.273 34.5549 74.1258L35.2284 73.7006C35.4165 73.582 35.4542 73.4062 35.345 73.2631C35.3149 73.2999 35.2773 73.3367 35.2284 73.3694L34.5549 73.7946C34.3179 73.9459 33.9303 73.9459 33.6933 73.7946L33.0235 73.3735C32.9746 73.3449 32.9408 73.3081 32.9107 73.2712C32.8015 73.4144 32.8354 73.5902 33.0235 73.7047ZM31.0708 74.9273L31.7405 75.3484C31.9775 75.4956 32.3613 75.4956 32.6021 75.3484L33.2756 74.9232C33.4638 74.8046 33.5014 74.6288 33.3923 74.4857C33.3622 74.5225 33.3245 74.5593 33.2756 74.592L32.6021 75.0172C32.3651 75.1685 31.9775 75.1685 31.7405 75.0172L31.0708 74.5961C31.0218 74.5674 30.988 74.5306 30.9579 74.4938C30.8488 74.637 30.8826 74.8128 31.0708 74.9273ZM19.3616 82.2751L20.0314 82.6963C20.2684 82.8435 20.6522 82.8435 20.893 82.6963L21.5665 82.271C21.7546 82.1525 21.7923 81.9766 21.6831 81.8335C21.653 81.8703 21.6154 81.9071 21.5665 81.9398L20.893 82.3651C20.656 82.5164 20.2684 82.5164 20.0314 82.3651L19.3616 81.9439C19.3127 81.9153 19.2789 81.8785 19.2488 81.8417C19.1396 81.9848 19.1735 82.1606 19.3616 82.2751ZM27.169 77.3766L27.8387 77.7977C28.0758 77.9449 28.4595 77.9449 28.7003 77.7977L29.3738 77.3725C29.562 77.2539 29.5996 77.0781 29.4905 76.935C29.4604 76.9718 29.4228 77.0085 29.3738 77.0413L28.7003 77.4665C28.4633 77.6178 28.0758 77.6178 27.8387 77.4665L27.169 77.0453C27.1201 77.0167 27.0862 76.9799 27.0561 76.9431C26.947 77.0862 26.9808 77.2621 27.169 77.3766ZM28.7794 79.143L28.1096 78.7218C28.0607 78.6932 28.0268 78.6564 27.9967 78.6196C27.8876 78.7627 27.9215 78.9385 28.1096 79.053L28.7794 79.4742C29.0164 79.6214 29.4002 79.6214 29.641 79.4742L30.3145 79.0489C30.5026 78.9304 30.5402 78.7545 30.4311 78.6114C30.401 78.6482 30.3634 78.685 30.3145 78.7177L29.641 79.143C29.4039 79.2943 29.0164 79.2943 28.7794 79.143ZM17.4089 83.4977L18.0786 83.9189C18.3156 84.0661 18.6994 84.0661 18.9402 83.9189L19.6137 83.4936C19.8019 83.375 19.8395 83.1992 19.7304 83.0561C19.7003 83.0929 19.6626 83.1297 19.6137 83.1624L18.9402 83.5877C18.7032 83.739 18.3156 83.739 18.0786 83.5877L17.4089 83.1665C17.3599 83.1379 17.3261 83.1011 17.296 83.0643C17.1869 83.2074 17.2207 83.3832 17.4089 83.4977ZM24.9152 81.6168L24.1627 81.1425C24.1251 81.1179 24.0987 81.0934 24.0724 81.0648C23.9557 81.1956 23.9858 81.3633 24.1627 81.4737L24.9152 81.948C25.1297 82.0829 25.4758 82.0829 25.694 81.948L26.4503 81.4737C26.6272 81.3633 26.6573 81.1915 26.5406 81.0607C26.5143 81.0893 26.4879 81.1139 26.4503 81.1384L25.694 81.6127C25.4796 81.7476 25.1297 81.7476 24.9152 81.6127V81.6168ZM22.9624 82.8394L22.2099 82.3651C22.1723 82.3405 22.1459 82.316 22.1196 82.2874C22.003 82.4182 22.0331 82.5859 22.2099 82.6963L22.9624 83.1706C23.1769 83.3055 23.523 83.3055 23.7413 83.1706L24.4975 82.6963C24.6744 82.5859 24.7045 82.4141 24.5878 82.2833C24.5615 82.3119 24.5352 82.3364 24.4975 82.361L23.7413 82.8353C23.5268 82.9702 23.1769 82.9702 22.9624 82.8353V82.8394ZM26.8642 80.3901L26.1117 79.9158C26.0741 79.8913 26.0477 79.8667 26.0214 79.8381C25.9048 79.9689 25.9349 80.1366 26.1117 80.247L26.8642 80.7213C27.0787 80.8562 27.4248 80.8562 27.6431 80.7213L28.3993 80.247C28.5762 80.1366 28.6063 79.9649 28.4896 79.834C28.4633 79.8626 28.437 79.8872 28.3993 79.9117L27.6431 80.386C27.4286 80.521 27.0787 80.521 26.8642 80.386V80.3901ZM15.4523 84.7203L16.1221 85.1415C16.3591 85.2887 16.7429 85.2887 16.9837 85.1415L17.6572 84.7162C17.8453 84.5976 17.8829 84.4218 17.7738 84.2787C17.7437 84.3155 17.7061 84.3523 17.6572 84.385L16.9837 84.8103C16.7466 84.9616 16.3591 84.9616 16.1221 84.8103L15.4523 84.3891C15.4034 84.3605 15.3695 84.3237 15.3394 84.2869C15.2303 84.43 15.2642 84.6058 15.4523 84.7203ZM30.7246 77.9163L30.0549 77.4951C30.006 77.4665 29.9721 77.4297 29.942 77.3929C29.8329 77.536 29.8667 77.7118 30.0549 77.8263L30.7246 78.2475C30.9616 78.3947 31.3454 78.3947 31.5862 78.2475L32.2597 77.8223C32.4479 77.7037 32.4855 77.5278 32.3764 77.3847C32.3463 77.4215 32.3086 77.4583 32.2597 77.491L31.5862 77.9163C31.3492 78.0676 30.9616 78.0676 30.7246 77.9163ZM21.5928 89.1037L22.2513 88.6907C22.4432 88.5721 22.4808 88.3922 22.3717 88.2491C22.3416 88.29 22.304 88.3268 22.2513 88.3595L21.5928 88.7725C21.3483 88.9237 20.957 88.9278 20.7162 88.7725L20.0652 88.3636C20.0126 88.3308 19.9749 88.2941 19.9486 88.2572C19.8395 88.4004 19.8771 88.5803 20.0652 88.6989L20.7162 89.1077C20.957 89.259 21.352 89.259 21.5928 89.1077V89.1037ZM33.302 81.7558L33.9604 81.3428C34.1523 81.2243 34.1899 81.0443 34.0808 80.9012C34.0507 80.9421 34.0131 80.9789 33.9604 81.0116L33.302 81.4246C33.0574 81.5759 32.6661 81.58 32.4253 81.4246L31.7744 81.0157C31.7217 80.983 31.6841 80.9462 31.6577 80.9094C31.5486 81.0525 31.5862 81.2324 31.7744 81.351L32.4253 81.7599C32.6661 81.9112 33.0612 81.9112 33.302 81.7599V81.7558ZM38.2798 77.7527L37.6289 77.3438C37.5762 77.3111 37.5386 77.2743 37.5123 77.2375C37.4032 77.3806 37.4408 77.5606 37.6289 77.6791L38.2798 78.088C38.5207 78.2393 38.9157 78.2393 39.1565 78.088L42.6294 75.9086C42.8213 75.79 42.8589 75.6101 42.7498 75.467C42.7197 75.5079 42.6821 75.5447 42.6294 75.5774L39.1565 77.7568C38.912 77.9081 38.5207 77.9122 38.2798 77.7568V77.7527ZM41.621 78.4765L40.9626 78.8895C40.718 79.0408 40.3267 79.0408 40.0859 78.8895L39.435 78.4806C39.3823 78.4479 39.3447 78.4111 39.3183 78.3743C39.2092 78.5174 39.2468 78.6973 39.435 78.8159L40.0859 79.2248C40.3267 79.376 40.7218 79.376 40.9626 79.2248L41.621 78.8118C41.8129 78.6932 41.8505 78.5133 41.7414 78.3702C41.7113 78.4111 41.6737 78.4479 41.621 78.4806V78.4765ZM44.5596 76.5997C44.5295 76.6405 44.4919 76.6773 44.4392 76.7101L42.9153 77.6669C42.6708 77.8182 42.2795 77.8182 42.0387 77.6669L41.3877 77.258C41.3351 77.2253 41.2974 77.1885 41.2711 77.1517C41.162 77.2948 41.1996 77.4747 41.3877 77.5933L42.0387 78.0022C42.2795 78.1535 42.6745 78.1535 42.9153 78.0022L44.4392 77.0453C44.6311 76.9268 44.6687 76.7469 44.5596 76.6037V76.5997ZM37.7192 80.9258L25.3554 88.6825C25.1108 88.8338 24.7195 88.8379 24.4787 88.6825L23.8278 88.2736C23.7751 88.2409 23.7375 88.2041 23.7112 88.1673C23.6021 88.3104 23.6397 88.4903 23.8278 88.6089L24.4787 89.0178C24.7195 89.1691 25.1146 89.1691 25.3554 89.0178L37.7192 81.2611C37.9111 81.1425 37.9487 80.9626 37.8396 80.8195C37.8095 80.8603 37.7719 80.8971 37.7192 80.9298V80.9258ZM39.672 79.7032L39.0135 80.1162C38.769 80.2674 38.3777 80.2715 38.1369 80.1162L37.4859 79.7073C37.4333 79.6745 37.3956 79.6377 37.3693 79.6009C37.2602 79.7441 37.2978 79.924 37.4859 80.0425L38.1369 80.4514C38.3777 80.6027 38.7727 80.6027 39.0135 80.4514L39.672 80.0385C39.8639 79.9199 39.9015 79.74 39.7924 79.5969C39.7623 79.6377 39.7247 79.6745 39.672 79.7073V79.7032ZM34.8597 72.0446C34.7506 72.1877 34.7844 72.3635 34.9725 72.478L35.6423 72.8992C35.8793 73.0464 36.2631 73.0464 36.5039 72.8992L37.1774 72.4739C37.3655 72.3553 37.4032 72.1795 37.2941 72.0364C37.264 72.0732 37.2263 72.11 37.1774 72.1427L36.5039 72.568C36.2669 72.7192 35.8793 72.7192 35.6423 72.568L34.9725 72.1468C34.9236 72.1182 34.8898 72.0814 34.8597 72.0446ZM37.6101 75.9209L36.8576 75.4466C36.82 75.422 36.7936 75.3975 36.7673 75.3689C36.6507 75.4997 36.6808 75.6674 36.8576 75.7778L37.6101 76.2521C37.8246 76.387 38.1707 76.387 38.389 76.2521L40.8346 74.7187C41.0115 74.6083 41.0416 74.4366 40.9249 74.3058C40.8986 74.3344 40.8723 74.3589 40.8346 74.3834L38.389 75.9168C38.1745 76.0517 37.8246 76.0517 37.6101 75.9168V75.9209ZM36.5829 74.2444L35.9132 73.8233C35.8643 73.7946 35.8304 73.7578 35.8003 73.721C35.6912 73.8641 35.7251 74.04 35.9132 74.1545L36.5829 74.5756C36.82 74.7228 37.2038 74.7228 37.4446 74.5756L38.9872 73.6106C39.1753 73.4921 39.213 73.3162 39.1039 73.1731C39.0737 73.2099 39.0361 73.2467 38.9872 73.2794L37.4446 74.2444C37.2075 74.3957 36.82 74.3957 36.5829 74.2444ZM22.1083 90.7229L21.4499 91.1359C21.2053 91.2872 20.814 91.2912 20.5732 91.1359L19.9223 90.727C19.8696 90.6943 19.832 90.6575 19.8056 90.6207C19.6965 90.7638 19.7341 90.9437 19.9223 91.0623L20.5732 91.4712C20.814 91.6225 21.2091 91.6225 21.4499 91.4712L22.1083 91.0582C22.3002 90.9396 22.3378 90.7597 22.2287 90.6166C22.1986 90.6575 22.161 90.6943 22.1083 90.727V90.7229ZM24.0611 89.5003L23.4026 89.9133C23.1581 90.0646 22.7668 90.0686 22.526 89.9133L21.875 89.5044C21.8224 89.4717 21.7847 89.4349 21.7584 89.3981C21.6493 89.5412 21.6869 89.7211 21.875 89.8397L22.526 90.2486C22.7668 90.3999 23.1618 90.3999 23.4026 90.2486L24.0611 89.8356C24.253 89.717 24.2906 89.5371 24.1815 89.394C24.1514 89.4349 24.1138 89.4717 24.0611 89.5044V89.5003ZM14.7939 88.4331C14.7675 88.4617 14.7412 88.4862 14.7036 88.5108L13.9473 88.9851C13.7328 89.12 13.3829 89.12 13.1684 88.9851L12.4159 88.5108C12.3783 88.4862 12.352 88.4617 12.3256 88.4331C12.209 88.5639 12.2391 88.7316 12.4159 88.842L13.1684 89.3163C13.3829 89.4512 13.7291 89.4512 13.9473 89.3163L14.7036 88.842C14.8804 88.7316 14.9105 88.5598 14.7939 88.429V88.4331ZM17.7701 88.8338C17.7437 88.8624 17.7174 88.8869 17.6798 88.9115L15.7533 90.1218C15.5389 90.2567 15.1889 90.2567 14.9745 90.1218L14.222 89.6475C14.1843 89.623 14.158 89.5984 14.1317 89.5698C14.015 89.7006 14.0451 89.8683 14.222 89.9787L14.9745 90.453C15.1889 90.5879 15.5351 90.5879 15.7533 90.453L17.6798 89.2427C17.8566 89.1323 17.8867 88.9605 17.7701 88.8297V88.8338ZM11.1818 86.1637C11.1592 86.1882 11.1329 86.2128 11.0953 86.2373L10.3164 86.728C10.1057 86.8588 9.76708 86.8588 9.56014 86.728C9.52628 86.7075 9.49994 86.683 9.47736 86.6585C9.36072 86.7852 9.38706 86.9529 9.56014 87.0592C9.76708 87.19 10.1057 87.19 10.3164 87.0592L11.0953 86.5685C11.2721 86.4581 11.2984 86.2905 11.1818 86.1637ZM13.8344 86.7525C13.8043 86.7893 13.7667 86.8261 13.7178 86.8588L12.1751 87.8238C11.9381 87.9751 11.5505 87.9751 11.3135 87.8238L10.6438 87.4027C10.5948 87.374 10.561 87.3372 10.5309 87.3004C10.4218 87.4435 10.4556 87.6194 10.6438 87.7339L11.3135 88.155C11.5505 88.3022 11.9343 88.3022 12.1751 88.155L13.7178 87.19C13.9059 87.0715 13.9435 86.8956 13.8344 86.7525ZM18.4285 90.727C18.3984 90.7679 18.3608 90.8047 18.3081 90.8374L17.6497 91.2504C17.4051 91.4016 17.0138 91.4016 16.773 91.2504L16.1221 90.8415C16.0694 90.8088 16.0318 90.772 16.0054 90.7352C15.8963 90.8783 15.9339 91.0582 16.1221 91.1768L16.773 91.5857C17.0138 91.7369 17.4089 91.7369 17.6497 91.5857L18.3081 91.1727C18.5 91.0541 18.5376 90.8742 18.4285 90.7311V90.727ZM33.0198 72.339C33.2267 72.4698 33.5653 72.4698 33.7761 72.339L35.4203 71.3045C35.5971 71.1941 35.6235 71.0264 35.5068 70.8997C35.4843 70.9242 35.4579 70.9487 35.4203 70.9733L33.7761 72.0078C33.5653 72.1386 33.2267 72.1386 33.0198 72.0078C32.9859 71.9873 32.9596 71.9628 32.937 71.9383C32.8204 72.065 32.8467 72.2327 33.0198 72.339ZM20.1142 91.97L19.4557 92.383C19.2111 92.5343 18.8198 92.5384 18.579 92.383L17.9281 91.9741C17.8754 91.9414 17.8378 91.9046 17.8115 91.8678C17.7023 92.0109 17.74 92.1908 17.9281 92.3094L18.579 92.7183C18.8198 92.8696 19.2149 92.8696 19.4557 92.7183L20.1142 92.3053C20.306 92.1867 20.3437 92.0068 20.2346 91.8637C20.2045 91.9046 20.1668 91.9414 20.1142 91.9741V91.97ZM17.4051 82.1361C17.612 82.2669 17.9507 82.2669 18.1614 82.1361L18.9402 81.6454C19.1171 81.535 19.1434 81.3674 19.0268 81.2406C19.0042 81.2651 18.9779 81.2897 18.9402 81.3142L18.1614 81.8049C17.9507 81.9357 17.612 81.9357 17.4051 81.8049C17.3712 81.7844 17.3449 81.7599 17.3223 81.7354C17.2057 81.8621 17.232 82.0298 17.4051 82.1361ZM13.5033 85.947L14.1731 86.3682C14.4101 86.5154 14.7939 86.5154 15.0347 86.3682L15.7082 85.9429C15.8963 85.8243 15.9339 85.6485 15.8248 85.5054C15.7947 85.5422 15.7571 85.579 15.7082 85.6117L15.0347 86.0369C14.7976 86.1882 14.4101 86.1882 14.1731 86.0369L13.5033 85.6158C13.4544 85.5872 13.4205 85.5504 13.3904 85.5136C13.2813 85.6567 13.3152 85.8325 13.5033 85.947ZM13.5033 84.5854C13.7103 84.7162 14.0489 84.7162 14.2596 84.5854L15.0384 84.0947C15.2153 83.9843 15.2416 83.8166 15.125 83.6899C15.1024 83.7144 15.0761 83.739 15.0384 83.7635L14.2596 84.2542C14.0489 84.385 13.7103 84.385 13.5033 84.2542C13.4694 84.2337 13.4431 84.2092 13.4205 84.1847C13.3039 84.3114 13.3302 84.4791 13.5033 84.5854ZM11.5505 85.808C11.7575 85.9388 12.0961 85.9388 12.3068 85.808L13.0857 85.3173C13.2625 85.2069 13.2888 85.0392 13.1722 84.9125C13.1496 84.937 13.1233 84.9616 13.0857 84.9861L12.3068 85.4768C12.0961 85.6076 11.7575 85.6076 11.5505 85.4768C11.5167 85.4563 11.4903 85.4318 11.4678 85.4073C11.3511 85.534 11.3775 85.7017 11.5505 85.808ZM17.3374 88.0242L18.0899 88.4985C18.3044 88.6334 18.6505 88.6334 18.8687 88.4985L19.625 88.0242C19.8019 87.9138 19.832 87.742 19.7153 87.6112C19.689 87.6398 19.6626 87.6644 19.625 87.6889L18.8687 88.1632C18.6543 88.2981 18.3044 88.2981 18.0899 88.1632L17.3374 87.6889C17.2997 87.6644 17.2734 87.6398 17.2471 87.6112C17.1304 87.742 17.1605 87.9097 17.3374 88.0201V88.0242ZM31.0632 73.5657C31.2702 73.6965 31.6088 73.6965 31.8195 73.5657L32.5984 73.075C32.7752 72.9646 32.8015 72.7969 32.6849 72.6702C32.6623 72.6947 32.636 72.7192 32.5984 72.7438L31.8195 73.2345C31.6088 73.3653 31.2702 73.3653 31.0632 73.2345C31.0294 73.214 31.003 73.1895 30.9805 73.1649C30.8638 73.2917 30.8902 73.4593 31.0632 73.5657ZM36.4287 77.4747L37.1849 77.0004C37.3618 76.89 37.3919 76.7182 37.2752 76.5874C37.2489 76.616 37.2226 76.6405 37.1849 76.6651L36.4287 77.1394C36.2142 77.2743 35.8643 77.2743 35.6498 77.1394L34.8973 76.6651C34.8597 76.6405 34.8333 76.616 34.807 76.5874C34.6904 76.7182 34.7205 76.8859 34.8973 76.9963L35.6498 77.4706C35.8643 77.6055 36.2104 77.6055 36.4287 77.4706V77.4747ZM37.2038 79.3106L37.8622 78.8976C38.0541 78.7791 38.0917 78.5992 37.9826 78.456C37.9525 78.4969 37.9149 78.5337 37.8622 78.5664L37.2038 78.9794C36.9592 79.1307 36.5679 79.1348 36.3271 78.9794L35.6761 78.5705C35.6235 78.5378 35.5858 78.501 35.5595 78.4642C35.4504 78.6073 35.488 78.7872 35.6761 78.9058L36.3271 79.3147C36.5679 79.466 36.9629 79.466 37.2038 79.3147V79.3106ZM18.1087 89.9214L18.7596 90.3303C19.0004 90.4816 19.3955 90.4816 19.6363 90.3303L20.2948 89.9174C20.4866 89.7988 20.5243 89.6189 20.4152 89.4758C20.3851 89.5166 20.3474 89.5534 20.2948 89.5862L19.6363 89.9991C19.3917 90.1504 19.0004 90.1504 18.7596 89.9991L18.1087 89.5902C18.056 89.5575 18.0184 89.5207 17.9921 89.4839C17.8829 89.627 17.9206 89.807 18.1087 89.9255V89.9214ZM15.9264 87.7339C15.7119 87.8688 15.362 87.8688 15.1476 87.7339L14.395 87.2595C14.3574 87.235 14.3311 87.2105 14.3047 87.1819C14.1881 87.3127 14.2182 87.4803 14.395 87.5907L15.1476 88.0651C15.362 88.2 15.7082 88.2 15.9264 88.0651L16.6827 87.5907C16.8595 87.4803 16.8896 87.3086 16.773 87.1778C16.7467 87.2064 16.7203 87.2309 16.6827 87.2555L15.9264 87.7298V87.7339ZM25.2049 77.2375C25.4119 77.3684 25.7505 77.3684 25.9612 77.2375L26.74 76.7469C26.9169 76.6365 26.9432 76.4688 26.8266 76.3421C26.804 76.3666 26.7777 76.3911 26.74 76.4157L25.9612 76.9063C25.7505 77.0372 25.4119 77.0372 25.2049 76.9063C25.171 76.8859 25.1447 76.8613 25.1221 76.8368C25.0055 76.9636 25.0318 77.1312 25.2049 77.2375ZM27.1577 76.0149C27.3646 76.1458 27.7033 76.1458 27.914 76.0149L28.6928 75.5243C28.8697 75.4139 28.896 75.2462 28.7794 75.1195C28.7568 75.144 28.7304 75.1685 28.6928 75.1931L27.914 75.6837C27.7033 75.8146 27.3646 75.8146 27.1577 75.6837C27.1238 75.6633 27.0975 75.6387 27.0749 75.6142C26.9583 75.741 26.9846 75.9086 27.1577 76.0149ZM15.4486 83.3628C15.6555 83.4936 15.9941 83.4936 16.2048 83.3628L16.9837 82.8721C17.1605 82.7617 17.1869 82.5941 17.0702 82.4673C17.0477 82.4918 17.0213 82.5164 16.9837 82.5409L16.2048 83.0316C15.9941 83.1624 15.6555 83.1624 15.4486 83.0316C15.4147 83.0111 15.3884 82.9866 15.3658 82.9621C15.2491 83.0888 15.2755 83.2565 15.4486 83.3628ZM23.2559 78.4642C23.4628 78.5951 23.8015 78.5951 24.0122 78.4642L24.791 77.9735C24.9679 77.8631 24.9942 77.6955 24.8776 77.5687C24.855 77.5933 24.8287 77.6178 24.791 77.6423L24.0122 78.133C23.8015 78.2639 23.4628 78.2639 23.2559 78.133C23.222 78.1126 23.1957 78.088 23.1731 78.0635C23.0565 78.1903 23.0828 78.3579 23.2559 78.4642ZM29.1105 74.7923C29.3174 74.9232 29.656 74.9232 29.8667 74.7923L30.6456 74.3017C30.8224 74.1913 30.8488 74.0236 30.7321 73.8969C30.7096 73.9214 30.6832 73.9459 30.6456 73.9705L29.8667 74.4611C29.656 74.592 29.3174 74.592 29.1105 74.4611C29.0766 74.4407 29.0503 74.4162 29.0277 74.3916C28.911 74.5184 28.9374 74.686 29.1105 74.7923ZM21.3031 79.6909C21.5101 79.8217 21.8487 79.8217 22.0594 79.6909L22.8383 79.2002C23.0151 79.0898 23.0414 78.9222 22.9248 78.7954C22.9022 78.82 22.8759 78.8445 22.8383 78.869L22.0594 79.3597C21.8487 79.4905 21.5101 79.4905 21.3031 79.3597C21.2693 79.3392 21.2429 79.3147 21.2203 79.2902C21.1037 79.4169 21.13 79.5846 21.3031 79.6909ZM36.1578 75.0459L35.4843 75.4711C35.2472 75.6224 34.8597 75.6224 34.6226 75.4711L33.9529 75.0499C33.904 75.0213 33.8701 74.9845 33.84 74.9477C33.7309 75.0908 33.7648 75.2667 33.9529 75.3811L34.6226 75.8023C34.8597 75.9495 35.2435 75.9495 35.4843 75.8023L36.1578 75.3771C36.3459 75.2585 36.3835 75.0827 36.2744 74.9395C36.2443 74.9763 36.2067 75.0131 36.1578 75.0459ZM19.3503 80.9135C19.5573 81.0443 19.8959 81.0443 20.1066 80.9135L20.8855 80.4228C21.0623 80.3124 21.0887 80.1448 20.972 80.018C20.9494 80.0425 20.9231 80.0671 20.8855 80.0916L20.1066 80.5823C19.8959 80.7131 19.5573 80.7131 19.3503 80.5823C19.3165 80.5618 19.2901 80.5373 19.2676 80.5128C19.1509 80.6395 19.1773 80.8072 19.3503 80.9135Z",
    fill: "url(#paint81_linear_2_901)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3707 83.2567L50.3885 71.2761C49.8806 70.9571 49.6247 70.5319 49.6172 70.0821C49.6172 70.0657 49.6172 68.5365 49.6172 68.5242C49.6247 67.9804 49.9972 68.9249 50.7083 68.4792L67.369 61.5158C68.6897 60.6857 70.6876 60.5957 71.8276 61.3154L84.5865 69.4361C84.9665 69.6773 85.245 68.6592 85.3428 68.9822C85.3767 69.0885 85.3541 70.5155 85.3579 70.6259C85.3691 71.182 85.0004 71.7749 84.2667 72.2329L73.8331 83.0563C72.5124 83.8864 70.5183 83.9763 69.3744 83.2567H69.3707Z",
    fill: "url(#paint82_linear_2_901)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3718 81.7272L50.3896 69.7465C49.2458 69.031 49.3888 67.7757 50.7094 66.9497L67.3701 59.9862C68.6907 59.1562 70.6887 59.0662 71.8287 59.7859L84.5876 67.9065C85.7314 68.6221 85.5884 69.8774 84.2678 70.7033L73.8342 81.5268C72.5135 82.3568 70.5194 82.4468 69.3755 81.7272H69.3718Z",
    fill: "url(#paint83_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.82,
    d: "M84.5806 67.9064L71.8217 59.7857C70.6779 59.0702 68.6837 59.1601 67.363 59.9861L58.9688 63.4944C59.0478 63.5639 59.1305 63.6294 59.2284 63.6907L78.2105 75.6713C78.4739 75.8349 78.7825 75.9575 79.1173 76.0352L84.257 70.7032C85.5777 69.8732 85.7206 68.622 84.5768 67.9064H84.5806Z",
    fill: "url(#paint84_linear_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M84.2641 70.4457L73.8305 81.2691C72.5098 82.0992 70.5157 82.1891 69.3719 81.4695L50.3897 69.4888C49.9156 69.1904 49.6673 68.8019 49.6259 68.3889C49.5657 68.8959 49.8178 69.3907 50.3897 69.7505L69.3719 81.7312C70.5157 82.4467 72.5136 82.3568 73.8305 81.5308L84.2641 70.7073C85.0354 70.2208 85.4042 69.5952 85.3477 69.0104C85.2875 69.5175 84.9226 70.0327 84.2641 70.4497V70.4457Z",
    fill: "url(#paint85_radial_2_901)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1761 81.7927L47.5579 52.52C45.1761 51.0234 43.2422 47.0121 43.2422 43.5611V4.81011C43.2422 1.35495 45.1761 -0.231564 47.5579 1.26499L94.1761 30.5378C96.5578 32.0343 98.4918 36.0456 98.4918 39.4967V78.2435C98.4918 81.6987 96.5578 83.2852 94.1761 81.7886V81.7927Z",
    fill: "url(#paint86_linear_2_901)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7318 79.0941L48.7682 50.2384C46.8493 48.9136 45.6641 46.2681 45.6641 43.5571V4.55669C45.6641 3.91473 46.3075 3.5181 46.8154 3.84113C46.8756 3.87793 46.9208 3.91064 46.9509 3.927L92.9633 32.8195C95.2472 34.2506 96.0675 36.7899 96.0675 39.5009V78.3786C96.0675 79.0655 95.3827 79.4989 94.8333 79.1555C94.7882 79.1269 94.7543 79.1064 94.7318 79.0941Z",
    fill: "url(#paint87_linear_2_901)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9633 32.8195L46.9509 3.927C46.9208 3.91064 46.8756 3.87793 46.8154 3.84113C46.3075 3.5181 45.6641 3.91473 45.6641 4.55669V43.5571C45.6641 46.264 46.8493 48.9136 48.7682 50.2384L94.7318 79.0941C94.7543 79.1064 94.7882 79.1309 94.8333 79.1555C95.3827 79.4949 96.0675 79.0655 96.0675 78.3786V39.5009C96.0675 36.794 95.2472 34.2506 92.9633 32.8195ZM95.5821 78.3786C95.5821 78.6076 95.4053 78.7507 95.2397 78.7507C95.1833 78.7507 95.1268 78.7343 95.0704 78.7016L49.009 49.7846C47.2782 48.5865 46.1457 46.1413 46.1457 43.5612V4.55669C46.1457 4.3686 46.2924 4.25411 46.4279 4.25411C46.4768 4.25411 46.5219 4.27047 46.5671 4.295L92.715 33.2775C95.0817 34.7577 95.5783 37.4809 95.5783 39.5009V78.3786H95.5821Z",
    fill: "#BCBEC0"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.391 29.8346L48.7727 0.561785C47.8283 -0.031113 46.9592 -0.137426 46.2481 0.156979C46.1578 0.193779 44.9537 0.8889 44.871 0.942057H44.8672C45.6009 0.557696 46.534 0.631297 47.5499 1.26917L94.1682 30.542C96.5499 32.0385 98.4838 36.0498 98.4838 39.5008V78.2477C98.4838 80.4026 97.7313 81.8296 96.5875 82.2385C96.6816 82.2426 96.7982 82.2058 96.9638 82.0995C97.0164 82.0668 98.3258 81.2654 98.3747 81.2245C99.195 80.5989 99.7067 79.319 99.7067 77.5444V38.7934C99.7067 35.3383 97.7727 31.327 95.391 29.8346Z",
    fill: "url(#paint88_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M94.3823 30.4271L47.764 1.15431C46.7857 0.540969 45.8865 0.455101 45.1641 0.794484C45.7811 0.688171 46.4922 0.851729 47.2448 1.32605L93.863 30.5988C96.2447 32.0954 98.1787 36.1066 98.1787 39.5618V78.3087C98.1787 80.345 97.5014 81.727 96.463 82.2136C97.7949 81.9846 98.6979 80.4963 98.6979 78.1369V39.3901C98.6979 35.9349 96.764 31.9236 94.3823 30.4271Z",
    fill: "url(#paint89_radial_2_901)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4227 58.572L47.4922 29.2665V10.167L94.4227 39.4725V58.572Z",
    fill: "url(#paint90_linear_2_901)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M54.4267 11.97C54.4267 12.5629 54.0429 12.8 53.5688 12.5015C53.0947 12.203 52.7109 11.4834 52.7109 10.8905C52.7109 10.2976 53.0947 10.0604 53.5688 10.3589C54.0429 10.6574 54.4267 11.3771 54.4267 11.97Z",
    fill: "url(#paint91_linear_2_901)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7157 10.3264C51.7157 10.9193 51.3319 11.1565 50.8579 10.858C50.3838 10.5595 50 9.83983 50 9.24693C50 8.65404 50.3838 8.41688 50.8579 8.71537C51.3319 9.01386 51.7157 9.73352 51.7157 10.3264Z",
    fill: "url(#paint92_linear_2_901)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9814 8.64575C48.9814 9.23865 48.5976 9.47581 48.1235 9.17732C47.6494 8.87882 47.2656 8.15917 47.2656 7.56627C47.2656 6.97337 47.6494 6.73621 48.1235 7.03471C48.5976 7.3332 48.9814 8.05286 48.9814 8.64575Z",
    fill: "url(#paint93_linear_2_901)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6328 34.6432L94.4414 37.6608V36.2379L89.6328 33.2202V34.6432Z",
    fill: "#9F79C8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 30.7425L88.3086 33.7602V32.3372L83.5 29.3196V30.7425Z",
    fill: "#9F79C8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0357 48.3904L47.5234 39.2107V31.2004L62.0357 40.3842V48.3904Z",
    fill: "url(#paint94_linear_2_901)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0108 51.273L47.5625 42.1301V40.7153L62.0108 49.8582V51.273Z",
    fill: "#8969C3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0108 52.8715L47.5625 43.7286V43.0867L62.0108 52.2296V52.8715Z",
    fill: "#8969C3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0108 54.217L47.5625 45.0741V44.4321L62.0108 53.575V54.217Z",
    fill: "#8969C3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0108 55.5622L47.5625 46.4193V45.7773L62.0108 54.9202V55.5622Z",
    fill: "#8969C3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2075 58.7273L63.6953 49.5476V41.5374L78.2075 50.7211V58.7273Z",
    fill: "url(#paint95_linear_2_901)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1748 61.6138L63.7266 52.4709V51.0562L78.1748 60.199V61.6138Z",
    fill: "#8969C3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1748 63.2128L63.7266 54.0699V53.4238L78.1748 62.5667V63.2128Z",
    fill: "#8969C3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1748 64.5537L63.7266 55.4149V54.7688L78.1748 63.9117V64.5537Z",
    fill: "#8969C3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1748 65.8991L63.7266 56.7603V56.1143L78.1748 65.2571V65.8991Z",
    fill: "#8969C3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4092 36.9003L63.9609 27.7615V26.3467L78.4092 35.4855V36.9003Z",
    fill: "#D1B4E3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5667 40.7274L60.3984 27.3402V26.6982L81.5667 40.0855V40.7274Z",
    fill: "#D1B4E3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M67.6913 34.4717C67.0103 34.0464 66.4609 34.3858 66.4609 35.2322V37.105C66.4609 37.9514 67.0103 38.9859 67.6913 39.4111L74.9568 43.9499C75.6378 44.3751 76.4355 43.9907 76.4355 43.1443V41.2716C76.4355 40.4252 75.6378 39.4357 74.9568 39.0104L67.6913 34.4717Z",
    fill: "url(#paint96_linear_2_901)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M67.6525 34.5331C66.9753 34.1078 66.4297 34.4472 66.4297 35.2895V37.0682C66.4297 37.9105 66.979 38.9369 67.6525 39.3621L74.8767 43.8763C75.5539 44.3016 76.3253 43.9213 76.3253 43.079V41.3003C76.3253 40.4579 75.5539 39.4684 74.8767 39.0432L67.6525 34.529V34.5331Z",
    fill: "url(#paint97_linear_2_901)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M67.6019 34.5901C66.9284 34.1689 66.3828 34.5042 66.3828 35.3466V37.0312C66.3828 37.8694 66.9284 38.8917 67.6019 39.3128L74.7846 43.8025C75.4581 44.2237 76.2031 43.8516 76.2031 43.0133V41.3287C76.2031 40.4905 75.4581 39.5009 74.7846 39.0798L67.6019 34.5901Z",
    fill: "url(#paint98_linear_2_901)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M67.5787 34.6517C66.909 34.2306 66.3672 34.5699 66.3672 35.4041V36.9906C66.3672 37.8247 66.909 38.8429 67.5787 39.2641L74.7201 43.7251C75.3898 44.1463 76.1047 43.7782 76.1047 42.9441V41.3576C76.1047 40.5234 75.3898 39.5339 74.7201 39.1168L67.5787 34.6558V34.6517Z",
    fill: "url(#paint99_linear_2_901)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M67.5437 34.7086C66.8778 34.2915 66.3359 34.6268 66.3359 35.4569V36.9494C66.3359 37.7794 66.8778 38.7935 67.5437 39.2105L74.6475 43.6471C75.3134 44.0641 76.002 43.7043 76.002 42.8742V41.3818C76.002 40.5517 75.3134 39.5663 74.6475 39.1451L67.5437 34.7086Z",
    fill: "url(#paint100_linear_2_901)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M67.4971 34.77C66.8349 34.3529 66.2969 34.6882 66.2969 35.5142V36.9126C66.2969 37.7386 66.8349 38.7445 67.4971 39.1615L74.5595 43.5735C75.2217 43.9906 75.8839 43.6348 75.8839 42.8089V41.4104C75.8839 40.5845 75.2217 39.599 74.5595 39.182L67.4971 34.77Z",
    fill: "url(#paint101_linear_2_901)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M67.474 34.8315C66.8155 34.4186 66.2812 34.7498 66.2812 35.5716V36.876C66.2812 37.6979 66.8155 38.6997 67.474 39.1127L74.4949 43.5001C75.1534 43.9131 75.7893 43.5655 75.7893 42.7437V41.4393C75.7893 40.6174 75.1534 39.632 74.4949 39.219L67.474 34.8315Z",
    fill: "url(#paint102_linear_2_901)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M67.4233 34.8885C66.7687 34.4755 66.2344 34.8067 66.2344 35.6245V36.8349C66.2344 37.6527 66.7649 38.6504 67.4233 39.0633L74.4029 43.4262C75.0576 43.8392 75.6671 43.4958 75.6671 42.678V41.4676C75.6671 40.6498 75.0614 39.6644 74.4029 39.2555L67.4233 34.8967V34.8885Z",
    fill: "url(#paint103_linear_2_901)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M67.3924 34.9498C66.7415 34.5409 66.2109 34.868 66.2109 35.6817V36.798C66.2109 37.6117 66.7415 38.6053 67.3924 39.0142L74.3306 43.3485C74.9815 43.7574 75.5609 43.4221 75.5609 42.6084V41.4921C75.5609 40.6784 74.9815 39.693 74.3306 39.2841L67.3924 34.9498Z",
    fill: "url(#paint104_linear_2_901)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M67.3652 35.0112C66.7143 34.6023 66.1875 34.9294 66.1875 35.739V36.7613C66.1875 37.5709 66.7143 38.5563 67.3652 38.9652L74.2657 43.275C74.9167 43.6839 75.466 43.3527 75.466 42.543V41.5208C75.466 40.7112 74.9129 39.7298 74.2657 39.321L67.3652 35.0112Z",
    fill: "url(#paint105_linear_2_901)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3186 35.0686C66.6714 34.6638 66.1484 34.9868 66.1484 35.7923V36.7205C66.1484 37.526 66.6714 38.5074 67.3186 38.9122L74.1778 43.1974C74.8249 43.6022 75.3479 43.2792 75.3479 42.4737V41.5455C75.3479 40.74 74.8249 39.7586 74.1778 39.3538L67.3186 35.0686Z",
    fill: "url(#paint106_linear_2_901)"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M74.961 43.9659L66.9768 38.9733C66.42 38.6216 65.9609 37.673 65.9609 36.8634V35.6694C65.9609 34.8598 66.4162 34.4836 66.9768 34.8353L74.961 39.8279C75.5179 40.1795 75.9769 41.1282 75.9769 41.9378V43.1318C75.9769 43.9414 75.5216 44.3176 74.961 43.9659Z",
    fill: "url(#paint107_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M74.961 39.8279L66.9768 34.8353C66.42 34.4836 65.9609 34.8598 65.9609 35.6694V35.7921C65.9609 34.9825 66.4162 34.6063 66.9768 34.958L74.961 39.9506C75.5179 40.3022 75.9769 41.2508 75.9769 42.0605V41.9378C75.9769 41.1282 75.5216 40.1795 74.961 39.8279Z",
    fill: "url(#paint108_radial_2_901)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35156 70.8423L33.2 52.2049V40.0566L3.35156 58.6941V70.8423Z",
    fill: "url(#paint109_linear_2_901)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.89583 54.323C7.89583 53.9468 7.65127 53.7955 7.35026 53.9836C7.04925 54.1717 6.80469 54.6297 6.80469 55.01C6.80469 55.3902 7.04925 55.5374 7.35026 55.3493C7.65127 55.1613 7.89583 54.7033 7.89583 54.323Z",
    fill: "url(#paint110_linear_2_901)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16927 55.3697C6.16927 54.9935 5.9247 54.8422 5.6237 55.0303C5.32269 55.2184 5.07812 55.6763 5.07812 56.0566C5.07812 56.4369 5.32269 56.5841 5.6237 56.396C5.9247 56.2079 6.16927 55.7499 6.16927 55.3697Z",
    fill: "url(#paint111_linear_2_901)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4349 56.437C4.4349 56.0609 4.19033 55.9096 3.88932 56.0977C3.58832 56.2857 3.34375 56.7437 3.34375 57.124C3.34375 57.5043 3.58832 57.6515 3.88932 57.4634C4.19033 57.2753 4.4349 56.8173 4.4349 56.437Z",
    fill: "url(#paint112_linear_2_901)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2891 39.9011L33.348 37.9834V38.8871L30.2891 40.8089V39.9011Z",
    fill: "#9F79C8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3828 42.383L29.4418 40.4653V41.369L26.3828 43.2908V42.383Z",
    fill: "#9F79C8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1934 54.0853C32.1671 54.0853 32.1408 54.0935 32.1144 54.1099L31.8774 54.2612C31.7344 54.3511 31.5801 54.4492 31.5801 54.4492C31.5049 54.4942 31.4823 54.6005 31.5237 54.6782C31.5538 54.7314 31.6027 54.76 31.6592 54.76C31.6855 54.76 31.7118 54.7518 31.7382 54.7355L32.2725 54.3961C32.3477 54.3511 32.3703 54.2448 32.3289 54.1671C32.2988 54.1139 32.2499 54.0853 32.1934 54.0853ZM31.1249 54.76C31.0985 54.76 31.0722 54.7682 31.0459 54.7845L30.5116 55.1239C30.4363 55.1689 30.4137 55.2752 30.4551 55.3529C30.4852 55.4061 30.5342 55.4347 30.5906 55.4347C30.6169 55.4347 30.6433 55.4265 30.6696 55.4101L31.2039 55.0708C31.2791 55.0258 31.3017 54.9195 31.2603 54.8418C31.2302 54.7886 31.1813 54.76 31.1249 54.76ZM30.0563 55.4347C30.03 55.4347 30.0036 55.4429 29.9773 55.4592L29.443 55.7986C29.3678 55.8436 29.3452 55.9499 29.3866 56.0276C29.4167 56.0807 29.4656 56.1094 29.522 56.1094C29.5484 56.1094 29.5747 56.1012 29.601 56.0848L30.1353 55.7454C30.2106 55.7005 30.2331 55.5941 30.1918 55.5165C30.1617 55.4633 30.1127 55.4347 30.0563 55.4347ZM28.9877 56.1094C28.9614 56.1094 28.9351 56.1175 28.9087 56.1339L28.3744 56.4733C28.2992 56.5182 28.2766 56.6246 28.318 56.7022C28.3481 56.7554 28.397 56.784 28.4534 56.784C28.4798 56.784 28.5061 56.7759 28.5325 56.7595L29.0667 56.4201C29.142 56.3751 29.1646 56.2688 29.1232 56.1911C29.0931 56.138 29.0442 56.1094 28.9877 56.1094ZM27.9192 56.784C27.8928 56.784 27.8665 56.7922 27.8402 56.8086C27.8402 56.8086 27.7235 56.8822 27.5993 56.9599H27.5918L27.3021 57.1439C27.2269 57.1888 27.2043 57.2952 27.2457 57.3728C27.2758 57.426 27.3247 57.4546 27.3811 57.4546C27.4075 57.4546 27.4338 57.4464 27.4601 57.4301L27.9944 57.0907C28.0697 57.0457 28.0922 56.9394 28.0509 56.8617C28.0208 56.8086 27.9718 56.7799 27.9154 56.7799L27.9192 56.784ZM26.8506 57.4587C26.8243 57.4587 26.7979 57.4669 26.7716 57.4832L26.5007 57.655C26.369 57.7408 26.2411 57.8226 26.2411 57.8226C26.1658 57.8676 26.1432 57.9739 26.1846 58.0516C26.2147 58.1048 26.2636 58.1334 26.3201 58.1334C26.3464 58.1334 26.3727 58.1252 26.3991 58.1088L26.9334 57.7695C27.0086 57.7245 27.0312 57.6182 26.9898 57.5405C26.9597 57.4873 26.9108 57.4587 26.8544 57.4587H26.8506ZM25.782 58.1334C25.7557 58.1334 25.7293 58.1416 25.703 58.1579C25.703 58.1579 25.5525 58.252 25.4095 58.3419H25.402L25.1725 58.485C25.0972 58.53 25.0747 58.6363 25.116 58.714C25.1461 58.7672 25.1951 58.7958 25.2515 58.7958C25.2778 58.7958 25.3042 58.7876 25.3305 58.7713L25.8648 58.4319C25.9401 58.3869 25.9626 58.2806 25.9212 58.2029C25.8911 58.1497 25.8422 58.1211 25.7858 58.1211L25.782 58.1334ZM24.7135 58.8081C24.6871 58.8081 24.6608 58.8162 24.6344 58.8326L24.1002 59.172C24.0287 59.217 24.0023 59.3233 24.0437 59.401C24.0738 59.4541 24.1227 59.4827 24.1792 59.4827C24.2055 59.4827 24.2318 59.4746 24.2582 59.4582L24.7925 59.1188C24.8677 59.0738 24.8903 58.9675 24.8489 58.8898C24.8188 58.8367 24.7699 58.8081 24.7135 58.8081ZM24.1152 59.585C24.0287 59.585 23.9609 59.6586 23.9609 59.7526V60.4232C23.9609 60.5172 24.0287 60.5908 24.1152 60.5908C24.2017 60.5908 24.2695 60.5172 24.2695 60.4232V59.7526C24.2695 59.6586 24.2017 59.585 24.1152 59.585ZM24.1152 60.9302C24.0287 60.9302 23.9609 61.0038 23.9609 61.0979V61.7685C23.9609 61.8625 24.0287 61.9361 24.1152 61.9361C24.2017 61.9361 24.2695 61.8625 24.2695 61.7685V61.0979C24.2695 61.0038 24.2017 60.9302 24.1152 60.9302ZM24.1152 62.2755C24.0287 62.2755 23.9609 62.3491 23.9609 62.4431V63.1137C23.9609 63.2078 24.0287 63.2814 24.1152 63.2814C24.2017 63.2814 24.2695 63.2078 24.2695 63.1137V62.4431C24.2695 62.3491 24.2017 62.2755 24.1152 62.2755ZM24.1152 63.6208C24.0287 63.6208 23.9609 63.6944 23.9609 63.7884V64.459C23.9609 64.553 24.0287 64.6266 24.1152 64.6266C24.2017 64.6266 24.2695 64.553 24.2695 64.459V63.7884C24.2695 63.6944 24.2017 63.6208 24.1152 63.6208ZM24.1152 64.966C24.0287 64.966 23.9609 65.0396 23.9609 65.1337V65.8043C23.9609 65.8983 24.0287 65.9719 24.1152 65.9719C24.2017 65.9719 24.2695 65.8983 24.2695 65.8043V65.1337C24.2695 65.0396 24.2017 64.966 24.1152 64.966ZM24.1152 66.3113C24.0287 66.3113 23.9609 66.3849 23.9609 66.4789V67.1495C23.9609 67.2436 24.0287 67.3172 24.1152 67.3172C24.2017 67.3172 24.2695 67.2436 24.2695 67.1495V66.4789C24.2695 66.3849 24.2017 66.3113 24.1152 66.3113ZM24.1152 67.6565C24.0287 67.6565 23.9609 67.7301 23.9609 67.8242V68.4948C23.9609 68.5888 24.0287 68.6624 24.1152 68.6624C24.2017 68.6624 24.2695 68.5888 24.2695 68.4948V67.8242C24.2695 67.7301 24.2017 67.6565 24.1152 67.6565ZM24.3259 68.691C24.2996 68.691 24.2732 68.6992 24.2469 68.7156L23.9609 68.8955V69.2839L24.4049 69.0018C24.4802 68.9568 24.5027 68.8505 24.4614 68.7728C24.4313 68.7197 24.3823 68.691 24.3259 68.691ZM25.3945 68.0164C25.3681 68.0164 25.3418 68.0246 25.3155 68.0409L24.7812 68.3803C24.7059 68.4253 24.6834 68.5316 24.7247 68.6093C24.7548 68.6624 24.8038 68.691 24.8602 68.691C24.8865 68.691 24.9129 68.6829 24.9392 68.6665C24.9392 68.6665 25.4396 68.3517 25.4735 68.3312C25.5487 68.2862 25.5713 68.1799 25.5299 68.1022C25.4998 68.0491 25.4509 68.0205 25.3945 68.0205V68.0164ZM26.463 67.3417C26.4367 67.3417 26.4104 67.3499 26.384 67.3662L25.8497 67.7056C25.7745 67.7506 25.7519 67.8569 25.7933 67.9346C25.8234 67.9877 25.8723 68.0164 25.9288 68.0164C25.9551 68.0164 25.9814 68.0082 26.0078 67.9918C26.0078 67.9918 26.0304 67.9796 26.0642 67.9591L26.5458 67.6565C26.6211 67.6116 26.6437 67.5053 26.6023 67.4276C26.5722 67.3744 26.5232 67.3458 26.4668 67.3458L26.463 67.3417ZM27.5316 66.667C27.5053 66.667 27.4789 66.6752 27.4526 66.6916L26.9183 67.0309C26.8431 67.0759 26.8205 67.1822 26.8619 67.2599C26.892 67.3131 26.9409 67.3417 26.9973 67.3417C27.0237 67.3417 27.05 67.3335 27.0763 67.3172L27.2871 67.1822C27.4376 67.0882 27.6106 66.9778 27.6106 66.9778C27.6859 66.9328 27.7085 66.8265 27.6671 66.7488C27.637 66.6956 27.5881 66.667 27.5316 66.667ZM28.6002 65.9923C28.5739 65.9923 28.5475 66.0005 28.5212 66.0169L27.9869 66.3563C27.9116 66.4012 27.8891 66.5076 27.9305 66.5852C27.9606 66.6384 28.0095 66.667 28.0659 66.667C28.0922 66.667 28.1186 66.6588 28.1449 66.6425L28.6792 66.3031C28.7545 66.2581 28.777 66.1518 28.7356 66.0741C28.7055 66.021 28.6566 65.9923 28.6002 65.9923ZM29.6688 65.3177C29.6424 65.3177 29.6161 65.3258 29.5897 65.3422L29.0555 65.6816C28.9802 65.7266 28.9576 65.8329 28.999 65.9106C29.0291 65.9637 29.078 65.9923 29.1345 65.9923C29.1608 65.9923 29.1871 65.9842 29.2135 65.9678L29.7478 65.6284C29.823 65.5834 29.8456 65.4771 29.8042 65.3994C29.7741 65.3463 29.7252 65.3177 29.6688 65.3177ZM30.7373 64.643C30.711 64.643 30.6847 64.6512 30.6583 64.6675L30.124 65.0069C30.0488 65.0519 30.0262 65.1582 30.0676 65.2359C30.0977 65.289 30.1466 65.3177 30.203 65.3177C30.2294 65.3177 30.2557 65.3095 30.2821 65.2931L30.8163 64.9537C30.8916 64.9088 30.9142 64.8025 30.8728 64.7248C30.8427 64.6716 30.7938 64.643 30.7373 64.643ZM31.8059 63.9683C31.7796 63.9683 31.7532 63.9765 31.7269 63.9928L31.1926 64.3322C31.1173 64.3772 31.0948 64.4835 31.1362 64.5612C31.1663 64.6144 31.2152 64.643 31.2716 64.643C31.298 64.643 31.3243 64.6348 31.3506 64.6185L31.8849 64.2791C31.9602 64.2341 31.9827 64.1278 31.9414 64.0501C31.9113 63.9969 31.8623 63.9683 31.8059 63.9683ZM32.8745 63.2936C32.8481 63.2936 32.8218 63.3018 32.7955 63.3182L32.2612 63.6576C32.1859 63.7025 32.1633 63.8088 32.2047 63.8865C32.2348 63.9397 32.2837 63.9683 32.3402 63.9683C32.3665 63.9683 32.3929 63.9601 32.4192 63.9438L32.6224 63.817C32.6224 63.817 32.6224 63.817 32.6261 63.8129C32.6261 63.8129 32.6299 63.8129 32.6337 63.8129C32.7804 63.7189 32.9497 63.6126 32.9497 63.6126C33.025 63.5676 33.0475 63.4613 33.0062 63.3836C32.9761 63.3304 32.9271 63.3018 32.8707 63.3018L32.8745 63.2936ZM33.0287 62.2387C32.9422 62.2387 32.8745 62.3123 32.8745 62.4063V63.0769C32.8745 63.171 32.9422 63.2446 33.0287 63.2446C33.1153 63.2446 33.183 63.171 33.183 63.0769V62.4063C33.183 62.3123 33.1153 62.2387 33.0287 62.2387ZM33.0287 60.8934C32.9422 60.8934 32.8745 60.967 32.8745 61.0611V61.7317C32.8745 61.8257 32.9422 61.8993 33.0287 61.8993C33.1153 61.8993 33.183 61.8257 33.183 61.7317V61.0611C33.183 60.967 33.1153 60.8934 33.0287 60.8934ZM33.0287 59.5482C32.9422 59.5482 32.8745 59.6218 32.8745 59.7158V60.3864C32.8745 60.4804 32.9422 60.554 33.0287 60.554C33.1153 60.554 33.183 60.4804 33.183 60.3864V59.7158C33.183 59.6218 33.1153 59.5482 33.0287 59.5482ZM33.0287 58.2029C32.9422 58.2029 32.8745 58.2765 32.8745 58.3705V59.0411C32.8745 59.1352 32.9422 59.2088 33.0287 59.2088C33.1153 59.2088 33.183 59.1352 33.183 59.0411V58.3705C33.183 58.2765 33.1153 58.2029 33.0287 58.2029ZM33.0287 56.8576C32.9422 56.8576 32.8745 56.9312 32.8745 57.0253V57.6959C32.8745 57.7899 32.9422 57.8635 33.0287 57.8635C33.1153 57.8635 33.183 57.7899 33.183 57.6959V57.0253C33.183 56.9312 33.1153 56.8576 33.0287 56.8576ZM33.0287 55.5124C32.9422 55.5124 32.8745 55.586 32.8745 55.68V56.3506C32.8745 56.4446 32.9422 56.5182 33.0287 56.5182C33.1153 56.5182 33.183 56.4446 33.183 56.3506V55.68C33.183 55.586 33.1153 55.5124 33.0287 55.5124ZM33.0287 54.1671C32.9422 54.1671 32.8745 54.2407 32.8745 54.3347V55.0053C32.8745 55.0994 32.9422 55.173 33.0287 55.173C33.1153 55.173 33.183 55.0994 33.183 55.0053V54.3347C33.183 54.2407 33.1153 54.1671 33.0287 54.1671ZM33.183 53.4311L32.8745 53.6274C32.7578 53.701 32.6487 53.7705 32.6487 53.7705C32.5735 53.8155 32.5509 53.9218 32.5923 53.9995C32.6224 54.0526 32.6713 54.0812 32.7277 54.0812C32.7541 54.0812 32.7804 54.0731 32.8067 54.0567L33.1868 53.8155V53.427L33.183 53.4311Z",
    fill: "#C7BCD6"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M13.6641 70.9446L22.8937 65.1015V60.0107L13.6641 65.8498V70.9446Z",
    fill: "url(#paint113_linear_2_901)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6641 72.7761L22.856 66.9616V66.062L13.6641 71.8765V72.7761Z",
    fill: "#8969C3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6641 73.7942L22.856 67.9797V67.5708L13.6641 73.3853V73.7942Z",
    fill: "#8969C3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6641 74.6489L22.856 68.8344V68.4255L13.6641 74.24V74.6489Z",
    fill: "#8969C3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6641 75.5034L22.856 69.6889V69.28L13.6641 75.0945V75.5034Z",
    fill: "#8969C3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M3.40625 77.5521L12.6358 71.7131V66.6223L3.40625 72.4613V77.5521Z",
    fill: "url(#paint114_linear_2_901)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41406 79.3884L12.606 73.5739V72.6743L3.41406 78.4888V79.3884Z",
    fill: "#8969C3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41406 80.4065L12.606 74.592V74.1831L3.41406 79.9976V80.4065Z",
    fill: "#8969C3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41406 81.261L12.606 75.4465V75.0376L3.41406 80.8521V81.261Z",
    fill: "#8969C3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41406 82.1157L12.606 76.3012V75.8923L3.41406 81.7068V82.1157Z",
    fill: "#8969C3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5391 57.0581L22.731 51.2436V50.344L13.5391 56.1585V57.0581Z",
    fill: "#D1B4E3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5312 59.495L24.9937 50.9777V50.5688L11.5312 59.082V59.495Z",
    fill: "#D1B4E3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M20.3736 55.5127C20.8063 55.2429 21.1562 55.4596 21.1562 55.9993V57.1892C21.1562 57.7289 20.8063 58.3832 20.3736 58.6571L15.7531 61.5439C15.3204 61.8138 14.8125 61.5726 14.8125 61.0328V59.8429C14.8125 59.3032 15.3204 58.6735 15.7531 58.4036L20.3736 55.5168V55.5127Z",
    fill: "url(#paint115_linear_2_901)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M20.3909 55.5534C20.8199 55.2835 21.1698 55.5002 21.1698 56.0359V57.1644C21.1698 57.7001 20.8199 58.3543 20.3909 58.6242L15.7968 61.4946C15.3679 61.7645 14.875 61.5232 14.875 60.9876V59.859C14.875 59.3234 15.3641 58.6937 15.7968 58.4238L20.3909 55.5534Z",
    fill: "url(#paint116_linear_2_901)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M20.4083 55.5901C20.8372 55.3202 21.1834 55.5369 21.1834 56.0685V57.1398C21.1834 57.6714 20.8372 58.3215 20.4083 58.5914L15.8405 61.4455C15.4116 61.7153 14.9375 61.4782 14.9375 60.9425V59.8712C14.9375 59.3397 15.4116 58.71 15.8405 58.4401L20.4083 55.586V55.5901Z",
    fill: "url(#paint117_linear_2_901)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M20.4375 55.6269C20.8627 55.3611 21.2088 55.5737 21.2088 56.1053V57.1153C21.2088 57.6468 20.8627 58.2929 20.4375 58.5586L15.8961 61.3964C15.4709 61.6622 15.0156 61.4291 15.0156 60.9016V59.8916C15.0156 59.3601 15.4709 58.7345 15.8961 58.4646L20.4375 55.6269Z",
    fill: "url(#paint118_linear_2_901)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M20.4508 55.6636C20.876 55.3978 21.2184 55.6104 21.2184 56.1379V57.0865C21.2184 57.614 20.876 58.2601 20.4508 58.5259L15.9319 61.3472C15.5068 61.613 15.0703 61.384 15.0703 60.8566V59.9079C15.0703 59.3805 15.5105 58.7507 15.9319 58.485L20.4508 55.6636Z",
    fill: "url(#paint119_linear_2_901)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M20.4838 55.7049C20.9052 55.4391 21.2476 55.6517 21.2476 56.1792V57.0706C21.2476 57.598 20.9052 58.2359 20.4838 58.5017L15.9913 61.3067C15.5698 61.5725 15.1484 61.3476 15.1484 60.8201V59.9287C15.1484 59.4013 15.5698 58.7757 15.9913 58.5099L20.4838 55.7049Z",
    fill: "url(#paint120_linear_2_901)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M20.5089 55.7415C20.9266 55.4798 21.269 55.6883 21.269 56.2117V57.0418C21.269 57.5652 20.9303 58.203 20.5089 58.4647L16.0428 61.2534C15.6251 61.5151 15.2188 61.2943 15.2188 60.7709V59.9408C15.2188 59.4175 15.6213 58.7918 16.0428 58.5302L20.5089 55.7415Z",
    fill: "url(#paint121_linear_2_901)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M20.5303 55.7782C20.948 55.5165 21.2866 55.7251 21.2866 56.2444V57.0131C21.2866 57.5324 20.948 58.1662 20.5303 58.4279L16.0905 61.2002C15.6728 61.4619 15.2891 61.2451 15.2891 60.7258V59.9571C15.2891 59.4378 15.6766 58.8122 16.0905 58.5505L20.5303 55.7782Z",
    fill: "url(#paint122_linear_2_901)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M20.5477 55.819C20.9616 55.5573 21.3002 55.7658 21.3002 56.2851V56.9966C21.3002 57.5159 20.9653 58.1456 20.5477 58.4073L16.1342 61.1632C15.7203 61.4249 15.3516 61.2082 15.3516 60.693V59.9815C15.3516 59.4622 15.7203 58.8366 16.1342 58.579L20.5477 55.8231V55.819Z",
    fill: "url(#paint123_linear_2_901)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M20.5728 55.8561C20.9867 55.5985 21.3216 55.803 21.3216 56.3182V56.9683C21.3216 57.4835 20.9867 58.1091 20.5728 58.3708L16.1857 61.1104C15.7718 61.368 15.4219 61.1595 15.4219 60.6443V59.9941C15.4219 59.4789 15.7718 58.8533 16.1857 58.5957L20.5728 55.8561Z",
    fill: "url(#paint124_linear_2_901)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M20.598 55.893C21.0081 55.6354 21.343 55.8398 21.343 56.355V56.9438C21.343 57.455 21.0081 58.0806 20.598 58.3382L16.2372 61.0614C15.8271 61.319 15.4922 61.1146 15.4922 60.5994V60.0106C15.4922 59.4994 15.8271 58.8738 16.2372 58.6162L20.598 55.893Z",
    fill: "url(#paint125_linear_2_901)"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7331 61.552L20.8126 58.3789C21.1663 58.1581 21.4597 57.553 21.4597 57.0378V56.2772C21.4597 55.762 21.17 55.5248 20.8126 55.7456L15.7331 58.9187C15.3794 59.1395 15.0859 59.7446 15.0859 60.2599V61.0204C15.0859 61.5356 15.3757 61.7728 15.7331 61.552Z",
    fill: "url(#paint126_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M15.7331 58.9189L20.8126 55.7459C21.1663 55.521 21.4597 55.7623 21.4597 56.2775V56.3552C21.4597 55.84 21.17 55.6028 20.8126 55.8236L15.7331 58.9966C15.3794 59.2215 15.0859 59.8226 15.0859 60.3378V60.2601C15.0859 59.7449 15.3757 59.1438 15.7331 58.9189Z",
    fill: "url(#paint127_radial_2_901)"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8543 106.049L82.8445 96.0225C81.4411 95.1434 80.3048 92.7841 80.3048 90.7519V54.7855C80.3048 53.751 79.5222 53.5261 79.9963 53.154C80.0151 53.1417 81.1062 52.602 81.125 52.5938C81.633 52.3812 82.1785 52.2871 82.8408 52.7042L98.8505 62.7303C100.254 63.6094 101.39 65.9688 101.39 68.001V103.967C101.39 105.047 101.07 105.816 100.559 106.167C100.529 106.188 99.2155 106.866 99.1816 106.879C98.7301 107.042 99.4676 106.437 98.8543 106.049Z",
    fill: "url(#paint128_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M98.7485 62.7711L82.7388 52.745C82.0766 52.328 98.06 63.0206 98.06 63.0206C99.4634 63.8997 100.6 66.259 100.6 68.2912C100.6 68.2912 101.288 105.088 101.288 104.008V68.0418C101.288 66.0096 100.152 63.6503 98.7485 62.7711Z",
    fill: "url(#paint129_radial_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M97.901 106.531L81.8913 96.5052C80.4879 95.6261 79.3516 93.2667 79.3516 91.2345V55.2681C79.3516 53.2359 80.4879 52.3037 81.8913 53.1828L97.901 63.2089C99.3045 64.088 100.441 66.4473 100.441 68.4795V104.446C100.441 106.478 99.3045 107.41 97.901 106.531Z",
    fill: "url(#paint130_radial_2_901)"
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6745 106.658L81.6647 96.6319C80.2613 95.7528 79.125 93.3934 79.125 91.3612V55.3948C79.125 53.3626 80.2613 52.4304 81.6647 53.3095L97.6745 63.3356C99.0779 64.2147 100.214 66.574 100.214 68.6062V104.573C100.214 106.605 99.0779 107.537 97.6745 106.658Z",
    fill: "url(#paint131_linear_2_901)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4766 91.6023V55.595C79.4766 53.8163 80.4736 52.9944 81.7002 53.7673L97.6423 63.7525C98.8726 64.5253 99.8659 66.5902 99.8659 68.373V104.38C99.8659 106.159 98.8689 106.981 97.6423 106.208L81.7002 96.2228C80.4699 95.45 79.4766 93.3851 79.4766 91.6023Z",
    fill: "url(#paint132_linear_2_901)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9318 67.5389L81.5383 57.2716C81.3464 57.153 81.1094 57.3002 81.1094 57.5414V90.069C81.1094 90.298 81.2222 90.5106 81.4066 90.6251L97.8001 100.892C97.992 101.011 98.2291 100.864 98.2291 100.623V68.095C98.2291 67.866 98.1162 67.6534 97.9318 67.5389Z",
    fill: "url(#paint133_linear_2_901)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0936 100.782L81.7001 90.5145C81.5157 90.4001 81.4029 90.1874 81.4029 89.9584V57.4309C81.4029 57.3573 81.4292 57.2918 81.4668 57.2387C81.2937 57.1855 81.1094 57.3286 81.1094 57.5372V90.0648C81.1094 90.2937 81.2222 90.5064 81.4066 90.6209L97.8001 100.888C97.9318 100.97 98.0823 100.925 98.1651 100.811C98.1425 100.802 98.12 100.794 98.0974 100.782H98.0936Z",
    fill: "#939598"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4348 98.8441C90.4348 99.5024 90.0059 99.7682 89.4791 99.437C88.9486 99.1058 88.5234 98.3002 88.5234 97.6419C88.5234 96.9836 88.9524 96.7178 89.4791 97.049C90.0059 97.3802 90.4348 98.1857 90.4348 98.8441Z",
    fill: "url(#paint134_linear_2_901)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1882 98.6847C90.1882 99.1713 89.8721 99.3675 89.4808 99.1222C89.0895 98.8769 88.7734 98.284 88.7734 97.7974C88.7734 97.3108 89.0895 97.1145 89.4808 97.3599C89.8721 97.6052 90.1882 98.1981 90.1882 98.6847Z",
    fill: "url(#paint135_linear_2_901)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0374 62.4399L88.5947 60.281C88.4404 60.1828 88.3125 59.9211 88.3125 59.7003C88.3125 59.4755 88.4404 59.3732 88.5947 59.4714L92.0374 61.6303C92.1917 61.7285 92.3196 61.9902 92.3196 62.211C92.3196 62.4358 92.1917 62.5381 92.0374 62.4399Z",
    fill: "url(#paint136_linear_2_901)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M32.5531 54.5116C33.3395 54.0169 33.9754 54.4135 33.9754 55.3948V61.9371C33.9754 62.9185 33.3395 64.1125 32.5531 64.6031L25.9348 68.7452C25.1484 69.24 24.2266 68.7943 24.2266 67.813V61.2707C24.2266 60.2893 25.1484 59.1444 25.9348 58.6537L32.5531 54.5116Z",
    fill: "url(#paint137_linear_2_901)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M32.8937 54.7445C33.6801 54.2498 34.3197 54.6464 34.3197 55.6277V62.1087C34.3197 63.0901 33.6801 64.2881 32.8937 64.7829L26.2716 68.925C25.4852 69.4198 24.5859 68.9782 24.5859 67.9968V61.5158C24.5859 60.5345 25.4814 59.3814 26.2716 58.8866L32.8937 54.7445Z",
    fill: "url(#paint138_linear_2_901)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M33.2421 54.9817C34.0322 54.487 34.6718 54.8836 34.6718 55.869V62.2846C34.6718 63.27 34.0322 64.4722 33.2421 64.9669L26.6124 69.1131C25.8223 69.6079 24.9531 69.1745 24.9531 68.1849V61.7694C24.9531 60.784 25.8223 59.6227 26.6124 59.1238L33.2421 54.9776V54.9817Z",
    fill: "url(#paint139_linear_2_901)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M33.5904 55.2149C34.3843 54.716 35.0277 55.1167 35.0277 56.1063V62.4605C35.0277 63.45 34.3843 64.6563 33.5904 65.151L26.957 69.3013C26.1631 69.8002 25.3203 69.3667 25.3203 68.3772V62.023C25.3203 61.0334 26.1631 59.864 26.957 59.3652L33.5904 55.2149Z",
    fill: "url(#paint140_linear_2_901)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M33.9388 55.448C34.7327 54.9492 35.3799 55.3499 35.3799 56.3394V62.6323C35.3799 63.6259 34.7365 64.8322 33.9388 65.331L27.2979 69.4854C26.504 69.9842 25.6875 69.5549 25.6875 68.5654V62.2725C25.6875 61.2789 26.504 60.1013 27.2979 59.6024L33.9388 55.448Z",
    fill: "url(#paint141_linear_2_901)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M34.2872 55.6811C35.0849 55.1822 35.732 55.5829 35.732 56.5766V62.8081C35.732 63.8017 35.0849 65.0161 34.2872 65.515L27.6425 69.6735C26.8448 70.1723 26.0547 69.7471 26.0547 68.7534V62.5219C26.0547 61.5283 26.8448 60.3384 27.6425 59.8395L34.2872 55.6811Z",
    fill: "url(#paint142_linear_2_901)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M34.6278 55.9181C35.4292 55.4152 36.0763 55.82 36.0763 56.8177V62.9838C36.0763 63.9815 35.4292 65.2 34.6278 65.6989L27.9793 69.8574C27.1779 70.3603 26.4141 69.9391 26.4141 68.9414V62.7753C26.4141 61.7776 27.1779 60.5795 27.9793 60.0766L34.6278 55.9181Z",
    fill: "url(#paint143_linear_2_901)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M34.9761 56.1513C35.7776 55.6483 36.4285 56.0491 36.4285 57.0509V63.1557C36.4285 64.1575 35.7776 65.376 34.9761 65.883L28.3201 70.0455C27.5187 70.5485 26.7812 70.1314 26.7812 69.1296V63.0248C26.7812 62.023 27.5187 60.8168 28.3201 60.3138L34.9761 56.1513Z",
    fill: "url(#paint144_linear_2_901)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M35.3245 56.3842C36.1297 55.8772 36.7844 56.282 36.7844 57.2878V63.3313C36.7844 64.3372 36.1297 65.5598 35.3245 66.0668L28.6648 70.2335C27.8596 70.7405 27.1484 70.3234 27.1484 69.3216V63.2782C27.1484 62.2723 27.8596 61.0579 28.6648 60.5549L35.3245 56.3883V56.3842Z",
    fill: "url(#paint145_linear_2_901)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M35.6729 56.6172C36.4818 56.1102 37.1365 56.515 37.1365 57.525V63.5071C37.1365 64.513 36.4818 65.7438 35.6729 66.2508L29.0056 70.4215C28.1967 70.9286 27.5156 70.5197 27.5156 69.5097V63.5276C27.5156 62.5217 28.2004 61.2991 29.0056 60.792L35.6729 56.6213V56.6172Z",
    fill: "url(#paint146_linear_2_901)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0291 56.8545C36.838 56.3475 37.4965 56.7523 37.4965 57.7623V63.679C37.4965 64.689 36.838 65.9197 36.0291 66.4309L29.358 70.6016C28.5491 71.1086 27.8906 70.7038 27.8906 69.6938V63.7771C27.8906 62.7672 28.5491 61.5364 29.358 61.0253L36.0291 56.8545Z",
    fill: "url(#paint147_linear_2_901)"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M36.0511 56.5515C36.8638 56.0404 37.5222 56.4493 37.5222 57.4634V64.2878C37.5222 65.3019 36.8638 66.5368 36.0511 67.0479L29.3462 71.2431C28.5335 71.7543 27.875 71.3454 27.875 70.3313V63.5069C27.875 62.4928 28.5335 61.2579 29.3462 60.7468L36.0511 56.5515Z",
    fill: "url(#paint148_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M29.3462 60.7468L36.0511 56.5515C36.8638 56.0404 37.5222 56.4493 37.5222 57.4634V57.6188C37.5222 56.6047 36.8638 56.1958 36.0511 56.7069L29.3462 60.9022C28.5335 61.4133 27.875 62.6482 27.875 63.6622V63.5069C27.875 62.4928 28.5335 61.2579 29.3462 60.7468Z",
    fill: "url(#paint149_radial_2_901)"
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1719 63.1839V68.336L35.4959 64.9953V59.8433L30.1719 63.1839ZM30.5143 63.3966L35.1573 60.4852V64.7868L30.5143 67.6981V63.3966ZM30.8567 67.0603L34.8186 64.5742L33.498 64.1285L32.8395 65.0199L32.008 63.8136L30.8567 67.0603ZM34.3483 62.3989C34.3483 62.0308 34.1113 61.8836 33.814 62.0677C33.5168 62.2517 33.2798 62.6973 33.2798 63.0654C33.2798 63.4334 33.5168 63.5806 33.814 63.3966C34.1113 63.2126 34.3483 62.7669 34.3483 62.3989Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4977 82.361L82.2969 72.8583V60.7795L97.4977 70.2863V82.361Z",
    fill: "url(#paint150_linear_2_901)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3047 84.7529V84.9083V85.1332V85.4276C82.3047 85.5216 82.3724 85.5953 82.459 85.5953C82.5455 85.5953 82.6132 85.5216 82.6132 85.4276V85.3377L82.8804 85.5053C82.9029 85.5217 82.933 85.5257 82.9556 85.5257C83.0083 85.5257 83.061 85.4971 83.0911 85.4399C83.1325 85.3581 83.1099 85.2559 83.0346 85.2109L82.854 85.1005C82.775 85.0514 82.6847 84.9942 82.617 84.9492L82.3085 84.757L82.3047 84.7529ZM82.459 85.9305C82.3724 85.9305 82.3047 86.0042 82.3047 86.0982V86.7688C82.3047 86.8628 82.3724 86.9364 82.459 86.9364C82.5455 86.9364 82.6132 86.8628 82.6132 86.7688V86.0982C82.6132 86.0042 82.5455 85.9305 82.459 85.9305ZM82.459 87.2758C82.3724 87.2758 82.3047 87.3494 82.3047 87.4435V88.114C82.3047 88.2081 82.3724 88.2817 82.459 88.2817C82.5455 88.2817 82.6132 88.2081 82.6132 88.114V87.4435C82.6132 87.3494 82.5455 87.2758 82.459 87.2758ZM82.459 88.6211C82.3724 88.6211 82.3047 88.6947 82.3047 88.7887V89.4593C82.3047 89.5534 82.3724 89.627 82.459 89.627C82.5455 89.627 82.6132 89.5534 82.6132 89.4593V88.7887C82.6132 88.6947 82.5455 88.6211 82.459 88.6211ZM82.7411 89.5942C82.6885 89.5942 82.6358 89.6229 82.6057 89.6801C82.5643 89.7619 82.5869 89.8641 82.6621 89.9091L83.2002 90.2444C83.2228 90.2607 83.2491 90.2648 83.2754 90.2648C83.3281 90.2648 83.3808 90.2362 83.4109 90.179C83.4523 90.0972 83.4297 89.995 83.3544 89.95L82.8164 89.6147C82.7938 89.5983 82.7637 89.5942 82.7411 89.5942ZM83.8135 90.2648C83.7608 90.2648 83.7081 90.2935 83.678 90.3507C83.6366 90.4325 83.6592 90.5347 83.7345 90.5797L84.2725 90.915C84.2951 90.9313 84.3252 90.9354 84.3478 90.9354C84.4004 90.9354 84.4531 90.9068 84.4832 90.8496C84.5246 90.7678 84.502 90.6656 84.4268 90.6206L83.8887 90.2853C83.8662 90.2689 83.8361 90.2648 83.8135 90.2648ZM84.8858 90.9354C84.8331 90.9354 84.7805 90.964 84.7504 91.0213C84.709 91.1031 84.7315 91.2053 84.8068 91.2503L85.3448 91.5856C85.3674 91.6019 85.3938 91.606 85.4201 91.606C85.4728 91.606 85.5255 91.5774 85.5556 91.5201C85.5969 91.4384 85.5744 91.3361 85.4991 91.2912L84.9611 90.9559C84.9385 90.9395 84.9084 90.9354 84.8858 90.9354ZM85.9581 91.606C85.9055 91.606 85.8528 91.6346 85.8227 91.6919C85.7813 91.7737 85.8039 91.8759 85.8791 91.9209C85.8791 91.9209 85.9732 91.9781 86.0823 92.0476L86.4172 92.2562C86.4398 92.2725 86.4661 92.2766 86.4924 92.2766C86.5451 92.2766 86.5978 92.248 86.6279 92.1907C86.6693 92.1089 86.6467 92.0067 86.5714 91.9617L86.0334 91.6265C86.0108 91.6101 85.9807 91.606 85.9581 91.606ZM87.0305 92.2766C86.9778 92.2766 86.9251 92.3052 86.895 92.3625C86.8536 92.4442 86.8762 92.5465 86.9515 92.5914L87.4895 92.9267C87.5121 92.9431 87.5422 92.9472 87.5648 92.9472C87.6174 92.9472 87.6701 92.9186 87.7002 92.8613C87.7416 92.7795 87.719 92.6773 87.6438 92.6323L87.1057 92.297C87.0832 92.2807 87.0531 92.2766 87.0305 92.2766ZM88.1028 92.9472C88.0501 92.9472 87.9975 92.9758 87.9674 93.0331C87.926 93.1148 87.9485 93.2171 88.0238 93.262C88.0238 93.262 88.1668 93.352 88.3022 93.4379L88.5618 93.5973C88.5844 93.6137 88.6108 93.6178 88.6371 93.6178C88.6898 93.6178 88.7424 93.5891 88.7725 93.5319C88.8139 93.4501 88.7914 93.3479 88.7161 93.3029L88.1781 92.9676C88.1555 92.9513 88.1254 92.9472 88.1028 92.9472ZM89.1751 93.6178C89.1225 93.6178 89.0698 93.6464 89.0397 93.7036C88.9983 93.7854 89.0209 93.8876 89.0961 93.9326L89.6342 94.2679C89.6568 94.2843 89.6869 94.2884 89.7094 94.2884C89.7621 94.2884 89.8148 94.2597 89.8449 94.2025C89.8863 94.1207 89.8637 94.0185 89.7884 93.9735L89.2504 93.6382C89.2278 93.6219 89.1977 93.6178 89.1751 93.6178ZM90.2475 94.2884C90.1948 94.2884 90.1421 94.317 90.112 94.3742C90.0706 94.456 90.0932 94.5582 90.1685 94.6032L90.477 94.7954C90.5936 94.869 90.699 94.9344 90.699 94.9344C90.7216 94.9508 90.7517 94.9549 90.7742 94.9549C90.8269 94.9549 90.8796 94.9262 90.9097 94.869C90.9511 94.7872 90.9285 94.685 90.8533 94.64L90.3152 94.3047C90.2926 94.2884 90.2625 94.2843 90.24 94.2843L90.2475 94.2884ZM91.3198 94.9589C91.2671 94.9589 91.2145 94.9876 91.1844 95.0448C91.143 95.1266 91.1655 95.2288 91.2408 95.2738C91.2408 95.2738 91.3988 95.3719 91.5456 95.466L91.7751 95.6091C91.7977 95.6254 91.824 95.6295 91.8503 95.6295C91.903 95.6295 91.9557 95.6009 91.9858 95.5437C92.0272 95.4619 92.0046 95.3597 91.9293 95.3147L91.3913 94.9794C91.3687 94.963 91.3386 94.9589 91.3161 94.9589H91.3198ZM92.3921 95.6295C92.3395 95.6295 92.2868 95.6582 92.2567 95.7154C92.2153 95.7972 92.2379 95.8994 92.3131 95.9444L92.4862 96.0507C92.6442 96.1488 92.8512 96.2797 92.8512 96.2797C92.8738 96.296 92.9039 96.3001 92.9264 96.3001C92.9791 96.3001 93.0318 96.2715 93.0619 96.2143C93.1033 96.1325 93.0807 96.0302 93.0054 95.9853L92.4674 95.65C92.4448 95.6336 92.4147 95.6295 92.3921 95.6295ZM93.4645 96.3001C93.4118 96.3001 93.3591 96.3287 93.329 96.386C93.2876 96.4678 93.3102 96.57 93.3855 96.615C93.3855 96.615 93.7617 96.848 93.8821 96.9257L93.916 96.9462C93.9386 96.9625 93.9687 96.9666 93.9912 96.9666C94.0439 96.9666 94.0966 96.938 94.1267 96.8808C94.1681 96.799 94.1455 96.6968 94.0703 96.6518L93.5322 96.3165C93.5096 96.3001 93.4795 96.296 93.457 96.296L93.4645 96.3001ZM94.5368 96.9707C94.4841 96.9707 94.4315 96.9993 94.4014 97.0566C94.36 97.1384 94.3825 97.2406 94.4578 97.2856L94.4879 97.306C94.6083 97.3796 94.9883 97.6209 94.9883 97.6209C95.0109 97.6372 95.041 97.6413 95.0636 97.6413C95.1162 97.6413 95.1689 97.6127 95.199 97.5554C95.2404 97.4736 95.2178 97.3714 95.1426 97.3264L94.6045 96.9912C94.582 96.9748 94.5519 96.9707 94.5293 96.9707H94.5368ZM95.6091 97.6413C95.5565 97.6413 95.5038 97.6699 95.4737 97.7272C95.4323 97.8089 95.4549 97.9112 95.5301 97.9561L95.9553 98.2219C96.0193 98.2628 96.0607 98.2914 96.0607 98.2914C96.0832 98.3078 96.1133 98.3119 96.1359 98.3119C96.1886 98.3119 96.2413 98.2833 96.2714 98.226C96.3127 98.1442 96.2902 98.042 96.2149 97.997L95.6769 97.6617C95.6543 97.6454 95.6242 97.6413 95.6016 97.6413H95.6091ZM97.3512 98.132C97.2647 98.132 97.197 98.2056 97.197 98.2996V98.6063L96.7605 98.3323C96.7379 98.316 96.7078 98.3119 96.6852 98.3119C96.6326 98.3119 96.5799 98.3405 96.5498 98.3977C96.5084 98.4795 96.531 98.5818 96.6062 98.6267C96.6062 98.6267 96.6739 98.6676 96.7567 98.7208L97.1405 98.962C97.1405 98.962 97.1781 98.9784 97.197 98.9825C97.197 98.9866 97.197 98.9906 97.197 98.9988L97.4077 99.1297C97.4641 99.1051 97.5017 99.0438 97.5017 98.9743V98.3037C97.5017 98.2097 97.434 98.1361 97.3475 98.1361L97.3512 98.132ZM97.3512 96.7867C97.2647 96.7867 97.197 96.8603 97.197 96.9544V97.6249C97.197 97.719 97.2647 97.7926 97.3512 97.7926C97.4378 97.7926 97.5055 97.719 97.5055 97.6249V96.9544C97.5055 96.8603 97.4378 96.7867 97.3512 96.7867ZM97.3512 95.4414C97.2647 95.4414 97.197 95.515 97.197 95.6091V96.2797C97.197 96.3737 97.2647 96.4473 97.3512 96.4473C97.4378 96.4473 97.5055 96.3737 97.5055 96.2797V95.6091C97.5055 95.515 97.4378 95.4414 97.3512 95.4414ZM97.2797 94.1166C97.2308 94.1452 97.197 94.2025 97.197 94.2679V94.9385C97.197 95.0325 97.2647 95.1061 97.3512 95.1061C97.4378 95.1061 97.5055 95.0325 97.5055 94.9385V94.2679C97.5055 94.2679 97.5055 94.2638 97.5055 94.2597L97.2797 94.1207V94.1166ZM96.3617 93.5687C96.309 93.5687 96.2563 93.5973 96.2262 93.6546C96.1848 93.7364 96.2074 93.8386 96.2826 93.8836L96.8207 94.2188C96.8433 94.2352 96.8734 94.2393 96.8959 94.2393C96.9486 94.2393 97.0013 94.2107 97.0314 94.1534C97.0728 94.0716 97.0502 93.9694 96.975 93.9244C96.975 93.9244 96.7379 93.7772 96.5799 93.675L96.4407 93.5891C96.4181 93.5728 96.3918 93.5687 96.3654 93.5687H96.3617ZM95.2893 92.8981C95.2366 92.8981 95.184 92.9267 95.1539 92.984C95.1125 93.0658 95.1351 93.168 95.2103 93.213L95.7484 93.5483C95.7709 93.5646 95.801 93.5687 95.8236 93.5687C95.8763 93.5687 95.929 93.5401 95.9591 93.4828C96.0005 93.4011 95.9779 93.2988 95.9026 93.2539L95.8048 93.1925C95.6505 93.0944 95.3646 92.9186 95.3646 92.9186C95.342 92.9022 95.3119 92.8981 95.2893 92.8981ZM94.217 92.2275C94.1643 92.2275 94.1116 92.2562 94.0815 92.3134C94.0401 92.3952 94.0627 92.4974 94.138 92.5424L94.676 92.8777C94.6986 92.894 94.7287 92.8981 94.7513 92.8981C94.804 92.8981 94.8566 92.8695 94.8867 92.8123C94.9281 92.7305 94.9055 92.6282 94.8303 92.5833L94.3374 92.2725C94.3111 92.2561 94.296 92.248 94.296 92.248C94.2734 92.2316 94.2433 92.2275 94.2208 92.2275H94.217ZM93.1447 91.5569C93.092 91.5569 93.0393 91.5856 93.0092 91.6428C92.9678 91.7246 92.9904 91.8268 93.0656 91.8718L93.6037 92.2071C93.6263 92.2234 93.6564 92.2275 93.6789 92.2275C93.7316 92.2275 93.7843 92.1989 93.8144 92.1417C93.8558 92.0599 93.8332 91.9577 93.758 91.9127L93.2199 91.5774C93.1973 91.561 93.1672 91.5569 93.1447 91.5569ZM92.0723 90.8864C92.0196 90.8864 91.967 90.915 91.9369 90.9722C91.8955 91.054 91.9181 91.1562 91.9933 91.2012L92.5314 91.5365C92.5539 91.5528 92.584 91.5569 92.6066 91.5569C92.6593 91.5569 92.712 91.5283 92.7421 91.4711C92.7835 91.3893 92.7609 91.2871 92.6856 91.2421L92.3545 91.0336C92.2492 90.9681 92.1626 90.9109 92.1626 90.9109C92.1401 90.8945 92.1099 90.8904 92.0874 90.8904L92.0723 90.8864ZM91 90.2158C90.9473 90.2158 90.8946 90.2444 90.8645 90.3016C90.8231 90.3834 90.8457 90.4856 90.921 90.5306L91.459 90.8659C91.4816 90.8823 91.5117 90.8864 91.5343 90.8864C91.587 90.8864 91.6396 90.8577 91.6697 90.8005C91.7111 90.7187 91.6885 90.6165 91.6133 90.5715C91.6133 90.5715 91.4854 90.4897 91.3537 90.4079L91.0828 90.2403C91.0602 90.2239 91.0339 90.2199 91.0075 90.2199L91 90.2158ZM89.9277 89.5452C89.875 89.5452 89.8223 89.5738 89.7922 89.631C89.7508 89.7128 89.7734 89.8151 89.8486 89.86L90.3867 90.1953C90.4093 90.2117 90.4394 90.2158 90.4619 90.2158C90.5146 90.2158 90.5673 90.1871 90.5974 90.1299C90.6388 90.0481 90.6162 89.9459 90.541 89.9009L90.3528 89.7823H90.3491C90.1948 89.6842 90.0067 89.5656 90.0067 89.5656C89.9841 89.5493 89.954 89.5452 89.9314 89.5452H89.9277ZM88.8553 88.8746C88.8026 88.8746 88.75 88.9032 88.7199 88.9605C88.6785 89.0422 88.7011 89.1445 88.7763 89.1894L89.3144 89.5247C89.3369 89.5411 89.367 89.5452 89.3896 89.5452C89.4423 89.5452 89.495 89.5166 89.5251 89.4593C89.5665 89.3775 89.5439 89.2753 89.4686 89.2303C89.4686 89.2303 89.1827 89.0504 89.0284 88.9523L88.9419 88.8991C88.9193 88.8828 88.893 88.8787 88.8666 88.8787L88.8553 88.8746ZM87.783 88.204C87.7303 88.204 87.6776 88.2326 87.6475 88.2899C87.6062 88.3716 87.6287 88.4739 87.704 88.5189L88.242 88.8541C88.2646 88.8705 88.2947 88.8746 88.3173 88.8746C88.37 88.8746 88.4226 88.846 88.4527 88.7887C88.4941 88.7069 88.4715 88.6047 88.3963 88.5597L88.3323 88.5189C88.1894 88.4289 87.862 88.2244 87.862 88.2244C87.8394 88.2081 87.8093 88.204 87.7868 88.204H87.783ZM86.7107 87.5334C86.658 87.5334 86.6053 87.562 86.5752 87.6193C86.5338 87.7011 86.5564 87.8033 86.6316 87.8483L87.1697 88.1836C87.1923 88.1999 87.2224 88.204 87.2449 88.204C87.2976 88.204 87.3503 88.1754 87.3804 88.1181C87.4218 88.0364 87.3992 87.9341 87.324 87.8892L86.8649 87.6029C86.8198 87.5743 86.7897 87.5539 86.7897 87.5539C86.7671 87.5375 86.737 87.5334 86.7144 87.5334H86.7107ZM85.6383 86.8628C85.5857 86.8628 85.533 86.8914 85.5029 86.9487C85.4615 87.0305 85.4841 87.1327 85.5593 87.1777L86.0974 87.513C86.1199 87.5293 86.15 87.5334 86.1726 87.5334C86.2253 87.5334 86.278 87.5048 86.3081 87.4475C86.3495 87.3658 86.3269 87.2635 86.2516 87.2186C86.2516 87.2186 86.2102 87.194 86.15 87.1531L85.7211 86.8833C85.6985 86.8669 85.6722 86.8628 85.6459 86.8628H85.6383ZM84.566 86.1922C84.5133 86.1922 84.4606 86.2209 84.4305 86.2781C84.3892 86.3599 84.4117 86.4621 84.487 86.5071L85.025 86.8424C85.0476 86.8587 85.0777 86.8628 85.1003 86.8628C85.153 86.8628 85.2056 86.8342 85.2357 86.777C85.2771 86.6952 85.2545 86.593 85.1793 86.548L84.8595 86.3476C84.7428 86.274 84.6412 86.2127 84.6412 86.2127C84.6187 86.1963 84.5886 86.1922 84.566 86.1922ZM83.4937 85.5217C83.441 85.5217 83.3883 85.5503 83.3582 85.6075C83.3168 85.6893 83.3394 85.7915 83.4147 85.8365L83.9527 86.1718C83.9753 86.1882 84.0054 86.1922 84.0279 86.1922C84.0806 86.1922 84.1333 86.1636 84.1634 86.1064C84.2048 86.0246 84.1822 85.9224 84.107 85.8774C84.107 85.8774 83.9565 85.7833 83.8135 85.6934L83.5689 85.5421C83.5463 85.5257 83.52 85.5217 83.4937 85.5217Z",
    fill: "#C7BCD6"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M86.6774 61.9201C86.6774 62.2922 86.4328 62.4435 86.1356 62.2554C85.8346 62.0673 85.5938 61.6093 85.5938 61.2373C85.5938 60.8652 85.8383 60.7139 86.1356 60.902C86.4366 61.09 86.6774 61.548 86.6774 61.9201Z",
    fill: "url(#paint151_linear_2_901)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9742 60.8813C84.9742 61.2534 84.7297 61.4047 84.4324 61.2166C84.1314 61.0285 83.8906 60.5705 83.8906 60.1984C83.8906 59.8263 84.1352 59.675 84.4324 59.8631C84.7334 60.0512 84.9742 60.5092 84.9742 60.8813Z",
    fill: "url(#paint152_linear_2_901)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2399 59.8183C83.2399 60.1904 82.9953 60.3417 82.6981 60.1536C82.3971 59.9655 82.1562 59.5075 82.1562 59.1354C82.1562 58.7633 82.4008 58.6121 82.6981 58.8001C82.9991 58.9882 83.2399 59.4462 83.2399 59.8183Z",
    fill: "url(#paint153_linear_2_901)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5703 67.5011L97.6105 69.4107V68.5111L94.5703 66.6016V67.5011Z",
    fill: "#9F79C8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7109 65.0358L93.7549 66.9453V66.0458L90.7109 64.1362V65.0358Z",
    fill: "#9F79C8"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M89.4623 83.4973L82.2344 78.9136V73.6511L89.4623 78.2307V83.4973Z",
    fill: "url(#paint154_linear_2_901)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4521 85.223L82.2656 80.6638V79.7356L89.4521 84.2907V85.223Z",
    fill: "#8969C3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4521 86.2737L82.2656 81.7146V81.2893L89.4521 85.8485V86.2737Z",
    fill: "#8969C3"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4521 87.1569L82.2656 82.5977V82.1765L89.4521 86.7316V87.1569Z",
    fill: "#8969C3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4521 88.0402L82.2656 83.481V83.0598L89.4521 87.6149V88.0402Z",
    fill: "#8969C3"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M97.4898 88.678L90.2656 84.0943V78.8318L97.4898 83.4155V88.678Z",
    fill: "url(#paint155_linear_2_901)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4756 90.4036L90.2891 85.8445V84.9163L97.4756 89.4754V90.4036Z",
    fill: "#8969C3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4756 91.4547L90.2891 86.8955V86.4744L97.4756 91.0295V91.4547Z",
    fill: "#8969C3"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4756 92.3375L90.2891 87.7783V87.3572L97.4756 91.9164V92.3375Z",
    fill: "#8969C3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4756 93.2208L90.2891 88.6657V88.2405L97.4756 92.7997V93.2208Z",
    fill: "#8969C3"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3416 72.7396L85.8984 67.3953V66.5693L94.3416 71.9136V72.7396Z",
    fill: "#D1B4E3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1916 74.9762L83.8203 67.154V66.7778L96.1916 74.6V74.9762Z",
    fill: "#D1B4E3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M88.0702 71.3204C87.6714 71.071 87.3516 71.2714 87.3516 71.7661V72.862C87.3516 73.3567 87.6751 73.9619 88.0702 74.2113L92.3144 76.8651C92.7132 77.1145 93.1798 76.8896 93.1798 76.3948V75.3031C93.1798 74.8083 92.7132 74.2277 92.3144 73.9824L88.0702 71.3286V71.3204Z",
    fill: "url(#paint156_linear_2_901)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M88.0352 71.353C87.6401 71.1036 87.3203 71.304 87.3203 71.7946V72.8332C87.3203 73.328 87.6401 73.925 88.0352 74.1744L92.2568 76.8118C92.6519 77.0612 93.1034 76.8404 93.1034 76.3456V75.307C93.1034 74.8123 92.6519 74.2357 92.2568 73.9904L88.0352 71.353Z",
    fill: "url(#paint157_linear_2_901)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M88.0158 71.39C87.6245 71.1447 87.3047 71.341 87.3047 71.8316V72.8171C87.3047 73.3078 87.6245 73.9047 88.0158 74.1501L92.2148 76.7752C92.6062 77.0205 93.0426 76.8038 93.0426 76.3131V75.3277C93.0426 74.837 92.6062 74.2605 92.2148 74.0151L88.0158 71.39Z",
    fill: "url(#paint158_linear_2_901)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M88.0042 71.4226C87.6129 71.1773 87.2969 71.3736 87.2969 71.8601V72.7883C87.2969 73.2749 87.6129 73.8719 88.0042 74.1172L92.1807 76.726C92.572 76.9713 92.9896 76.7587 92.9896 76.268V75.3398C92.9896 74.8532 92.572 74.2767 92.1807 74.0314L88.0042 71.4226Z",
    fill: "url(#paint159_linear_2_901)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M87.9692 71.4595C87.5817 71.2141 87.2656 71.4104 87.2656 71.897V72.772C87.2656 73.2586 87.5817 73.8474 87.9692 74.0928L92.1193 76.6852C92.5069 76.9305 92.9132 76.7179 92.9132 76.2354V75.3603C92.9132 74.8738 92.5107 74.2972 92.1193 74.056L87.9692 71.4636V71.4595Z",
    fill: "url(#paint160_linear_2_901)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M87.9498 71.492C87.5623 71.2507 87.25 71.4429 87.25 71.9254V72.7432C87.25 73.2257 87.5623 73.8145 87.9498 74.0598L92.0774 76.64C92.4649 76.8812 92.8525 76.6768 92.8525 76.1943V75.3765C92.8525 74.894 92.4649 74.3174 92.0774 74.0762L87.9498 71.4961V71.492Z",
    fill: "url(#paint161_linear_2_901)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M87.9305 71.5291C87.5467 71.2878 87.2344 71.48 87.2344 71.9625V72.7271C87.2344 73.2096 87.5467 73.7944 87.9305 74.0356L92.0354 76.5994C92.4192 76.8406 92.7917 76.6362 92.7917 76.1578V75.3931C92.7917 74.9106 92.423 74.3382 92.0354 74.0969L87.9305 71.5332V71.5291Z",
    fill: "url(#paint162_linear_2_901)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M87.9148 71.5617C87.531 71.3204 87.2188 71.5126 87.2188 71.991V72.6984C87.2188 73.1768 87.531 73.7574 87.9148 73.9987L91.9935 76.5461C92.3772 76.7873 92.7309 76.587 92.7309 76.1086V75.4012C92.7309 74.9228 92.3772 74.3462 91.9935 74.1091L87.9148 71.5617Z",
    fill: "url(#paint163_linear_2_901)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M87.8954 71.5985C87.5154 71.3573 87.2031 71.5494 87.2031 72.0279V72.6821C87.2031 73.1564 87.5117 73.737 87.8954 73.9783L91.9515 76.5134C92.3315 76.7547 92.6701 76.5543 92.6701 76.08V75.4258C92.6701 74.9515 92.3315 74.3749 91.9515 74.1378L87.8954 71.6026V71.5985Z",
    fill: "url(#paint164_linear_2_901)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M87.8761 71.6352C87.496 71.398 87.1875 71.5861 87.1875 72.0604V72.6574C87.1875 73.1317 87.496 73.7083 87.8761 73.9454L91.9095 76.4642C92.2895 76.7014 92.6131 76.5092 92.6131 76.0349V75.4379C92.6131 74.9636 92.2895 74.3911 91.9095 74.1539L87.8761 71.6352Z",
    fill: "url(#paint165_linear_2_901)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8489 71.6681C87.4726 71.431 87.1641 71.619 87.1641 72.0934V72.6372C87.1641 73.1074 87.4688 73.6799 87.8489 73.917L91.856 76.4195C92.2322 76.6566 92.5408 76.4685 92.5408 75.9942V75.4504C92.5408 74.9802 92.236 74.4077 91.856 74.1705L87.8489 71.6681Z",
    fill: "url(#paint166_linear_2_901)"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3226 76.865L87.657 73.9496C87.3296 73.7451 87.0625 73.189 87.0625 72.7188V72.0196C87.0625 71.5453 87.3296 71.3286 87.657 71.533L92.3226 74.4484C92.6499 74.6529 92.9171 75.209 92.9171 75.6792V76.3784C92.9171 76.8527 92.6499 77.0695 92.3226 76.865Z",
    fill: "url(#paint167_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M92.3226 74.4486L87.657 71.5332C87.3296 71.3287 87.0625 71.5495 87.0625 72.0197V72.0933C87.0625 71.619 87.3296 71.4023 87.657 71.6068L92.3226 74.5222C92.6499 74.7266 92.9171 75.2827 92.9171 75.7529V75.6793C92.9171 75.205 92.6499 74.653 92.3226 74.4486Z",
    fill: "url(#paint168_radial_2_901)"
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1016 89.3855V92.3786L91.1944 94.3168V91.3237L88.1016 89.3855ZM90.995 93.9447L88.301 92.2518V89.7535L90.995 91.4463V93.9447ZM90.1296 91.6917L89.648 92.3909L89.2642 91.8716L88.4966 92.1292L90.7956 93.5726L90.1296 91.6876V91.6917ZM89.0798 91.4504C89.2491 91.5567 89.3884 91.4709 89.3884 91.2582C89.3884 91.0456 89.2491 90.7839 89.0798 90.6776C88.9105 90.5713 88.7713 90.6572 88.7713 90.8698C88.7713 91.0824 88.9105 91.3441 89.0798 91.4504Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M75.7321 67.4409C74.4566 66.6394 73.4219 67.2814 73.4219 68.872V88.7606C73.4219 90.3512 74.4566 92.2894 75.7321 93.0868L82.9148 97.4497C84.1904 98.2511 85.6879 97.5273 85.6879 95.9408V76.0522C85.6879 74.4616 84.1904 72.6052 82.9148 71.8038L75.7321 67.4409Z",
    fill: "url(#paint169_linear_2_901)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M75.5524 67.5063C74.2769 66.7049 73.2422 67.3468 73.2422 68.9374V88.7361C73.2422 90.3267 74.2769 92.2649 75.5524 93.0622L82.7389 97.4292C84.0144 98.2306 85.4668 97.5151 85.4668 95.9286V76.1299C85.4668 74.5393 84.0144 72.6747 82.7389 71.8733L75.5524 67.5063Z",
    fill: "url(#paint170_linear_2_901)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M75.3805 67.5717C74.105 66.7703 73.0703 67.4123 73.0703 69.0029V88.7157C73.0703 90.3063 74.105 92.2444 75.3805 93.0459L82.5708 97.4129C83.8463 98.2143 85.2498 97.5069 85.2498 95.9163V76.2035C85.2498 74.6129 83.8426 72.7402 82.5708 71.9387L75.3805 67.5717Z",
    fill: "url(#paint171_linear_2_901)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M75.193 67.633C73.9175 66.8316 72.8828 67.4735 72.8828 69.0641V88.6911C72.8828 90.2817 73.9175 92.2199 75.193 93.0213L82.3871 97.3924C83.6626 98.1938 85.0209 97.4946 85.0209 95.904V76.277C85.0209 74.6864 83.6626 72.8055 82.3871 72.0041L75.193 67.633Z",
    fill: "url(#paint172_linear_2_901)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M75.0212 67.6984C73.7456 66.897 72.7109 67.539 72.7109 69.1296V88.6707C72.7109 90.2613 73.7456 92.1994 75.0212 93.0008L82.219 97.376C83.4945 98.1775 84.8076 97.4864 84.8076 95.8958V76.3547C84.8076 74.7641 83.4945 72.875 82.219 72.0736L75.0212 67.6984Z",
    fill: "url(#paint173_linear_2_901)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M74.8337 67.7641C73.5581 66.9627 72.5234 67.6046 72.5234 69.1952V88.6505C72.5234 90.2411 73.5581 92.1792 74.8337 92.9807L82.0352 97.3599C83.3107 98.1614 84.5787 97.4785 84.5787 95.8879V76.4327C84.5787 74.8421 83.3107 72.9448 82.0352 72.1434L74.8337 67.7641Z",
    fill: "url(#paint174_linear_2_901)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M74.654 67.8293C73.3785 67.0279 72.3438 67.6698 72.3438 69.2604V88.6298C72.3438 90.2204 73.3785 92.1585 74.654 92.96L81.8593 97.3392C83.1348 98.1407 84.3539 97.466 84.3539 95.8754V76.506C84.3539 74.9154 83.1348 73.0059 81.8593 72.2086L74.654 67.8293Z",
    fill: "url(#paint175_linear_2_901)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M74.4821 67.895C73.2066 67.0935 72.1719 67.7355 72.1719 69.3261V88.6055C72.1719 90.1961 73.2066 92.1343 74.4821 92.9357L81.6912 97.319C82.9667 98.1205 84.1406 97.454 84.1406 95.8634V76.584C84.1406 74.9934 82.9667 73.0757 81.6912 72.2783L74.4821 67.895Z",
    fill: "url(#paint176_linear_2_901)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M74.3102 67.9562C73.0347 67.1548 72 67.7968 72 69.3874V88.5809C72 90.1715 73.0347 92.1138 74.3102 92.9111L81.5231 97.2985C82.7986 98.1 83.9274 97.4417 83.9274 95.8511V76.6575C83.9274 75.0669 82.7986 73.141 81.5231 72.3437L74.3102 67.9562Z",
    fill: "url(#paint177_linear_2_901)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M74.1305 68.0214C72.855 67.22 71.8203 67.862 71.8203 69.4526V88.5602C71.8203 90.1508 72.855 92.0931 74.1305 92.8945L81.3471 97.286C82.6227 98.0875 83.7063 97.4373 83.7063 95.8467V76.7391C83.7063 75.1485 82.6264 73.2144 81.3471 72.413L74.1305 68.0214Z",
    fill: "url(#paint178_linear_2_901)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9508 68.0871C72.6753 67.2857 71.6406 67.9276 71.6406 69.5182V88.54C71.6406 90.1306 72.6753 92.0729 73.9508 92.8743L81.1712 97.2658C82.4467 98.0673 83.4814 97.4253 83.4814 95.8347V76.8129C83.4814 75.2223 82.4467 73.2801 81.1712 72.4786L73.9508 68.0871Z",
    fill: "url(#paint179_linear_2_901)"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4392 105.161L73.1419 99.3265C72.0922 98.6681 71.2418 96.9017 71.2418 95.3847V68.4794C71.2418 67.7066 70.6586 67.5349 71.0123 67.2568C71.0274 67.2446 71.8438 66.8439 71.8589 66.8357C72.2389 66.6762 72.649 66.6067 73.1419 66.9175L82.4392 72.7524C83.489 73.4107 84.3393 75.1771 84.3393 76.6941V103.599C84.3393 104.405 84.0985 104.981 83.7185 105.247C83.6959 105.264 82.7139 105.771 82.6876 105.779C82.3489 105.901 82.902 105.448 82.443 105.157L82.4392 105.161Z",
    fill: "url(#paint180_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M82.3556 72.7811L73.0583 66.9461C72.5617 66.6354 81.8402 72.9651 81.8402 72.9651C82.8899 73.6234 83.7403 75.3898 83.7403 76.9068C83.7403 76.9068 84.2557 104.434 84.2557 103.628V76.7228C84.2557 75.2017 83.4054 73.4394 82.3556 72.7811Z",
    fill: "url(#paint181_radial_2_901)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M81.7209 105.517L72.4235 99.6823C71.3738 99.024 70.5234 97.2575 70.5234 95.7405V68.8353C70.5234 67.3142 71.3738 66.6191 72.4235 67.2733L81.7209 73.1082C82.7706 73.7665 83.6209 75.533 83.6209 77.05V103.955C83.6209 105.476 82.7706 106.171 81.7209 105.517Z",
    fill: "url(#paint182_radial_2_901)"
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M81.549 105.615L72.2517 99.7804C71.2019 99.1221 70.3516 97.3557 70.3516 95.8387V68.9334C70.3516 67.4123 71.2019 66.7172 72.2517 67.3714L81.549 73.2064C82.5987 73.8647 83.4491 75.6311 83.4491 77.1481V104.053C83.4491 105.574 82.5987 106.27 81.549 105.615Z",
    fill: "url(#paint183_linear_2_901)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6094 96.0187V69.0807C70.6094 67.7477 71.3544 67.1344 72.2724 67.715L81.5208 73.5172C82.4389 74.0937 83.1839 75.6435 83.1839 76.9724V103.91C83.1839 105.243 82.4389 105.857 81.5208 105.276L72.2724 99.4738C71.3544 98.8973 70.6094 97.3476 70.6094 96.0187Z",
    fill: "url(#paint184_linear_2_901)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9844 96.1819V69.3789C70.9844 68.2626 71.609 67.7515 72.3765 68.234L81.4255 73.9135C82.1968 74.396 82.8177 75.6922 82.8177 76.8085V103.612C82.8177 104.728 82.1931 105.239 81.4255 104.756L72.3765 99.0769C71.6052 98.5944 70.9844 97.2982 70.9844 96.1819Z",
    fill: "url(#paint185_linear_2_901)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4772 68.5327C71.751 68.0789 71.1641 68.4428 71.1641 69.3464V96.4521C71.1641 97.3557 71.751 98.4597 72.4772 98.9136L81.3192 104.462C82.0454 104.916 82.6324 104.552 82.6324 103.649V76.543C82.6324 75.6393 82.0454 74.5353 81.3192 74.0814L72.4772 68.5327Z",
    fill: "url(#paint186_linear_2_901)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6218 75.3855L81.7958 76.1216C81.8409 76.1502 81.8785 76.1256 81.8785 76.0725C81.8785 76.0193 81.8409 75.9498 81.7958 75.9212L80.6218 75.1852C80.5767 75.1566 80.5391 75.1811 80.5391 75.2343C80.5391 75.2874 80.5767 75.3569 80.6218 75.3855ZM81.7958 76.3751L80.6218 75.6391C80.5767 75.6104 80.5391 75.635 80.5391 75.6881C80.5391 75.7413 80.5767 75.8108 80.6218 75.8394L81.7958 76.5754C81.8409 76.604 81.8785 76.5795 81.8785 76.5264C81.8785 76.4732 81.8409 76.4037 81.7958 76.3751ZM81.7958 76.8289L80.6218 76.0929C80.5767 76.0643 80.5391 76.0888 80.5391 76.142C80.5391 76.1952 80.5767 76.2647 80.6218 76.2933L81.7958 77.0293C81.8409 77.0579 81.8785 77.0334 81.8785 76.9802C81.8785 76.9271 81.8409 76.8576 81.7958 76.8289Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1162 86.9981L71.6562 80.4557V71.1902L82.1162 77.7325V86.9981Z",
    fill: "url(#paint187_linear_2_901)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8183 92.0114C71.7318 92.0114 71.6641 92.085 71.6641 92.179V92.8496C71.6641 92.9436 71.7318 93.0172 71.8183 93.0172C71.9049 93.0172 71.9726 92.9436 71.9726 92.8496V92.179C71.9726 92.085 71.9049 92.0114 71.8183 92.0114ZM71.8183 93.3566C71.7318 93.3566 71.6641 93.4302 71.6641 93.5243V94.1949C71.6641 94.2889 71.7318 94.3625 71.8183 94.3625C71.9049 94.3625 71.9726 94.2889 71.9726 94.1949V93.5243C71.9726 93.4302 71.9049 93.3566 71.8183 93.3566ZM71.8183 94.7019C71.7318 94.7019 71.6641 94.7755 71.6641 94.8695V95.5401C71.6641 95.6342 71.7318 95.7078 71.8183 95.7078C71.9049 95.7078 71.9726 95.6342 71.9726 95.5401V94.8695C71.9726 94.7755 71.9049 94.7019 71.8183 94.7019ZM71.8183 96.0471C71.7318 96.0471 71.6641 96.1208 71.6641 96.2148V96.8445C71.6678 96.8445 71.6979 96.8649 71.6979 96.8649C71.7205 96.8813 71.7506 96.8854 71.7732 96.8854C71.8108 96.8854 71.8484 96.869 71.8785 96.8404H71.9726V96.2107C71.9726 96.1167 71.9049 96.0431 71.8183 96.0431V96.0471ZM72.3112 96.8895C72.2585 96.8895 72.2059 96.9181 72.1758 96.9753C72.1344 97.0571 72.157 97.1593 72.2322 97.2043L72.7703 97.5396C72.7928 97.556 72.8192 97.5601 72.8455 97.5601C72.8982 97.5601 72.9509 97.5314 72.981 97.4742C73.0224 97.3924 72.9998 97.2902 72.9245 97.2452L72.3865 96.9099C72.3639 96.8936 72.3338 96.8895 72.3112 96.8895ZM73.3836 97.5601C73.3309 97.5601 73.2782 97.5887 73.2481 97.6459C73.2067 97.7277 73.2293 97.8299 73.3045 97.8749L73.8426 98.2102C73.8652 98.2266 73.8915 98.2307 73.9178 98.2307C73.9705 98.2307 74.0232 98.202 74.0533 98.1448C74.0947 98.063 74.0721 97.9608 73.9969 97.9158L73.4588 97.5805C73.4362 97.5641 73.4061 97.5601 73.3836 97.5601ZM74.4559 98.2307C74.4032 98.2307 74.3505 98.2593 74.3204 98.3165C74.279 98.3983 74.3016 98.5005 74.3769 98.5455C74.3769 98.5455 74.6704 98.7295 74.8246 98.8235L74.8923 98.8644C74.9149 98.8808 74.945 98.8849 74.9676 98.8849C75.0203 98.8849 75.073 98.8563 75.1031 98.799C75.1444 98.7172 75.1219 98.615 75.0466 98.57L74.5086 98.2347C74.486 98.2184 74.4559 98.2143 74.4333 98.2143L74.4559 98.2307ZM75.5282 98.9012C75.4755 98.9012 75.4229 98.9299 75.3928 98.9871C75.3514 99.0689 75.374 99.1711 75.4492 99.2161L75.9873 99.5514C76.0098 99.5677 76.0399 99.5718 76.0625 99.5718C76.1152 99.5718 76.1679 99.5432 76.198 99.486C76.2394 99.4042 76.2168 99.302 76.1415 99.257L75.6035 98.9217C75.5809 98.9053 75.5508 98.9012 75.5282 98.9012ZM76.6006 99.5718C76.5479 99.5718 76.4952 99.6004 76.4651 99.6577C76.4237 99.7395 76.4463 99.8417 76.5215 99.8867C76.5215 99.8867 76.6231 99.9521 76.7398 100.022C76.7398 100.022 76.7435 100.022 76.7473 100.022L77.0558 100.214C77.0784 100.23 77.1047 100.234 77.1311 100.234C77.1838 100.234 77.2364 100.206 77.2665 100.148C77.3079 100.067 77.2853 99.9644 77.2101 99.9194L76.672 99.5841C76.6495 99.5677 76.6194 99.5636 76.5968 99.5636L76.6006 99.5718ZM77.6729 100.242C77.6202 100.242 77.5675 100.271 77.5374 100.328C77.496 100.41 77.5186 100.512 77.5939 100.557L78.1319 100.893C78.1545 100.909 78.1808 100.913 78.2072 100.913C78.2599 100.913 78.3125 100.884 78.3426 100.827C78.384 100.745 78.3614 100.643 78.2862 100.598L77.7481 100.263C77.7256 100.247 77.6955 100.242 77.6729 100.242ZM78.7452 100.913C78.6925 100.913 78.6399 100.942 78.6098 100.999C78.5684 101.081 78.591 101.183 78.6662 101.228L78.8205 101.322C78.8205 101.322 78.8205 101.322 78.8242 101.322C78.9823 101.42 79.2043 101.559 79.2043 101.559C79.2268 101.575 79.2569 101.579 79.2795 101.579C79.3322 101.579 79.3849 101.551 79.415 101.494C79.4564 101.412 79.4338 101.31 79.3585 101.265L78.8205 100.929C78.7979 100.913 78.7678 100.909 78.7452 100.909V100.913ZM79.8176 101.584C79.7649 101.584 79.7122 101.612 79.6821 101.669C79.6407 101.751 79.6633 101.853 79.7385 101.898L80.2766 102.234C80.2992 102.25 80.3293 102.254 80.3518 102.254C80.4045 102.254 80.4572 102.226 80.4873 102.168C80.5287 102.087 80.5061 101.984 80.4309 101.939L79.8928 101.604C79.8702 101.588 79.8401 101.584 79.8176 101.584ZM80.8899 102.254C80.8372 102.254 80.7845 102.283 80.7544 102.34C80.713 102.422 80.7356 102.524 80.8109 102.569C80.8109 102.569 81.0705 102.733 81.2285 102.831L81.3489 102.904C81.3715 102.921 81.3978 102.925 81.4242 102.925C81.4768 102.925 81.5295 102.896 81.5596 102.839C81.601 102.757 81.5784 102.655 81.5032 102.61L80.9651 102.275C80.9426 102.258 80.9125 102.254 80.8899 102.254ZM81.966 102.843C81.8794 102.843 81.8117 102.917 81.8117 103.011V103.06C81.808 103.084 81.808 103.109 81.8117 103.133V103.195L82.1203 103.387V102.998C82.1165 102.912 82.0488 102.843 81.966 102.843ZM81.966 101.498C81.8794 101.498 81.8117 101.571 81.8117 101.665V102.336C81.8117 102.43 81.8794 102.504 81.966 102.504C82.0525 102.504 82.1203 102.43 82.1203 102.336V101.665C82.1203 101.571 82.0525 101.498 81.966 101.498ZM81.966 100.152C81.8794 100.152 81.8117 100.226 81.8117 100.32V100.991C81.8117 101.085 81.8794 101.158 81.966 101.158C82.0525 101.158 82.1203 101.085 82.1203 100.991V100.32C82.1203 100.226 82.0525 100.152 81.966 100.152ZM81.966 98.8072C81.8794 98.8072 81.8117 98.8808 81.8117 98.9748V99.6454C81.8117 99.7395 81.8794 99.8131 81.966 99.8131C82.0525 99.8131 82.1203 99.7395 82.1203 99.6454V98.9748C82.1203 98.8808 82.0525 98.8072 81.966 98.8072ZM81.966 97.4619C81.8794 97.4619 81.8117 97.5355 81.8117 97.6296V98.3002C81.8117 98.3942 81.8794 98.4678 81.966 98.4678C82.0525 98.4678 82.1203 98.3942 82.1203 98.3002V97.6296C82.1203 97.5355 82.0525 97.4619 81.966 97.4619ZM81.1721 96.8077C81.1194 96.8077 81.0667 96.8363 81.0366 96.8936C80.9952 96.9753 81.0178 97.0776 81.0931 97.1225L81.6311 97.4578C81.6537 97.4742 81.6838 97.4783 81.7064 97.4783C81.759 97.4783 81.8117 97.4497 81.8418 97.3924C81.8832 97.3106 81.8606 97.2084 81.7854 97.1634L81.2473 96.8281C81.2248 96.8118 81.1947 96.8077 81.1721 96.8077ZM80.0997 96.1371C80.0471 96.1371 79.9944 96.1657 79.9643 96.223C79.9229 96.3048 79.9455 96.407 80.0207 96.452L80.5588 96.7873C80.5814 96.8036 80.6115 96.8077 80.634 96.8077C80.6867 96.8077 80.7394 96.7791 80.7695 96.7218C80.8109 96.6401 80.7883 96.5378 80.713 96.4928C80.713 96.4928 80.5362 96.3824 80.3857 96.2884L80.1788 96.1576C80.1562 96.1412 80.1299 96.1371 80.1035 96.1371H80.0997ZM79.0274 95.4665C78.9747 95.4665 78.9221 95.4951 78.892 95.5524C78.8506 95.6342 78.8731 95.7364 78.9484 95.7814L79.4865 96.1167C79.509 96.133 79.5391 96.1371 79.5617 96.1371C79.6144 96.1371 79.6671 96.1085 79.6972 96.0512C79.7385 95.9695 79.716 95.8672 79.6407 95.8223L79.3058 95.6137C79.3058 95.6137 79.3058 95.6137 79.3021 95.6096C79.3021 95.6096 79.3021 95.6096 79.2983 95.6096C79.2983 95.6096 79.2908 95.6055 79.287 95.6015C79.193 95.5442 79.1177 95.4951 79.1177 95.4951C79.0951 95.4788 79.065 95.4747 79.0425 95.4747L79.0274 95.4665ZM77.9551 94.7959C77.9024 94.7959 77.8497 94.8246 77.8196 94.8818C77.7782 94.9636 77.8008 95.0658 77.8761 95.1108L78.4141 95.4461C78.4367 95.4624 78.4668 95.4665 78.4894 95.4665C78.542 95.4665 78.5947 95.4379 78.6248 95.3807C78.6662 95.2989 78.6436 95.1967 78.5684 95.1517L78.2711 94.9677C78.2674 94.9677 78.2636 94.9636 78.2599 94.9595C78.1432 94.8859 78.0416 94.8246 78.0416 94.8246C78.019 94.8082 77.9889 94.8041 77.9664 94.8041L77.9551 94.7959ZM76.8827 94.1253C76.8301 94.1253 76.7774 94.154 76.7473 94.2112C76.7059 94.293 76.7285 94.3952 76.8037 94.4402L77.3418 94.7755C77.3644 94.7918 77.3945 94.7959 77.417 94.7959C77.4697 94.7959 77.5224 94.7673 77.5525 94.7101C77.5939 94.6283 77.5713 94.5261 77.496 94.4811L76.958 94.1458C76.9354 94.1294 76.9053 94.1253 76.8827 94.1253ZM75.8104 93.4548C75.7577 93.4548 75.7051 93.4834 75.675 93.5406C75.6336 93.6224 75.6561 93.7246 75.7314 93.7696L76.2695 94.1049C76.292 94.1213 76.3221 94.1253 76.3447 94.1253C76.3974 94.1253 76.4501 94.0967 76.4802 94.0395C76.5215 93.9577 76.499 93.8555 76.4237 93.8105C76.4237 93.8105 76.2318 93.6919 76.0776 93.5938L75.8894 93.4752C75.8669 93.4588 75.8405 93.4548 75.8142 93.4548H75.8104ZM74.7381 92.7842C74.6854 92.7842 74.6327 92.8128 74.6026 92.87C74.5612 92.9518 74.5838 93.054 74.6591 93.099L75.1971 93.4343C75.2197 93.4507 75.2498 93.4548 75.2724 93.4548C75.325 93.4548 75.3777 93.4261 75.4078 93.3689C75.4492 93.2871 75.4266 93.1849 75.3514 93.1399L74.8133 92.8046C74.7908 92.7883 74.7644 92.7842 74.7381 92.7842ZM73.6658 92.1136C73.6131 92.1136 73.5604 92.1422 73.5303 92.1995C73.4889 92.2812 73.5115 92.3835 73.5867 92.4284L74.1248 92.7637C74.1474 92.7801 74.1775 92.7842 74.2 92.7842C74.2527 92.7842 74.3054 92.7556 74.3355 92.6983C74.3769 92.6165 74.3543 92.5143 74.279 92.4693C74.279 92.4693 74.2076 92.4243 74.1173 92.3671H74.1097V92.363L73.7485 92.1381C73.726 92.1218 73.6996 92.1177 73.6733 92.1177L73.6658 92.1136ZM72.5934 91.443C72.5407 91.443 72.4881 91.4716 72.458 91.5289C72.4166 91.6106 72.4392 91.7129 72.5144 91.7578L73.0525 92.0931C73.075 92.1095 73.1051 92.1136 73.1277 92.1136C73.1804 92.1136 73.2331 92.085 73.2632 92.0277C73.3045 91.9459 73.282 91.8437 73.2067 91.7987L72.6687 91.4634C72.6461 91.4471 72.616 91.443 72.5934 91.443ZM71.6641 90.8337V91.2222V91.5084C71.6641 91.6025 71.7318 91.6761 71.8183 91.6761C71.9049 91.6761 71.9726 91.6025 71.9726 91.5084V91.4185H71.9801C72.0027 91.4389 72.0328 91.4471 72.0554 91.4471C72.108 91.4471 72.1607 91.4185 72.1908 91.3612C72.2322 91.2794 72.2096 91.1772 72.1344 91.1322C72.1344 91.1322 72.0629 91.0873 71.9726 91.03L71.6641 90.8378V90.8337Z",
    fill: "#C7BCD6"
  }))), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M75.2109 72.1143C75.2109 72.3965 75.0265 72.511 74.8007 72.3678C74.575 72.2247 74.3906 71.8813 74.3906 71.595C74.3906 71.3088 74.575 71.1984 74.8007 71.3415C75.0265 71.4846 75.2109 71.8281 75.2109 72.1143Z",
    fill: "url(#paint188_linear_2_901)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M73.914 71.3292C73.914 71.6113 73.7296 71.7258 73.5039 71.5827C73.2781 71.4396 73.0938 71.0961 73.0938 70.8099C73.0938 70.5236 73.2781 70.4132 73.5039 70.5564C73.7296 70.6995 73.914 71.0429 73.914 71.3292Z",
    fill: "url(#paint189_linear_2_901)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6015 70.5235C72.6015 70.8056 72.4171 70.9201 72.1914 70.777C71.9656 70.6339 71.7812 70.2904 71.7812 70.0042C71.7812 69.718 71.9656 69.6076 72.1914 69.7507C72.4171 69.8938 72.6015 70.2373 72.6015 70.5235Z",
    fill: "url(#paint190_linear_2_901)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M82.0982 91.9332L71.6797 85.3418V81.4451L82.0982 88.0324V91.9332Z",
    fill: "url(#paint191_linear_2_901)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0806 93.4995L71.7109 86.9367V86.0903L82.0806 92.6531V93.4995Z",
    fill: "#8969C3"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0806 94.4807L71.7109 87.9179V87.6235L82.0806 94.1863V94.4807Z",
    fill: "#8969C3"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0806 95.2781L71.7109 88.7153V88.4209L82.0806 94.9837V95.2781Z",
    fill: "#8969C3"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0806 96.0757L71.7109 89.5129V89.2185L82.0806 95.7813V96.0757Z",
    fill: "#8969C3"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M79.497 79.1144L74.4062 75.9005V75.1768L79.497 78.3907V79.1144Z",
    fill: "#D1B4E3"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1119 81.073L72.5859 75.6879V75.3567L81.1119 80.7418V81.073Z",
    fill: "#D1B4E3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M75.183 78.6198C74.8369 78.403 74.5547 78.5748 74.5547 79.0082V79.965C74.5547 80.3985 74.8369 80.9259 75.183 81.1426L78.8967 83.4652C79.2429 83.6819 79.653 83.4856 79.653 83.0522V82.0954C79.653 81.6619 79.2429 81.1549 78.8967 80.9382L75.183 78.6157V78.6198Z",
    fill: "url(#paint192_linear_2_901)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M75.1637 78.6486C74.8175 78.4319 74.5391 78.6036 74.5391 79.037V79.9448C74.5391 80.3741 74.8175 80.9016 75.1637 81.1183L78.8585 83.4285C79.2046 83.6453 79.5997 83.4531 79.5997 83.0196V82.1119C79.5997 81.6826 79.2046 81.1755 78.8585 80.9588L75.1637 78.6486Z",
    fill: "url(#paint193_linear_2_901)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M75.148 78.6811C74.8056 78.4644 74.5234 78.6362 74.5234 79.0655V79.9242C74.5234 80.3535 74.8019 80.8769 75.148 81.0936L78.8203 83.3875C79.1627 83.6042 79.5465 83.4121 79.5465 82.9827V82.124C79.5465 81.6947 79.1665 81.1877 78.8203 80.975L75.148 78.6811Z",
    fill: "url(#paint194_linear_2_901)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M75.1208 78.7097C74.7784 78.493 74.5 78.6688 74.5 79.0941V79.9078C74.5 80.333 74.7784 80.8564 75.1208 81.069L78.7743 83.3507C79.1167 83.5674 79.4816 83.3793 79.4816 82.9499V82.1362C79.4816 81.711 79.1167 81.204 78.7743 80.9913L75.1208 78.7097Z",
    fill: "url(#paint195_linear_2_901)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M75.1014 78.7424C74.759 78.5298 74.4844 78.7015 74.4844 79.1227V79.8873C74.4844 80.3126 74.759 80.8278 75.1014 81.0445L78.7323 83.3139C79.0747 83.5265 79.4246 83.3425 79.4246 82.9172V82.1526C79.4246 81.7274 79.071 81.2244 78.7323 81.0077L75.1014 78.7383V78.7424Z",
    fill: "url(#paint196_linear_2_901)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M75.0899 78.771C74.7512 78.5584 74.4766 78.7301 74.4766 79.1513V79.8668C74.4766 80.288 74.7512 80.8032 75.0899 81.0158L78.7019 83.2729C79.0406 83.4856 79.3792 83.3056 79.3792 82.8804V82.1648C79.3792 81.7437 79.0406 81.2366 78.7019 81.024L75.0899 78.7669V78.771Z",
    fill: "url(#paint197_linear_2_901)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M75.0705 78.8037C74.7318 78.5911 74.4609 78.7628 74.4609 79.184V79.8505C74.4609 80.2716 74.7356 80.7828 75.0705 80.9954L78.66 83.2402C78.9986 83.4528 79.3222 83.2729 79.3222 82.8518V82.1853C79.3222 81.7641 78.9986 81.2612 78.66 81.0485L75.0705 78.8037Z",
    fill: "url(#paint198_linear_2_901)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M75.0589 78.8323C74.724 78.6237 74.4531 78.7914 74.4531 79.2085V79.8259C74.4531 80.243 74.724 80.7541 75.0589 80.9667L78.6296 83.1952C78.9644 83.4037 79.2767 83.232 79.2767 82.8108V82.1934C79.2767 81.7763 78.9682 81.2734 78.6296 81.0608L75.0589 78.8323Z",
    fill: "url(#paint199_linear_2_901)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M75.0433 78.8652C74.7084 78.6567 74.4375 78.8244 74.4375 79.2414V79.8139C74.4375 80.2309 74.7084 80.738 75.0433 80.9465L78.5914 83.1627C78.9263 83.3713 79.2197 83.1995 79.2197 82.7825V82.21C79.2197 81.7929 78.9225 81.29 78.5914 81.0815L75.0433 78.8652Z",
    fill: "url(#paint200_linear_2_901)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M75.0161 78.8934C74.685 78.6849 74.4141 78.8525 74.4141 79.2655V79.7889C74.4141 80.2019 74.685 80.7089 75.0161 80.9174L78.5454 83.1214C78.8765 83.3299 79.1587 83.1623 79.1587 82.7452V82.2218C79.1587 81.8088 78.8765 81.3059 78.5454 81.0974L75.0161 78.8934Z",
    fill: "url(#paint201_linear_2_901)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9967 78.9264C74.6656 78.7178 74.3984 78.8855 74.3984 79.2985V79.7728C74.3984 80.1858 74.6656 80.6887 74.9967 80.8932L78.5034 83.0848C78.8345 83.2934 79.1017 83.1257 79.1017 82.7127V82.2384C79.1017 81.8254 78.8345 81.3225 78.5034 81.1181L74.9967 78.9264Z",
    fill: "url(#paint202_linear_2_901)"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9063 83.4735L74.8239 80.922C74.538 80.7421 74.3047 80.2596 74.3047 79.8425V79.2333C74.3047 78.8203 74.538 78.6281 74.8239 78.808L78.9063 81.3595C79.1923 81.5394 79.4255 82.0219 79.4255 82.439V83.0483C79.4255 83.4613 79.1923 83.6534 78.9063 83.4735Z",
    fill: "url(#paint203_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M78.9063 81.3595L74.8239 78.808C74.538 78.6281 74.3047 78.8203 74.3047 79.2333V79.2946C74.3047 78.8816 74.538 78.6895 74.8239 78.8694L78.9063 81.4209C79.1923 81.6008 79.4255 82.0833 79.4255 82.5004V82.439C79.4255 82.026 79.1923 81.5394 78.9063 81.3595Z",
    fill: "url(#paint204_radial_2_901)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M73.0863 90.9892C72.2999 90.4944 71.6641 90.891 71.6641 91.8724V95.8918C71.6641 96.8732 72.2999 98.0671 73.0863 98.5578L79.7047 102.7C80.4911 103.195 81.4129 102.749 81.4129 101.768V97.7482C81.4129 96.7668 80.4911 95.6219 79.7047 95.1313L73.0863 90.9892Z",
    fill: "url(#paint205_linear_2_901)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M72.7229 91.2221C71.9365 90.7273 71.2969 91.1239 71.2969 92.1053V96.0634C71.2969 97.0447 71.9365 98.2428 72.7229 98.7376L79.345 102.88C80.1314 103.374 81.0306 102.933 81.0306 101.951V97.9934C81.0306 97.012 80.1352 95.8589 79.345 95.3642L72.7229 91.2221Z",
    fill: "url(#paint206_linear_2_901)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M72.3907 91.4593C71.6006 90.9645 70.9609 91.3611 70.9609 92.3466V96.2433C70.9609 97.2288 71.6006 98.4309 72.3907 98.9257L79.0204 103.072C79.8105 103.567 80.6797 103.133 80.6797 102.144V98.2469C80.6797 97.2615 79.8105 96.1002 79.0204 95.6014L72.3907 91.4552V91.4593Z",
    fill: "url(#paint207_linear_2_901)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M72.0389 91.6924C71.245 91.1936 70.6016 91.5943 70.6016 92.5838V96.4192C70.6016 97.4088 71.245 98.615 72.0389 99.1098L78.6723 103.26C79.4662 103.759 80.309 103.325 80.309 102.336V98.5005C80.309 97.511 79.4662 96.3415 78.6723 95.8427L72.0389 91.6924Z",
    fill: "url(#paint208_linear_2_901)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M71.6911 91.9253C70.8972 91.4265 70.25 91.8272 70.25 92.8167V96.5867C70.25 97.5803 70.8934 98.7866 71.6911 99.2854L78.332 103.44C79.1259 103.939 79.9424 103.509 79.9424 102.52V98.7498C79.9424 97.7562 79.1259 96.5785 78.332 96.0797L71.6911 91.9253Z",
    fill: "url(#paint209_linear_2_901)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M71.3433 92.1584C70.5456 91.6595 69.8984 92.0602 69.8984 93.0539V96.7625C69.8984 97.7561 70.5456 98.9706 71.3433 99.4694L77.988 103.628C78.7856 104.127 79.5758 103.701 79.5758 102.708V98.9992C79.5758 98.0056 78.7856 96.8157 77.988 96.3168L71.3433 92.1584Z",
    fill: "url(#paint210_linear_2_901)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M70.9955 92.3915C70.194 91.8886 69.5469 92.2934 69.5469 93.2911V96.9384C69.5469 97.9361 70.194 99.1546 70.9955 99.6535L77.6439 103.812C78.4454 104.315 79.2092 103.894 79.2092 102.896V99.2487C79.2092 98.251 78.4454 97.0529 77.6439 96.55L70.9955 92.3915Z",
    fill: "url(#paint211_linear_2_901)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M70.6477 92.6288C69.8462 92.1259 69.1953 92.5266 69.1953 93.5284V97.1144C69.1953 98.1162 69.8462 99.3347 70.6477 99.8417L77.3037 104.004C78.1051 104.507 78.8425 104.09 78.8425 103.088V99.5024C78.8425 98.5006 78.1051 97.2943 77.3037 96.7914L70.6477 92.6288Z",
    fill: "url(#paint212_linear_2_901)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M70.3036 92.8617C69.4984 92.3547 68.8438 92.7595 68.8438 93.7654V97.286C68.8438 98.2918 69.4984 99.5144 70.3036 100.021L76.9634 104.188C77.7686 104.695 78.4797 104.278 78.4797 103.276V99.7557C78.4797 98.7498 77.7686 97.5354 76.9634 97.0324L70.3036 92.8658V92.8617Z",
    fill: "url(#paint213_linear_2_901)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M69.9636 93.095C69.1547 92.588 68.5 92.9928 68.5 94.0028V97.462C68.5 98.4679 69.1547 99.6987 69.9636 100.206L76.6309 104.376C77.4399 104.883 78.1209 104.475 78.1209 103.465V100.005C78.1209 98.9995 77.4361 97.7769 76.6309 97.2698L69.9636 93.0991V93.095Z",
    fill: "url(#paint214_linear_2_901)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M69.608 93.3279C68.7991 92.8209 68.1406 93.2257 68.1406 94.2357V97.6336C68.1406 98.6436 68.7991 99.8743 69.608 100.385L76.2791 104.556C77.088 105.063 77.7465 104.658 77.7465 103.648V100.251C77.7465 99.2405 77.088 98.0098 76.2791 97.4987L69.608 93.3279Z",
    fill: "url(#paint215_linear_2_901)"
  }))), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M69.5649 93.0296C68.7522 92.5185 68.0938 92.9273 68.0938 93.9414V98.2471C68.0938 99.2611 68.7522 100.496 69.5649 101.007L76.2698 105.202C77.0825 105.713 77.741 105.305 77.741 104.291V99.9849C77.741 98.9708 77.0825 97.736 76.2698 97.2248L69.5649 93.0296Z",
    fill: "url(#paint216_linear_2_901)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M76.2698 97.2209L69.5649 93.0257C68.7522 92.5145 68.0938 92.9234 68.0938 93.9375V94.0929C68.0938 93.0788 68.7522 92.6699 69.5649 93.181L76.2698 97.3763C77.0825 97.8874 77.741 99.1223 77.741 100.136V99.981C77.741 98.9669 77.0825 97.732 76.2698 97.2209Z",
    fill: "url(#paint217_radial_2_901)"
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2656 95.0208V99.9152L75.3225 103.088V98.1938L70.2656 95.0208ZM74.9989 102.483L70.5892 99.7149V95.6259L74.9989 98.3941V102.483ZM73.5842 98.7948L72.7941 99.9398L72.1657 99.0933L70.9128 99.5186L74.6754 101.878L73.5842 98.7948ZM71.8647 98.3982C72.1431 98.574 72.3689 98.435 72.3689 98.0834C72.3689 97.7317 72.1431 97.3106 71.8647 97.1347C71.5863 96.9589 71.3605 97.0979 71.3605 97.4496C71.3605 97.8012 71.5863 98.2224 71.8647 98.3982Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_901",
    x1: 54.9371,
    y1: 85.0025,
    x2: -3.77027,
    y2: 85.0025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2C1357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#574188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#755FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7D66AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5C458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#351F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2A1054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#220446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_901",
    x1: 58.1753,
    y1: 83.3304,
    x2: -27.0394,
    y2: 83.3304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_901",
    x1: 57.5439,
    y1: 83.33,
    x2: 2.32812,
    y2: 83.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3595 87.46) rotate(180) scale(21.1946 23.0331)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5436 73.9785) rotate(-159.506) scale(7.96909 5.01361)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_901",
    x1: -188.05,
    y1: 227.419,
    x2: -173.611,
    y2: 195.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_901",
    x1: 34.1938,
    y1: 69.2273,
    x2: 18.0075,
    y2: 92.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_901",
    x1: 33.2703,
    y1: 80.0671,
    x2: 32.3452,
    y2: 81.4081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_901",
    x1: 32.5595,
    y1: 78.186,
    x2: 31.6181,
    y2: 79.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_901",
    x1: 31.3209,
    y1: 81.2896,
    x2: 30.3919,
    y2: 82.6301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_901",
    x1: 27.4146,
    y1: 83.7391,
    x2: 26.4857,
    y2: 85.0796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_901",
    x1: 29.364,
    y1: 82.5164,
    x2: 28.435,
    y2: 83.8569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_901",
    x1: 24.747,
    y1: 83.0809,
    x2: 23.8094,
    y2: 84.4372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_901",
    x1: 28.6376,
    y1: 80.6315,
    x2: 27.7,
    y2: 81.9878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_901",
    x1: 30.5985,
    y1: 79.4089,
    x2: 29.6609,
    y2: 80.7653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_901",
    x1: 22.786,
    y1: 84.3074,
    x2: 21.8484,
    y2: 85.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_901",
    x1: 23.5046,
    y1: 86.1885,
    x2: 22.5756,
    y2: 87.5291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_901",
    x1: 35.2156,
    y1: 78.8404,
    x2: 34.2866,
    y2: 80.1809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_901",
    x1: 20.8407,
    y1: 85.5298,
    x2: 19.9031,
    y2: 86.8862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_901",
    x1: 33.5048,
    y1: 75.3197,
    x2: 32.5756,
    y2: 76.6644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_901",
    x1: 26.7079,
    y1: 81.8582,
    x2: 25.7664,
    y2: 83.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_901",
    x1: 25.4656,
    y1: 84.9615,
    x2: 24.5366,
    y2: 86.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_901",
    x1: 19.8563,
    y1: 83.8821,
    x2: 18.9189,
    y2: 85.2343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_901",
    x1: 23.7588,
    y1: 81.4327,
    x2: 22.8212,
    y2: 82.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_901",
    x1: 24.7548,
    y1: 78.5419,
    x2: 23.8256,
    y2: 79.8866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_901",
    x1: 26.7079,
    y1: 77.3151,
    x2: 25.7787,
    y2: 78.6598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_901",
    x1: 20.8564,
    y1: 80.9911,
    x2: 19.9274,
    y2: 82.3316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2_901",
    x1: 22.8132,
    y1: 79.7645,
    x2: 21.8801,
    y2: 81.1088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2_901",
    x1: 28.6726,
    y1: 76.0926,
    x2: 27.7395,
    y2: 77.4369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2_901",
    x1: 30.622,
    y1: 74.8658,
    x2: 29.6928,
    y2: 76.2105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2_901",
    x1: 34.5242,
    y1: 72.4208,
    x2: 33.5913,
    y2: 73.7609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2_901",
    x1: 32.5673,
    y1: 73.6432,
    x2: 31.6381,
    y2: 74.9879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2_901",
    x1: 29.6179,
    y1: 77.7692,
    x2: 28.6888,
    y2: 79.1139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2_901",
    x1: 27.661,
    y1: 78.9835,
    x2: 26.7195,
    y2: 80.3393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2_901",
    x1: 21.8095,
    y1: 82.6552,
    x2: 20.8679,
    y2: 84.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2_901",
    x1: 25.7079,
    y1: 80.2062,
    x2: 24.7703,
    y2: 81.5625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2_901",
    x1: 18.9032,
    y1: 82.214,
    x2: 17.9741,
    y2: 83.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2_901",
    x1: 17.9032,
    y1: 85.1048,
    x2: 16.9656,
    y2: 86.4611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2_901",
    x1: 16.9539,
    y1: 83.4405,
    x2: 16.021,
    y2: 84.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2_901",
    x1: 31.5517,
    y1: 76.5468,
    x2: 30.6227,
    y2: 77.8873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2_901",
    x1: 21.559,
    y1: 87.4109,
    x2: 20.63,
    y2: 88.7515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2_901",
    x1: 34.501,
    y1: 76.9598,
    x2: 33.5634,
    y2: 78.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2_901",
    x1: 43.5494,
    y1: 75.6306,
    x2: 42.0883,
    y2: 77.7406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2_901",
    x1: 40.9225,
    y1: 77.5281,
    x2: 39.9935,
    y2: 78.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2_901",
    x1: 41.2966,
    y1: 74.2037,
    x2: 38.6363,
    y2: 78.0427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2_901",
    x1: 34.3661,
    y1: 78.2109,
    x2: 26.2329,
    y2: 89.9537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2_901",
    x1: 38.9772,
    y1: 78.7546,
    x2: 38.0521,
    y2: 80.0956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2_901",
    x1: 39.6973,
    y1: 73.1977,
    x2: 37.7208,
    y2: 76.0539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2_901",
    x1: 36.4735,
    y1: 71.194,
    x2: 35.5444,
    y2: 72.5387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2_901",
    x1: 38.0767,
    y1: 72.2,
    x2: 36.6156,
    y2: 74.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2_901",
    x1: 13.962,
    y1: 87.5785,
    x2: 13.0243,
    y2: 88.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2_901",
    x1: 34.8536,
    y1: 70.1759,
    x2: 33.4011,
    y2: 72.2701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2_901",
    x1: 16.6734,
    y1: 87.8032,
    x2: 15.014,
    y2: 90.1967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2_901",
    x1: 12.8152,
    y1: 85.7836,
    x2: 11.354,
    y2: 87.8936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2_901",
    x1: 23.3522,
    y1: 88.5474,
    x2: 22.4232,
    y2: 89.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2_901",
    x1: 10.7229,
    y1: 85.5708,
    x2: 9.80663,
    y2: 86.8919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2_901",
    x1: 21.4106,
    y1: 89.7744,
    x2: 20.4816,
    y2: 91.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2_901",
    x1: 19.4225,
    y1: 91.0213,
    x2: 18.4935,
    y2: 92.3618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2_901",
    x1: 17.6178,
    y1: 89.8887,
    x2: 16.6888,
    y2: 91.2293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2_901",
    x1: 18.5704,
    y1: 80.6475,
    x2: 17.6502,
    y2: 81.9681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2_901",
    x1: 15.9501,
    y1: 86.3314,
    x2: 15.0127,
    y2: 87.6835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2_901",
    x1: 15.0007,
    y1: 84.663,
    x2: 14.0716,
    y2: 86.0077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2_901",
    x1: 12.711,
    y1: 84.3197,
    x2: 11.7907,
    y2: 85.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2_901",
    x1: 18.8876,
    y1: 86.7567,
    x2: 17.95,
    y2: 88.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2_901",
    x1: 36.4501,
    y1: 75.7368,
    x2: 35.5125,
    y2: 77.0931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2_901",
    x1: 19.6178,
    y1: 88.6377,
    x2: 18.6888,
    y2: 89.9782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2_901",
    x1: 32.2229,
    y1: 72.0731,
    x2: 31.3064,
    y2: 73.3983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2_901",
    x1: 37.1725,
    y1: 77.6177,
    x2: 36.2435,
    y2: 78.9583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2_901",
    x1: 14.6604,
    y1: 83.0929,
    x2: 13.7439,
    y2: 84.4181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2_901",
    x1: 24.422,
    y1: 76.9718,
    x2: 23.5016,
    y2: 78.2965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2_901",
    x1: 28.336,
    y1: 74.5226,
    x2: 27.4196,
    y2: 75.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2_901",
    x1: 26.3713,
    y1: 75.7491,
    x2: 25.4549,
    y2: 77.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2_901",
    x1: 30.2776,
    y1: 73.2997,
    x2: 29.3611,
    y2: 74.6248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2_901",
    x1: 22.4767,
    y1: 78.1985,
    x2: 21.5602,
    y2: 79.5237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2_901",
    x1: 35.4657,
    y1: 74.097,
    x2: 34.5326,
    y2: 75.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2_901",
    x1: 20.5198,
    y1: 79.4207,
    x2: 19.6033,
    y2: 80.7459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2_901",
    x1: 16.6213,
    y1: 81.8705,
    x2: 15.7049,
    y2: 83.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2_901",
    x1: 45.3269,
    y1: 34.1891,
    x2: -3.30375,
    y2: 73.5801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2_901",
    x1: 1.66134,
    y1: 87.9996,
    x2: 36.9129,
    y2: 37.7142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A0C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2_901",
    x1: -6.59992,
    y1: 87.1534,
    x2: 25.856,
    y2: 39.4335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2C1357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#574188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#755FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7D66AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5C458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#351F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2A1054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#220446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.63969 56.343) rotate(180) scale(4.91016 5.33608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2_901",
    x1: 34.1749,
    y1: 69.5789,
    x2: 18.0013,
    y2: 92.9326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2_901",
    x1: 51.0507,
    y1: 72.286,
    x2: 88.7442,
    y2: 72.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2C1357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#574188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#755FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7D66AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5C458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#351F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2A1054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#220446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2_901",
    x1: 61.1393,
    y1: 74.9191,
    x2: 78.8619,
    y2: 65.8941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2_901",
    x1: 70.1925,
    y1: 70.0613,
    x2: 73.9764,
    y2: 64.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.3087 78.366) scale(13.4098 14.573)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2_901",
    x1: 97.8672,
    y1: 82.1321,
    x2: 33.7249,
    y2: 0.45698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2_901",
    x1: 47.9818,
    y1: 4.02513,
    x2: 102.896,
    y2: 80.0082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2_901",
    x1: 110.118,
    y1: 84.0172,
    x2: 59.0914,
    y2: 8.99207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2C1357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#574188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#755FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7D66AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5C458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#351F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2A1054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#220446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.2418 39.1161) scale(7.72832 8.3987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2_901",
    x1: -407.686,
    y1: -252.224,
    x2: -466.46,
    y2: -322.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2_901",
    x1: 53.027,
    y1: 12.432,
    x2: 54.1144,
    y2: 10.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FEB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2_901",
    x1: 50.3198,
    y1: 10.7885,
    x2: 51.4073,
    y2: 9.07642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2_901",
    x1: 47.5854,
    y1: 9.1078,
    x2: 48.6729,
    y2: 7.39575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2_901",
    x1: 58.8563,
    y1: 63.9161,
    x2: 52.3183,
    y2: 31.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A1BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A205C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2_901",
    x1: 74.3321,
    y1: 70.1436,
    x2: 67.7985,
    y2: 37.3881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A1BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A205C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2_901",
    x1: 66.3631,
    y1: 28.7512,
    x2: 73.5649,
    y2: 41.3833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2_901",
    x1: 66.3544,
    y1: 28.8617,
    x2: 73.475,
    y2: 41.3521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2_901",
    x1: 66.3339,
    y1: 28.976,
    x2: 73.369,
    y2: 41.3211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2_901",
    x1: 66.3408,
    y1: 29.0907,
    x2: 73.2948,
    y2: 41.2942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2_901",
    x1: 66.3322,
    y1: 29.2049,
    x2: 73.2047,
    y2: 41.2626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2_901",
    x1: 66.3157,
    y1: 29.3153,
    x2: 73.103,
    y2: 41.2319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2_901",
    x1: 66.3189,
    y1: 29.43,
    x2: 73.0288,
    y2: 41.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2_901",
    x1: 66.2983,
    y1: 29.5443,
    x2: 72.9269,
    y2: 41.1688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2_901",
    x1: 66.2975,
    y1: 29.6546,
    x2: 72.841,
    y2: 41.1421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2_901",
    x1: 66.3004,
    y1: 29.7692,
    x2: 72.7625,
    y2: 41.1109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2_901",
    x1: 66.2839,
    y1: 29.8797,
    x2: 72.6648,
    y2: 41.0798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2_901",
    x1: 76.895,
    y1: 45.1026,
    x2: 63.9968,
    y2: 34.5891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.476 37.7834) scale(9.48168 10.3042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6B1D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#421232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1F0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2_901",
    x1: 556.418,
    y1: -273.468,
    x2: 593.801,
    y2: -318.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2_901",
    x1: 7.00787,
    y1: 54.0327,
    x2: 7.69615,
    y2: 55.1196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FEB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2_901",
    x1: 5.2813,
    y1: 55.0752,
    x2: 5.96959,
    y2: 56.1621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2_901",
    x1: 3.54693,
    y1: 56.1467,
    x2: 4.23918,
    y2: 57.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2_901",
    x1: 22.2728,
    y1: 71.1817,
    x2: 14.651,
    y2: 61.9595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A1BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A205C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2_901",
    x1: 12.4327,
    y1: 77.5889,
    x2: 3.28223,
    y2: 67.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A1BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A205C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2_901",
    x1: 21.2126,
    y1: 51.8736,
    x2: 16.6364,
    y2: 59.9098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2_901",
    x1: 21.2149,
    y1: 51.9469,
    x2: 16.686,
    y2: 59.8922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2_901",
    x1: 21.2135,
    y1: 52.0204,
    x2: 16.74,
    y2: 59.8715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2_901",
    x1: 21.2276,
    y1: 52.0899,
    x2: 16.8015,
    y2: 59.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2_901",
    x1: 21.2221,
    y1: 52.1635,
    x2: 16.8513,
    y2: 59.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2_901",
    x1: 21.2325,
    y1: 52.2333,
    x2: 16.9131,
    y2: 59.8127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2_901",
    x1: 21.2426,
    y1: 52.3068,
    x2: 16.9745,
    y2: 59.7956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2_901",
    x1: 21.2452,
    y1: 52.3803,
    x2: 17.0286,
    y2: 59.7745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2_901",
    x1: 21.2437,
    y1: 52.4497,
    x2: 17.0825,
    y2: 59.7538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2_901",
    x1: 21.2501,
    y1: 52.5236,
    x2: 17.1402,
    y2: 59.7371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2_901",
    x1: 21.2527,
    y1: 52.5932,
    x2: 17.1941,
    y2: 59.7162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2_901",
    x1: 14.5027,
    y1: 62.2757,
    x2: 22.7048,
    y2: 55.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5851 57.6227) rotate(180) scale(6.0314 6.55459)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6B1D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#421232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1F0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2_901",
    x1: 77.0615,
    y1: 53.4198,
    x2: 96.7404,
    y2: 84.7815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2C1357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#574188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#755FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7D66AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5C458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#351F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2A1054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#220446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.912 67.1054) scale(31.9292 34.6988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6B1D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#421232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1F0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.8237 64.5991) scale(18.7188 20.3425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2_901",
    x1: 100.91,
    y1: 83.8089,
    x2: 43.8416,
    y2: 67.3704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2_901",
    x1: 102.259,
    y1: 73.9789,
    x2: 46.1575,
    y2: 96.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2_901",
    x1: 80.0333,
    y1: 56.4988,
    x2: 103.642,
    y2: 103.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2_901",
    x1: 89.0314,
    y1: 98.3861,
    x2: 92.0912,
    y2: 97.5446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2_901",
    x1: 90.1957,
    y1: 98.7092,
    x2: 87.0539,
    y2: 96.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2_901",
    x1: 91.5634,
    y1: 58.3428,
    x2: 89.7874,
    y2: 61.4931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2_901",
    x1: 35.7438,
    y1: 47.9489,
    x2: 26.3225,
    y2: 64.4728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2_901",
    x1: 36.0768,
    y1: 48.194,
    x2: 26.677,
    y2: 64.6785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2_901",
    x1: 36.4177,
    y1: 48.4394,
    x2: 27.0434,
    y2: 64.8848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2_901",
    x1: 36.7548,
    y1: 48.6848,
    x2: 27.4059,
    y2: 65.0912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2_901",
    x1: 37.0919,
    y1: 48.9302,
    x2: 27.7644,
    y2: 65.2972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2_901",
    x1: 37.4327,
    y1: 49.1756,
    x2: 28.1267,
    y2: 65.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2_901",
    x1: 37.7657,
    y1: 49.4208,
    x2: 28.4812,
    y2: 65.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2_901",
    x1: 38.1066,
    y1: 49.6621,
    x2: 28.8434,
    y2: 65.9149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2_901",
    x1: 38.4437,
    y1: 49.9073,
    x2: 29.2061,
    y2: 66.1168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2_901",
    x1: 38.7808,
    y1: 50.1526,
    x2: 29.5646,
    y2: 66.3227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2_901",
    x1: 39.1257,
    y1: 50.3981,
    x2: 29.9309,
    y2: 66.5287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2_901",
    x1: 52.7305,
    y1: 36.0823,
    x2: 17.9801,
    y2: 76.9389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A1BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A205C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6986 59.9944) rotate(180) scale(9.08285 9.87072)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6B1D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#421232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1F0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2_901",
    x1: -410.153,
    y1: -237.29,
    x2: -431.07,
    y2: -262.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2_901",
    x1: 85.7969,
    y1: 62.2104,
    x2: 86.4811,
    y2: 61.1273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FEB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2_901",
    x1: 84.09,
    y1: 61.1716,
    x2: 84.778,
    y2: 60.0931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2_901",
    x1: 82.3557,
    y1: 60.1086,
    x2: 83.0436,
    y2: 59.0301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2_901",
    x1: 87.4907,
    y1: 91.6793,
    x2: 84.851,
    y2: 73.8366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A1BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A205C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2_901",
    x1: 95.9885,
    y1: 94.4638,
    x2: 91.9105,
    y2: 76.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A1BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A205C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2_901",
    x1: 87.2951,
    y1: 67.9757,
    x2: 91.5033,
    y2: 75.3582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2_901",
    x1: 87.2789,
    y1: 68.041,
    x2: 91.436,
    y2: 75.3413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2_901",
    x1: 87.2746,
    y1: 68.1066,
    x2: 91.3887,
    y2: 75.3239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2_901",
    x1: 87.2781,
    y1: 68.1719,
    x2: 91.3411,
    y2: 75.3069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2_901",
    x1: 87.2619,
    y1: 68.2415,
    x2: 91.2777,
    y2: 75.2897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2_901",
    x1: 87.2613,
    y1: 68.3067,
    x2: 91.23,
    y2: 75.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2_901",
    x1: 87.2532,
    y1: 68.3724,
    x2: 91.1748,
    y2: 75.2512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2_901",
    x1: 87.2564,
    y1: 68.4377,
    x2: 91.1309,
    y2: 75.2338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2_901",
    x1: 87.2558,
    y1: 68.5032,
    x2: 91.0833,
    y2: 75.2167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2_901",
    x1: 87.2515,
    y1: 68.5684,
    x2: 91.0279,
    y2: 75.1997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2_901",
    x1: 87.2431,
    y1: 68.6382,
    x2: 90.9724,
    y2: 75.1827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2_901",
    x1: 93.4513,
    y1: 77.5315,
    x2: 85.9149,
    y2: 71.3874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.7001 73.2546) scale(5.54227 6.02302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6B1D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#421232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1F0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2_901",
    x1: 67.1196,
    y1: 56.8096,
    x2: 84.7735,
    y2: 87.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2_901",
    x1: 66.9587,
    y1: 56.8996,
    x2: 84.5658,
    y2: 87.7957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2_901",
    x1: 66.8019,
    y1: 56.9895,
    x2: 84.3662,
    y2: 87.8109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2_901",
    x1: 66.6332,
    y1: 57.0794,
    x2: 84.1547,
    y2: 87.8261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2_901",
    x1: 66.4726,
    y1: 57.1735,
    x2: 83.9513,
    y2: 87.8412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2_901",
    x1: 66.3077,
    y1: 57.2637,
    x2: 83.7394,
    y2: 87.8529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2_901",
    x1: 66.143,
    y1: 57.3534,
    x2: 83.532,
    y2: 87.8679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2_901",
    x1: 65.99,
    y1: 57.4436,
    x2: 83.3362,
    y2: 87.8833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2_901",
    x1: 65.8331,
    y1: 57.5335,
    x2: 83.1365,
    y2: 87.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2_901",
    x1: 65.676,
    y1: 57.6232,
    x2: 82.9366,
    y2: 87.9093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2_901",
    x1: 65.5114,
    y1: 57.7094,
    x2: 82.7292,
    y2: 87.9207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2_901",
    x1: 68.1753,
    y1: 67.9356,
    x2: 81.8944,
    y2: 89.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2C1357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#574188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#755FA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7D66AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5C458C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442E74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#351F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2A1054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#220446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.0475 77.2258) scale(22.7899 24.7668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6B1D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#421232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1F0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.2372 75.4553) scale(13.4249 14.5894)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2_901",
    x1: 84.3145,
    y1: 89.0183,
    x2: 46.682,
    y2: 78.1786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2_901",
    x1: 84.7943,
    y1: 104.626,
    x2: 63.2496,
    y2: 62.7319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2_901",
    x1: 70.9844,
    y1: 86.4952,
    x2: 82.8214,
    y2: 86.4952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2_901",
    x1: 69.6402,
    y1: 71.4604,
    x2: 90.1123,
    y2: 107.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2_901",
    x1: -431.272,
    y1: -236.308,
    x2: -445.969,
    y2: -253.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2_901",
    x1: 74.5411,
    y1: 72.3351,
    x2: 75.0634,
    y2: 71.5186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FFA98C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FEB892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FEE0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEECA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2_901",
    x1: 73.2443,
    y1: 71.55,
    x2: 73.7627,
    y2: 70.7288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2_901",
    x1: 71.9318,
    y1: 70.7443,
    x2: 72.4502,
    y2: 69.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1EC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2_901",
    x1: 78.5313,
    y1: 100.054,
    x2: 75.9799,
    y2: 82.4576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A1BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A205C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2_901",
    x1: 74.5058,
    y1: 75.6921,
    x2: 78.188,
    y2: 82.1539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2_901",
    x1: 74.4977,
    y1: 75.7495,
    x2: 78.1413,
    y2: 82.1403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2_901",
    x1: 74.4971,
    y1: 75.8107,
    x2: 78.0978,
    y2: 82.1226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2_901",
    x1: 74.4849,
    y1: 75.8679,
    x2: 78.0431,
    y2: 82.1091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2_901",
    x1: 74.4806,
    y1: 75.9251,
    x2: 77.996,
    y2: 82.0917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2_901",
    x1: 74.4841,
    y1: 75.9823,
    x2: 77.9568,
    y2: 82.0783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2_901",
    x1: 74.4798,
    y1: 76.0396,
    x2: 77.9097,
    y2: 82.0607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2_901",
    x1: 74.4832,
    y1: 76.1009,
    x2: 77.8704,
    y2: 82.0473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2_901",
    x1: 74.4827,
    y1: 76.1584,
    x2: 77.8311,
    y2: 82.0296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2_901",
    x1: 74.4705,
    y1: 76.2152,
    x2: 77.7764,
    y2: 82.0158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2_901",
    x1: 74.4662,
    y1: 76.2727,
    x2: 77.7293,
    y2: 81.9985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2_901",
    x1: 79.8921,
    y1: 84.0582,
    x2: 73.2959,
    y2: 78.6828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#AE24B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D643BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63CE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.6111 80.3128) scale(4.84995 5.27065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6B1D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#421232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1F0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2_901",
    x1: 70.7535,
    y1: 84.9334,
    x2: 78.9518,
    y2: 99.3168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2_901",
    x1: 70.3976,
    y1: 85.1827,
    x2: 78.5703,
    y2: 99.5229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2_901",
    x1: 70.073,
    y1: 85.4281,
    x2: 78.2242,
    y2: 99.7288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2_901",
    x1: 69.7286,
    y1: 85.6735,
    x2: 77.8585,
    y2: 99.9348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2_901",
    x1: 69.3884,
    y1: 85.9187,
    x2: 77.4967,
    y2: 100.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2_901",
    x1: 69.0556,
    y1: 86.164,
    x2: 77.1385,
    y2: 100.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2_901",
    x1: 68.7153,
    y1: 86.4053,
    x2: 76.7769,
    y2: 100.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2_901",
    x1: 68.3751,
    y1: 86.6508,
    x2: 76.4151,
    y2: 100.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2_901",
    x1: 68.0423,
    y1: 86.8959,
    x2: 76.0569,
    y2: 100.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2_901",
    x1: 67.7099,
    y1: 87.1415,
    x2: 75.7029,
    y2: 101.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2_901",
    x1: 67.3655,
    y1: 87.3867,
    x2: 75.3372,
    y2: 101.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2_901",
    x1: 55.143,
    y1: 74.4289,
    x2: 85.9814,
    y2: 110.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6B24D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A1BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#A205C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#AD00BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_2_901",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.9174 96.4726) scale(9.08285 9.87072)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6B1D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#421232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1F0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.ab4a1bf9d3df0b77d95bddf9fb1b8f80.svg";
export { ForwardRef as ReactComponent };